import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type AddUserApprovalInput = {
  anchorRef: Scalars['String']['input'];
  approval: Approval;
  message: Scalars['String']['input'];
};

export type AddUserCommentInput = {
  anchorRef: Scalars['String']['input'];
  message: Scalars['String']['input'];
};

export enum Approval {
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED',
  Warning = 'WARNING'
}

export type CreateEnginePresetInput = {
  assumedCustomerGrowth?: InputMaybe<Scalars['Float']['input']>;
  auroraNextProductionRun?: InputMaybe<Scalars['String']['input']>;
  bindToForecastUpload?: InputMaybe<Scalars['Boolean']['input']>;
  bindToSKUOverrides?: InputMaybe<Scalars['Boolean']['input']>;
  cnpNextProductionRun?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  cutYieldLoss?: InputMaybe<Scalars['Float']['input']>;
  darkRoastRuntime?: InputMaybe<Scalars['Float']['input']>;
  decafChangeoverTime?: InputMaybe<Scalars['Float']['input']>;
  default: Scalars['Boolean']['input'];
  defaultChangeoverTime?: InputMaybe<Scalars['Float']['input']>;
  description: Scalars['String']['input'];
  desiredMinWeeksOnHand?: InputMaybe<Scalars['Int']['input']>;
  dyeYieldLoss?: InputMaybe<Scalars['Float']['input']>;
  excludeForecast?: InputMaybe<Scalars['Boolean']['input']>;
  excludeYieldPlan?: InputMaybe<Scalars['Boolean']['input']>;
  firmWindowLookAhead?: InputMaybe<Scalars['Int']['input']>;
  historicalDatePatterns?: InputMaybe<Scalars['Boolean']['input']>;
  leadTimeInWeeks?: InputMaybe<Scalars['Int']['input']>;
  lightRoastRuntime?: InputMaybe<Scalars['Float']['input']>;
  mediumRoastRuntime?: InputMaybe<Scalars['Float']['input']>;
  modifyExistingPos?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  onHoldToAvailableDays?: InputMaybe<Scalars['Int']['input']>;
  orderSimulationEndDate?: InputMaybe<Scalars['String']['input']>;
  orderToDeliveryDaysOffset?: InputMaybe<Scalars['Int']['input']>;
  organicMillingNextProductionRun?: InputMaybe<Scalars['String']['input']>;
  productionStartToEndDays?: InputMaybe<Scalars['Int']['input']>;
  sewYieldLoss?: InputMaybe<Scalars['Float']['input']>;
  taraNextProductionRun?: InputMaybe<Scalars['String']['input']>;
  trendLookbackWindow?: InputMaybe<Scalars['Int']['input']>;
  truckOrderToPackDays?: InputMaybe<Scalars['Int']['input']>;
  turnOnProductionBatching?: InputMaybe<Scalars['Boolean']['input']>;
  useBufferForecast?: InputMaybe<Scalars['Boolean']['input']>;
  weeksOfSupply?: InputMaybe<Scalars['Int']['input']>;
  weightingMethod?: InputMaybe<Scalars['String']['input']>;
  weightingWindowDays?: InputMaybe<Scalars['Int']['input']>;
};

export type CreatePowerBiInput = {
  customerId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};

export type Customer = {
  __typename?: 'Customer';
  defaultRole?: Maybe<Scalars['String']['output']>;
  ej2License?: Maybe<Scalars['String']['output']>;
  emailDomains?: Maybe<Array<Scalars['String']['output']>>;
  features?: Maybe<Features>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  powerBi?: Maybe<Array<PowerBi>>;
};

export type EnginePreset = {
  __typename?: 'EnginePreset';
  assumedCustomerGrowth?: Maybe<Scalars['Float']['output']>;
  auroraNextProductionRun?: Maybe<Scalars['String']['output']>;
  bindToForecastUpload?: Maybe<Scalars['Boolean']['output']>;
  bindToSKUOverrides?: Maybe<Scalars['Boolean']['output']>;
  cnpNextProductionRun?: Maybe<Scalars['String']['output']>;
  cutYieldLoss?: Maybe<Scalars['Float']['output']>;
  darkRoastRuntime?: Maybe<Scalars['Float']['output']>;
  decafChangeoverTime?: Maybe<Scalars['Float']['output']>;
  default: Scalars['Boolean']['output'];
  defaultChangeoverTime?: Maybe<Scalars['Float']['output']>;
  description: Scalars['String']['output'];
  desiredMinWeeksOnHand?: Maybe<Scalars['Int']['output']>;
  dyeYieldLoss?: Maybe<Scalars['Float']['output']>;
  excludeForecast?: Maybe<Scalars['Boolean']['output']>;
  excludeYieldPlan?: Maybe<Scalars['Boolean']['output']>;
  firmWindowLookAhead?: Maybe<Scalars['Int']['output']>;
  historicalDatePatterns?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  leadTimeInWeeks?: Maybe<Scalars['Int']['output']>;
  lightRoastRuntime?: Maybe<Scalars['Float']['output']>;
  mediumRoastRuntime?: Maybe<Scalars['Float']['output']>;
  modifyExistingPos?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  onHoldToAvailableDays?: Maybe<Scalars['Int']['output']>;
  orderSimulationEndDate?: Maybe<Scalars['String']['output']>;
  orderToDeliveryDaysOffset?: Maybe<Scalars['Int']['output']>;
  organicMillingNextProductionRun?: Maybe<Scalars['String']['output']>;
  productionStartToEndDays?: Maybe<Scalars['Int']['output']>;
  sewYieldLoss?: Maybe<Scalars['Float']['output']>;
  taraNextProductionRun?: Maybe<Scalars['String']['output']>;
  trendLookbackWindow?: Maybe<Scalars['Int']['output']>;
  truckOrderToPackDays?: Maybe<Scalars['Int']['output']>;
  turnOnProductionBatching?: Maybe<Scalars['Boolean']['output']>;
  useBufferForecast?: Maybe<Scalars['Boolean']['output']>;
  weeksOfSupply?: Maybe<Scalars['Int']['output']>;
  weightingMethod?: Maybe<Scalars['String']['output']>;
  weightingWindowDays?: Maybe<Scalars['Int']['output']>;
};

export type FeatureFlagsInput = {
  DarkMode: Role;
  EngineLegacyDatabase: Role;
  EngineLoadLockedDemandForecast: Role;
  EnginePresets: Role;
  EngineRunHistory: Role;
  EngineRuns: Role;
  ForecastAccuracy: Role;
  InventoryOnHand: Role;
  InventoryOnHandBeans: Role;
  InventoryOnHandForecast: Role;
  InventoryOnHandInStockRate: Role;
  InventoryOnHandInStockTreshold: Role;
  PoInbox: Role;
  RunComparison: Role;
  SkuHierarchyProductCategory: Role;
  SkuHierarchyProductFamily: Role;
  SkuHierarchyProductTitle: Role;
  SkuHierarchyProductType: Role;
  StepsExperimentalEngineWorkflow: Role;
  StepsRunDetails: Role;
  StepsStepDetails: Role;
  StepsUsedForEngineRuns: Role;
  StepsVariableSets: Role;
  ValidationDashboard: Role;
  VarAauroraNextProductionRun: Role;
  VarAssumedCustomerGrowth: Role;
  VarBindToForecastUpload: Role;
  VarBindToSKUOverrides: Role;
  VarCnpNextProductionRun: Role;
  VarCutYieldLoss: Role;
  VarDarkRoastRuntime: Role;
  VarDecafChangeoverTime: Role;
  VarDefaultChangeoverTime: Role;
  VarDesiredMinWeeksOnHand: Role;
  VarDyeYieldLoss: Role;
  VarExcludeForecast: Role;
  VarExcludeYieldPlan: Role;
  VarFirmWindowLookAhead: Role;
  VarHistoricalDatePatterns: Role;
  VarLeadTimeInWeeks: Role;
  VarLightRoastRuntime: Role;
  VarMediumRoastRuntime: Role;
  VarModifyExistingPos: Role;
  VarOnHoldToAvailableDays: Role;
  VarOrderSimulationEndDate: Role;
  VarOrderToDeliveryDaysOffset: Role;
  VarOrganicMillingNextProductionRun: Role;
  VarProductionStartToEndDays: Role;
  VarSewYieldLoss: Role;
  VarTaraNextProductionRun: Role;
  VarTrendLookbackWindow: Role;
  VarTruckOrderToPackDays: Role;
  VarTurnOnProductionBatching: Role;
  VarUseBufferForecast: Role;
  VarWeeksOfSupply: Role;
  VarWeightingMethod: Role;
  VarWeightingWindowDays: Role;
  customerId: Scalars['String']['input'];
};

export type Features = {
  __typename?: 'Features';
  DarkMode: Role;
  EngineLegacyDatabase: Role;
  EngineLoadLockedDemandForecast: Role;
  EnginePresets: Role;
  EngineRunHistory: Role;
  EngineRuns: Role;
  ForecastAccuracy: Role;
  InventoryOnHand: Role;
  InventoryOnHandBeans: Role;
  InventoryOnHandForecast: Role;
  InventoryOnHandInStockRate: Role;
  InventoryOnHandInStockTreshold: Role;
  PoInbox: Role;
  RunComparison: Role;
  SkuHierarchyProductCategory: Role;
  SkuHierarchyProductFamily: Role;
  SkuHierarchyProductTitle: Role;
  SkuHierarchyProductType: Role;
  StepsExperimentalEngineWorkflow: Role;
  StepsRunDetails: Role;
  StepsStepDetails: Role;
  StepsUsedForEngineRuns: Role;
  StepsVariableSets: Role;
  ValidationDashboard: Role;
  VarAauroraNextProductionRun: Role;
  VarAssumedCustomerGrowth: Role;
  VarBindToForecastUpload: Role;
  VarBindToSKUOverrides: Role;
  VarCnpNextProductionRun: Role;
  VarCutYieldLoss: Role;
  VarDarkRoastRuntime: Role;
  VarDecafChangeoverTime: Role;
  VarDefaultChangeoverTime: Role;
  VarDesiredMinWeeksOnHand: Role;
  VarDyeYieldLoss: Role;
  VarExcludeForecast: Role;
  VarExcludeYieldPlan: Role;
  VarFirmWindowLookAhead: Role;
  VarHistoricalDatePatterns: Role;
  VarLeadTimeInWeeks: Role;
  VarLightRoastRuntime: Role;
  VarMediumRoastRuntime: Role;
  VarModifyExistingPos: Role;
  VarOnHoldToAvailableDays: Role;
  VarOrderSimulationEndDate: Role;
  VarOrderToDeliveryDaysOffset: Role;
  VarOrganicMillingNextProductionRun: Role;
  VarProductionStartToEndDays: Role;
  VarSewYieldLoss: Role;
  VarTaraNextProductionRun: Role;
  VarTrendLookbackWindow: Role;
  VarTruckOrderToPackDays: Role;
  VarTurnOnProductionBatching: Role;
  VarUseBufferForecast: Role;
  VarWeeksOfSupply: Role;
  VarWeightingMethod: Role;
  VarWeightingWindowDays: Role;
};

export type GoodChopGrossOdlJobPlanIntKeyValue = {
  __typename?: 'GoodChopGrossOdlJobPlanIntKeyValue';
  dagsterJobName: Scalars['String']['output'];
  jobName: Scalars['String']['output'];
  step: Scalars['Int']['output'];
};

export type GoodChopGrossOdlJobPlanIntKeyValueInput = {
  dagsterJobName: Scalars['String']['input'];
  jobName: Scalars['String']['input'];
  step: Scalars['Int']['input'];
};

export type GoodchopGrossOdlCreateJobPlanResponse = {
  __typename?: 'GoodchopGrossOdlCreateJobPlanResponse';
  jobPlanId: Scalars['String']['output'];
};

export type GoodchopGrossOdlJob = {
  __typename?: 'GoodchopGrossOdlJob';
  dagsterRunId?: Maybe<Scalars['String']['output']>;
  dateCreated: Scalars['String']['output'];
  dateUpdated: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  job: Scalars['String']['output'];
  jobName: Scalars['String']['output'];
  jobPlanId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  runId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  step: Scalars['String']['output'];
};

export type GoodchopGrossOdlJobPlan = {
  __typename?: 'GoodchopGrossOdlJobPlan';
  jobPlan: Array<GoodChopGrossOdlJobPlanIntKeyValue>;
  jobPlanId: Scalars['String']['output'];
};

export type GoodchopGrossOdlPresignDownloadUrlResponse = {
  __typename?: 'GoodchopGrossOdlPresignDownloadUrlResponse';
  presignUrl: Scalars['String']['output'];
};

export type GoodchopGrossOdlPresignUploadUrlResponse = {
  __typename?: 'GoodchopGrossOdlPresignUploadUrlResponse';
  presignUrl: Scalars['String']['output'];
  runId: Scalars['String']['output'];
};

export type GoodchopGrossOdlStartJobResponse = {
  __typename?: 'GoodchopGrossOdlStartJobResponse';
  dagsterRunId: Scalars['String']['output'];
};

export type GoodchopGrossOdlStartUploadValidationResponse = {
  __typename?: 'GoodchopGrossOdlStartUploadValidationResponse';
  runId: Scalars['String']['output'];
};

export type GoodchopOdlTask = {
  __typename?: 'GoodchopOdlTask';
  createdAt: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type GoodchopOdlTaskId = {
  __typename?: 'GoodchopOdlTaskId';
  taskId?: Maybe<Scalars['String']['output']>;
};

export type GoodchopOdlTransformedDataUrls = {
  __typename?: 'GoodchopOdlTransformedDataUrls';
  data: Array<TransformedDataUrl>;
  page: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type InventoryOnHandForecastUrl = {
  __typename?: 'InventoryOnHandForecastUrl';
  id: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type InventoryOnHandUrl = {
  __typename?: 'InventoryOnHandUrl';
  date: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type Location = {
  __typename?: 'Location';
  address?: Maybe<Scalars['String']['output']>;
  address_override?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

export type LocationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  address_override?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

export type Logo = {
  __typename?: 'Logo';
  img_b64?: Maybe<Scalars['String']['output']>;
  logo_name?: Maybe<Scalars['String']['output']>;
};

export type LogoInput = {
  img_b64: Scalars['String']['input'];
  logo_name: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addMyUserApproval?: Maybe<UserApproval>;
  addMyUserComment?: Maybe<UserComment>;
  cancelMyOrchestratorRun?: Maybe<Scalars['String']['output']>;
  createCustomer?: Maybe<Customer>;
  createCustomerEmailDomain?: Maybe<Customer>;
  createEnginePreset?: Maybe<EnginePreset>;
  createMyEnginePreset?: Maybe<EnginePreset>;
  createMyGoodchopGrossOdlJob?: Maybe<Scalars['String']['output']>;
  createMyGoodchopGrossOdlJobPlan?: Maybe<GoodchopGrossOdlCreateJobPlanResponse>;
  createMyGoodchopGrossOdlPresignDownloadUrl?: Maybe<GoodchopGrossOdlPresignDownloadUrlResponse>;
  createMyGoodchopGrossOdlPresignUploadUrl?: Maybe<GoodchopGrossOdlPresignUploadUrlResponse>;
  createMyGoodchopPresignUploadUrl?: Maybe<Scalars['String']['output']>;
  createOrReplaceFeatureFlags?: Maybe<Features>;
  createPowerBi?: Maybe<Customer>;
  deleteCustomerEmailDomain?: Maybe<Customer>;
  generateMyPoPdfWithDownloadUrl?: Maybe<Scalars['String']['output']>;
  importMyPo: PurchaseOrderWithEditAndSkus;
  makeMyEnginePresetDefault?: Maybe<Scalars['String']['output']>;
  replaceEnginePreset?: Maybe<EnginePreset>;
  replaceMyEnginePreset?: Maybe<EnginePreset>;
  replacePowerBi?: Maybe<Customer>;
  rerunMyOrchestratorStep?: Maybe<Scalars['String']['output']>;
  retryMyOrchestratorRun?: Maybe<Scalars['String']['output']>;
  setMyLocation: Location;
  setMyLockedEngineRunId?: Maybe<Scalars['String']['output']>;
  setMyLogo: Logo;
  setMyOrchestratorRunDescription?: Maybe<Scalars['String']['output']>;
  setMyOrchestratorRunLocked?: Maybe<Scalars['String']['output']>;
  setMyOrchestratorRunName?: Maybe<Scalars['String']['output']>;
  setMyVendor: Vendor;
  startMyGoodchopGrossOdlJob?: Maybe<GoodchopGrossOdlStartJobResponse>;
  startMyGoodchopGrossOdlUploadValidation?: Maybe<GoodchopGrossOdlStartUploadValidationResponse>;
  startMyGoodchopOdlTask?: Maybe<GoodchopOdlTaskId>;
  startMyOrchestratorRun?: Maybe<Scalars['String']['output']>;
  storeMyPurchaseOrderEdit: Scalars['String']['output'];
  storeMyPurchaseOrderEditWithSkus: Scalars['String']['output'];
  storeMyPurchaseOrderSkuEdit: Scalars['String']['output'];
  storeMyPurchaseOrderSnoozeAndStatus: Scalars['String']['output'];
  triggerMyOrchestratorRunNextSteps?: Maybe<Scalars['String']['output']>;
  triggerMyorchestratorStartTheEngineScripts?: Maybe<Scalars['String']['output']>;
  updateMyGoodchopGrossOdlJob?: Maybe<Scalars['String']['output']>;
  updateMyRun?: Maybe<RunLog>;
  workflowTrigger?: Maybe<Scalars['String']['output']>;
};


export type MutationAddMyUserApprovalArgs = {
  newApproval: AddUserApprovalInput;
};


export type MutationAddMyUserCommentArgs = {
  newComment: AddUserCommentInput;
};


export type MutationCancelMyOrchestratorRunArgs = {
  runSettings: OrchestratorRunInput;
};


export type MutationCreateCustomerArgs = {
  defaultRole: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateCustomerEmailDomainArgs = {
  customerId: Scalars['String']['input'];
  emailDomain: Scalars['String']['input'];
};


export type MutationCreateEnginePresetArgs = {
  enginePreset: CreateEnginePresetInput;
};


export type MutationCreateMyEnginePresetArgs = {
  enginePreset: CreateEnginePresetInput;
};


export type MutationCreateMyGoodchopGrossOdlJobArgs = {
  fileName: Scalars['String']['input'];
  job: Scalars['String']['input'];
  jobName: Scalars['String']['input'];
  jobPlanId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  runId: Scalars['String']['input'];
  step: Scalars['String']['input'];
};


export type MutationCreateMyGoodchopGrossOdlJobPlanArgs = {
  jobPlan: Array<GoodChopGrossOdlJobPlanIntKeyValueInput>;
  jobPlanId: Scalars['String']['input'];
};


export type MutationCreateMyGoodchopGrossOdlPresignDownloadUrlArgs = {
  filePath: Scalars['String']['input'];
};


export type MutationCreateMyGoodchopGrossOdlPresignUploadUrlArgs = {
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  job: Scalars['String']['input'];
  jobPlanId: Scalars['String']['input'];
};


export type MutationCreateMyGoodchopPresignUploadUrlArgs = {
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};


export type MutationCreateOrReplaceFeatureFlagsArgs = {
  featureFlags: FeatureFlagsInput;
};


export type MutationCreatePowerBiArgs = {
  powerBi: CreatePowerBiInput;
};


export type MutationDeleteCustomerEmailDomainArgs = {
  customerId: Scalars['String']['input'];
  emailDomain: Scalars['String']['input'];
};


export type MutationGenerateMyPoPdfWithDownloadUrlArgs = {
  id: Scalars['String']['input'];
};


export type MutationImportMyPoArgs = {
  id: Scalars['String']['input'];
  runSettings: OrchestratorRunInput;
};


export type MutationMakeMyEnginePresetDefaultArgs = {
  enginePresetId: Scalars['Int']['input'];
};


export type MutationReplaceEnginePresetArgs = {
  enginePreset: ReplaceEnginePresetInput;
};


export type MutationReplaceMyEnginePresetArgs = {
  enginePreset: ReplaceEnginePresetInput;
};


export type MutationReplacePowerBiArgs = {
  powerBi: ReplacePowerBiInput;
};


export type MutationRerunMyOrchestratorStepArgs = {
  runSettings: OrchestratorRunSettingsInput;
  stepId: Scalars['String']['input'];
};


export type MutationRetryMyOrchestratorRunArgs = {
  runSettings: OrchestratorRunInput;
};


export type MutationSetMyLocationArgs = {
  location: LocationInput;
};


export type MutationSetMyLockedEngineRunIdArgs = {
  engineRunId: Scalars['Int']['input'];
};


export type MutationSetMyLogoArgs = {
  logo: LogoInput;
};


export type MutationSetMyOrchestratorRunDescriptionArgs = {
  description: Scalars['String']['input'];
  runSettings: OrchestratorRunSettingsInput;
};


export type MutationSetMyOrchestratorRunLockedArgs = {
  locked: Scalars['Boolean']['input'];
  runSettings: OrchestratorRunSettingsInput;
};


export type MutationSetMyOrchestratorRunNameArgs = {
  name: Scalars['String']['input'];
  runSettings: OrchestratorRunSettingsInput;
};


export type MutationSetMyVendorArgs = {
  vendor: VendorInput;
};


export type MutationStartMyGoodchopGrossOdlJobArgs = {
  job: Scalars['String']['input'];
  jobPlanId: Scalars['String']['input'];
  runId: Scalars['String']['input'];
};


export type MutationStartMyGoodchopGrossOdlUploadValidationArgs = {
  fileName: Scalars['String']['input'];
  job: Scalars['String']['input'];
  jobPlanId: Scalars['String']['input'];
  runId: Scalars['String']['input'];
};


export type MutationStartMyGoodchopOdlTaskArgs = {
  fileName: Scalars['String']['input'];
};


export type MutationStartMyOrchestratorRunArgs = {
  runSettings: OrchestratorRunTriggerInput;
};


export type MutationStoreMyPurchaseOrderEditArgs = {
  edit: PurchaseOrderEditInput;
};


export type MutationStoreMyPurchaseOrderEditWithSkusArgs = {
  edit: PurchaseOrderEditSkusInput;
};


export type MutationStoreMyPurchaseOrderSkuEditArgs = {
  edit: PurchaseOrderSkuEditInput;
};


export type MutationStoreMyPurchaseOrderSnoozeAndStatusArgs = {
  edit: PurchaseOrderSkuSnoozeAndStatus;
};


export type MutationTriggerMyOrchestratorRunNextStepsArgs = {
  runSettings: OrchestratorRunInput;
};


export type MutationTriggerMyorchestratorStartTheEngineScriptsArgs = {
  loadDemandOfRunId?: InputMaybe<Scalars['String']['input']>;
  variablesId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateMyGoodchopGrossOdlJobArgs = {
  dagsterRunId: Scalars['String']['input'];
  runId: Scalars['String']['input'];
};


export type MutationUpdateMyRunArgs = {
  run: UpdateMyRunInput;
};


export type MutationWorkflowTriggerArgs = {
  engineVariables?: InputMaybe<WorkflowTriggerEngineVariables>;
};

export type MyCustomer = {
  __typename?: 'MyCustomer';
  ej2License?: Maybe<Scalars['String']['output']>;
  features?: Maybe<MyFeatures>;
  id: Scalars['String']['output'];
  muiLicense?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  powerBi?: Maybe<Array<PowerBi>>;
};

export type MyFeatures = {
  __typename?: 'MyFeatures';
  DarkMode?: Maybe<Scalars['Boolean']['output']>;
  EngineLegacyDatabase?: Maybe<Scalars['Boolean']['output']>;
  EngineLoadLockedDemandForecast?: Maybe<Scalars['Boolean']['output']>;
  EnginePresets?: Maybe<Scalars['Boolean']['output']>;
  EngineRunHistory?: Maybe<Scalars['Boolean']['output']>;
  EngineRuns?: Maybe<Scalars['Boolean']['output']>;
  ForecastAccuracy?: Maybe<Scalars['Boolean']['output']>;
  InventoryOnHand?: Maybe<Scalars['Boolean']['output']>;
  InventoryOnHandBeans?: Maybe<Scalars['Boolean']['output']>;
  InventoryOnHandForecast?: Maybe<Scalars['Boolean']['output']>;
  InventoryOnHandInStockRate?: Maybe<Scalars['Boolean']['output']>;
  InventoryOnHandInStockTreshold?: Maybe<Scalars['Boolean']['output']>;
  PoInbox?: Maybe<Scalars['Boolean']['output']>;
  RunComparison?: Maybe<Scalars['Boolean']['output']>;
  SkuHierarchyProductCategory?: Maybe<Scalars['Boolean']['output']>;
  SkuHierarchyProductFamily?: Maybe<Scalars['Boolean']['output']>;
  SkuHierarchyProductTitle?: Maybe<Scalars['Boolean']['output']>;
  SkuHierarchyProductType?: Maybe<Scalars['Boolean']['output']>;
  StepsExperimentalEngineWorkflow?: Maybe<Scalars['Boolean']['output']>;
  StepsRunDetails?: Maybe<Scalars['Boolean']['output']>;
  StepsStepDetails?: Maybe<Scalars['Boolean']['output']>;
  StepsUsedForEngineRuns?: Maybe<Scalars['Boolean']['output']>;
  StepsVariableSets?: Maybe<Scalars['Boolean']['output']>;
  ValidationDashboard?: Maybe<Scalars['Boolean']['output']>;
  VarAauroraNextProductionRun?: Maybe<Scalars['Boolean']['output']>;
  VarAssumedCustomerGrowth?: Maybe<Scalars['Boolean']['output']>;
  VarBindToForecastUpload?: Maybe<Scalars['Boolean']['output']>;
  VarBindToSKUOverrides?: Maybe<Scalars['Boolean']['output']>;
  VarCnpNextProductionRun?: Maybe<Scalars['Boolean']['output']>;
  VarCutYieldLoss?: Maybe<Scalars['Boolean']['output']>;
  VarDarkRoastRuntime?: Maybe<Scalars['Boolean']['output']>;
  VarDecafChangeoverTime?: Maybe<Scalars['Boolean']['output']>;
  VarDefaultChangeoverTime?: Maybe<Scalars['Boolean']['output']>;
  VarDesiredMinWeeksOnHand?: Maybe<Scalars['Boolean']['output']>;
  VarDyeYieldLoss?: Maybe<Scalars['Boolean']['output']>;
  VarExcludeForecast?: Maybe<Scalars['Boolean']['output']>;
  VarExcludeYieldPlan?: Maybe<Scalars['Boolean']['output']>;
  VarFirmWindowLookAhead?: Maybe<Scalars['Boolean']['output']>;
  VarHistoricalDatePatterns?: Maybe<Scalars['Boolean']['output']>;
  VarLeadTimeInWeeks?: Maybe<Scalars['Boolean']['output']>;
  VarLightRoastRuntime?: Maybe<Scalars['Boolean']['output']>;
  VarMediumRoastRuntime?: Maybe<Scalars['Boolean']['output']>;
  VarModifyExistingPos?: Maybe<Scalars['Boolean']['output']>;
  VarOnHoldToAvailableDays?: Maybe<Scalars['Boolean']['output']>;
  VarOrderSimulationEndDate?: Maybe<Scalars['Boolean']['output']>;
  VarOrderToDeliveryDaysOffset?: Maybe<Scalars['Boolean']['output']>;
  VarOrganicMillingNextProductionRun?: Maybe<Scalars['Boolean']['output']>;
  VarProductionStartToEndDays?: Maybe<Scalars['Boolean']['output']>;
  VarSewYieldLoss?: Maybe<Scalars['Boolean']['output']>;
  VarTaraNextProductionRun?: Maybe<Scalars['Boolean']['output']>;
  VarTrendLookbackWindow?: Maybe<Scalars['Boolean']['output']>;
  VarTruckOrderToPackDays?: Maybe<Scalars['Boolean']['output']>;
  VarTurnOnProductionBatching?: Maybe<Scalars['Boolean']['output']>;
  VarUseBufferForecast?: Maybe<Scalars['Boolean']['output']>;
  VarWeeksOfSupply?: Maybe<Scalars['Boolean']['output']>;
  VarWeightingMethod?: Maybe<Scalars['Boolean']['output']>;
  VarWeightingWindowDays?: Maybe<Scalars['Boolean']['output']>;
};

export type OrchestratorRun = {
  __typename?: 'OrchestratorRun';
  createdAt: Scalars['String']['output'];
  customerId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  initiatedBy?: Maybe<Scalars['String']['output']>;
  locked?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  oldLockedRunId?: Maybe<Scalars['String']['output']>;
  oldRunId?: Maybe<Scalars['Int']['output']>;
  runParamsJson?: Maybe<Scalars['String']['output']>;
  runSettings: OrchestratorRunSettings;
  status: OrchestratorRunStatus;
  stepIds?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  usesLockedInputId?: Maybe<Scalars['String']['output']>;
  usesLockedVariablesId?: Maybe<Scalars['String']['output']>;
};

export type OrchestratorRunInput = {
  inputId: Scalars['String']['input'];
  runAttemptId: Scalars['Int']['input'];
  variablesId: Scalars['String']['input'];
  workflowId: Scalars['String']['input'];
};

export type OrchestratorRunSettings = {
  __typename?: 'OrchestratorRunSettings';
  inputId: Scalars['String']['output'];
  runAttemptId: Scalars['Int']['output'];
  variablesId: Scalars['String']['output'];
  workflowId: Scalars['String']['output'];
};

export type OrchestratorRunSettingsInput = {
  inputId: Scalars['String']['input'];
  runAttemptId: Scalars['Int']['input'];
  variablesId: Scalars['String']['input'];
  workflowId: Scalars['String']['input'];
};

export enum OrchestratorRunStatus {
  CancelCompleted = 'CANCEL_COMPLETED',
  CancelFailed = 'CANCEL_FAILED',
  CancelInProgress = 'CANCEL_IN_PROGRESS',
  RunCompleted = 'RUN_COMPLETED',
  RunFailed = 'RUN_FAILED',
  RunInProgress = 'RUN_IN_PROGRESS',
  ToRun = 'TO_RUN'
}

export type OrchestratorRunTriggerInput = {
  inputId: Scalars['String']['input'];
  runAttemptId: Scalars['Int']['input'];
  useLockedOutputs: Scalars['Boolean']['input'];
  variablesId: Scalars['String']['input'];
  workflowId: Scalars['String']['input'];
};

export type OrchestratorStep = {
  __typename?: 'OrchestratorStep';
  createdAt: Scalars['String']['output'];
  runSettings: OrchestratorRunSettings;
  status: OrchestratorStepStatus;
  stepId: Scalars['String']['output'];
};

export enum OrchestratorStepStatus {
  ExecutionCompleted = 'EXECUTION_COMPLETED',
  ExecutionFailed = 'EXECUTION_FAILED',
  ExecutionQueued = 'EXECUTION_QUEUED',
  ExecutionStarted = 'EXECUTION_STARTED',
  ToExecute = 'TO_EXECUTE'
}

export type PowerBi = {
  __typename?: 'PowerBi';
  datasetId?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
};

export type PowerBiReport = {
  __typename?: 'PowerBiReport';
  embedUrl: Scalars['String']['output'];
  pages: Array<PowerBiReportPages>;
  reportId: Scalars['String']['output'];
  reportName: Scalars['String']['output'];
};

export type PowerBiReportItems = {
  __typename?: 'PowerBiReportItems';
  embedToken: Scalars['String']['output'];
  embedTokenExpiration: Scalars['String']['output'];
  embedTokenId: Scalars['String']['output'];
  reports: Array<PowerBiReport>;
};

export type PowerBiReportPages = {
  __typename?: 'PowerBiReportPages';
  order: Scalars['Int']['output'];
  pageId: Scalars['String']['output'];
  pageName: Scalars['String']['output'];
};

export type PurchaseOrder = {
  __typename?: 'PurchaseOrder';
  created_at?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  location: Scalars['String']['output'];
  po_sim_id: Scalars['String']['output'];
  run_settings?: Maybe<OrchestratorRunSettings>;
  snooze_end_date?: Maybe<Scalars['String']['output']>;
  snooze_start_date?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PurchaseOrderStatus>;
  total_cogs?: Maybe<Scalars['Float']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
  vendor: Scalars['String']['output'];
};

export type PurchaseOrderEdit = {
  __typename?: 'PurchaseOrderEdit';
  created_at?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  location_address?: Maybe<Scalars['String']['output']>;
  location_email?: Maybe<Scalars['String']['output']>;
  need_by_date?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  po_id: Scalars['String']['output'];
  ship_by_date?: Maybe<Scalars['String']['output']>;
  vendor_address?: Maybe<Scalars['String']['output']>;
  vendor_email?: Maybe<Scalars['String']['output']>;
};

export type PurchaseOrderEditInput = {
  edit_date: Scalars['String']['input'];
  location_address?: InputMaybe<Scalars['String']['input']>;
  location_email?: InputMaybe<Scalars['String']['input']>;
  need_by_date: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  po_id: Scalars['String']['input'];
  ship_by_date: Scalars['String']['input'];
  vendor_address?: InputMaybe<Scalars['String']['input']>;
  vendor_email?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseOrderEditSkusDetailsInput = {
  quantity?: InputMaybe<Scalars['String']['input']>;
  sku: Scalars['String']['input'];
  unit: Scalars['String']['input'];
  unit_cost?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseOrderEditSkusInput = {
  edit_date: Scalars['String']['input'];
  location_address?: InputMaybe<Scalars['String']['input']>;
  location_email?: InputMaybe<Scalars['String']['input']>;
  need_by_date: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  po_id: Scalars['String']['input'];
  ship_by_date: Scalars['String']['input'];
  skus: Array<PurchaseOrderEditSkusDetailsInput>;
  vendor_address?: InputMaybe<Scalars['String']['input']>;
  vendor_email?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseOrderSku = {
  __typename?: 'PurchaseOrderSku';
  created_at?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  po_id: Scalars['String']['output'];
  quantity?: Maybe<Scalars['String']['output']>;
  sku: Scalars['String']['output'];
  unit: Scalars['String']['output'];
  unit_cost?: Maybe<Scalars['String']['output']>;
};

export type PurchaseOrderSkuEditInput = {
  edit_date: Scalars['String']['input'];
  po_id: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['String']['input']>;
  sku: Scalars['String']['input'];
  unit: Scalars['String']['input'];
  unit_cost?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseOrderSkuSnoozeAndStatus = {
  end_date?: InputMaybe<Scalars['String']['input']>;
  po_id: Scalars['String']['input'];
  start_date?: InputMaybe<Scalars['String']['input']>;
  status: PurchaseOrderStatus;
};

export enum PurchaseOrderStatus {
  AtomicSuggestion = 'ATOMIC_SUGGESTION',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  CustomerOwned = 'CUSTOMER_OWNED'
}

export type PurchaseOrderWithEditAndSkus = {
  __typename?: 'PurchaseOrderWithEditAndSkus';
  id: Scalars['String']['output'];
  pe?: Maybe<PurchaseOrderEdit>;
  po: PurchaseOrder;
  ps?: Maybe<Array<PurchaseOrderSku>>;
};

export type Query = {
  __typename?: 'Query';
  getAllCustomers: Array<Customer>;
  getCustomer?: Maybe<Customer>;
  getEnginePresets: Array<EnginePreset>;
  getGoodchopHelloWorld?: Maybe<Scalars['String']['output']>;
  getLatestOrchestratorRuns: Array<OrchestratorRun>;
  getMyCustomer?: Maybe<MyCustomer>;
  getMyDemandMonthlyDiffUrl?: Maybe<Scalars['String']['output']>;
  getMyDemandMonthlyUrl?: Maybe<Scalars['String']['output']>;
  getMyDemandWeeklyUrl?: Maybe<Scalars['String']['output']>;
  getMyEnginePresets: Array<EnginePreset>;
  getMyForecastAccuracyUrl?: Maybe<Scalars['String']['output']>;
  getMyGoodchopGrossOdlJobPlans?: Maybe<Array<GoodchopGrossOdlJobPlan>>;
  getMyGoodchopGrossOdlJobs?: Maybe<Array<Maybe<GoodchopGrossOdlJob>>>;
  getMyGoodchopGrossOdlSingleJob?: Maybe<GoodchopGrossOdlJob>;
  getMyGoodchopGrossOdlSingleJobPlan?: Maybe<GoodchopGrossOdlJobPlan>;
  getMyGoodchopOdlTask?: Maybe<GoodchopOdlTask>;
  getMyGoodchopOdlTransformedDataUrls?: Maybe<GoodchopOdlTransformedDataUrls>;
  getMyInventoryOnHandBeansUrls: Array<InventoryOnHandUrl>;
  getMyInventoryOnHandForecastUrls: Array<InventoryOnHandForecastUrl>;
  getMyInventoryOnHandUrls: Array<InventoryOnHandUrl>;
  getMyLocations: Array<Location>;
  getMyLockedDemandOutputRunIds: Array<Scalars['Int']['output']>;
  getMyLockedEngineRunId?: Maybe<Scalars['Int']['output']>;
  getMyLogo?: Maybe<Logo>;
  getMyOrchestratorRuns: Array<OrchestratorRun>;
  getMyOrchestratorSteps?: Maybe<Array<OrchestratorStep>>;
  getMyPoEdits: Array<PurchaseOrderEdit>;
  getMyPoSkuEdits: Array<PurchaseOrderSku>;
  getMyPoWithLatestEditAndSkus?: Maybe<PurchaseOrderWithEditAndSkus>;
  getMyPosWithLatestEdits: Array<PurchaseOrderWithEditAndSkus>;
  getMyPowerBiReportItems?: Maybe<PowerBiReportItems>;
  getMyPowerBis: Array<PowerBi>;
  getMyRunComparisonRunIds: Array<Scalars['Int']['output']>;
  getMyRunLogs: Array<RunLog>;
  getMySkuHierarchyUrl?: Maybe<Scalars['String']['output']>;
  getMyUserApprovalsByAnchor: Array<UserApproval>;
  getMyUserCommentsByAnchor: Array<UserComment>;
  getMyVendors: Array<Vendor>;
  getPowerBis: Array<PowerBi>;
  helloWorld?: Maybe<Scalars['String']['output']>;
  whoAmI?: Maybe<User>;
};


export type QueryGetCustomerArgs = {
  customerId: Scalars['String']['input'];
};


export type QueryGetEnginePresetsArgs = {
  customerId: Scalars['String']['input'];
};


export type QueryGetMyDemandMonthlyDiffUrlArgs = {
  engineRunId0: Scalars['Int']['input'];
  engineRunId1: Scalars['Int']['input'];
};


export type QueryGetMyDemandMonthlyUrlArgs = {
  engineRunId: Scalars['Int']['input'];
};


export type QueryGetMyDemandWeeklyUrlArgs = {
  engineRunId: Scalars['Int']['input'];
};


export type QueryGetMyForecastAccuracyUrlArgs = {
  actualsEngineRunId: Scalars['Int']['input'];
  forecastEngineRunId: Scalars['Int']['input'];
  maxDate?: InputMaybe<Scalars['String']['input']>;
  minDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetMyGoodchopGrossOdlSingleJobArgs = {
  dagsterRunId?: InputMaybe<Scalars['String']['input']>;
  runId: Scalars['String']['input'];
};


export type QueryGetMyGoodchopGrossOdlSingleJobPlanArgs = {
  jobPlanId: Scalars['String']['input'];
};


export type QueryGetMyGoodchopOdlTaskArgs = {
  taskId: Scalars['String']['input'];
};


export type QueryGetMyGoodchopOdlTransformedDataUrlsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetMyLocationsArgs = {
  runSettings?: InputMaybe<OrchestratorRunSettingsInput>;
};


export type QueryGetMyOrchestratorRunsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetMyOrchestratorStepsArgs = {
  runSettings: OrchestratorRunSettingsInput;
};


export type QueryGetMyPoEditsArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetMyPoSkuEditsArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetMyPoWithLatestEditAndSkusArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetMyPosWithLatestEditsArgs = {
  include_status: Array<PurchaseOrderStatus>;
  runSettings?: InputMaybe<OrchestratorRunSettingsInput>;
  snoozed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetMyPowerBiReportItemsArgs = {
  workspaceId: Scalars['String']['input'];
};


export type QueryGetMySkuHierarchyUrlArgs = {
  engineRunId: Scalars['Int']['input'];
};


export type QueryGetMyUserApprovalsByAnchorArgs = {
  anchorRefs: Array<Scalars['String']['input']>;
};


export type QueryGetMyUserCommentsByAnchorArgs = {
  anchorRefs: Array<Scalars['String']['input']>;
};


export type QueryGetMyVendorsArgs = {
  runSettings?: InputMaybe<OrchestratorRunSettingsInput>;
};


export type QueryGetPowerBisArgs = {
  customerId: Scalars['String']['input'];
};

export type ReplaceEnginePresetInput = {
  assumedCustomerGrowth?: InputMaybe<Scalars['Float']['input']>;
  auroraNextProductionRun?: InputMaybe<Scalars['String']['input']>;
  bindToForecastUpload?: InputMaybe<Scalars['Boolean']['input']>;
  bindToSKUOverrides?: InputMaybe<Scalars['Boolean']['input']>;
  cnpNextProductionRun?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  cutYieldLoss?: InputMaybe<Scalars['Float']['input']>;
  darkRoastRuntime?: InputMaybe<Scalars['Float']['input']>;
  decafChangeoverTime?: InputMaybe<Scalars['Float']['input']>;
  default: Scalars['Boolean']['input'];
  defaultChangeoverTime?: InputMaybe<Scalars['Float']['input']>;
  description: Scalars['String']['input'];
  desiredMinWeeksOnHand?: InputMaybe<Scalars['Int']['input']>;
  dyeYieldLoss?: InputMaybe<Scalars['Float']['input']>;
  excludeForecast?: InputMaybe<Scalars['Boolean']['input']>;
  excludeYieldPlan?: InputMaybe<Scalars['Boolean']['input']>;
  firmWindowLookAhead?: InputMaybe<Scalars['Int']['input']>;
  historicalDatePatterns?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  leadTimeInWeeks?: InputMaybe<Scalars['Int']['input']>;
  lightRoastRuntime?: InputMaybe<Scalars['Float']['input']>;
  mediumRoastRuntime?: InputMaybe<Scalars['Float']['input']>;
  modifyExistingPos?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  onHoldToAvailableDays?: InputMaybe<Scalars['Int']['input']>;
  orderSimulationEndDate?: InputMaybe<Scalars['String']['input']>;
  orderToDeliveryDaysOffset?: InputMaybe<Scalars['Int']['input']>;
  organicMillingNextProductionRun?: InputMaybe<Scalars['String']['input']>;
  productionStartToEndDays?: InputMaybe<Scalars['Int']['input']>;
  sewYieldLoss?: InputMaybe<Scalars['Float']['input']>;
  taraNextProductionRun?: InputMaybe<Scalars['String']['input']>;
  trendLookbackWindow?: InputMaybe<Scalars['Int']['input']>;
  truckOrderToPackDays?: InputMaybe<Scalars['Int']['input']>;
  turnOnProductionBatching?: InputMaybe<Scalars['Boolean']['input']>;
  useBufferForecast?: InputMaybe<Scalars['Boolean']['input']>;
  weeksOfSupply?: InputMaybe<Scalars['Int']['input']>;
  weightingMethod?: InputMaybe<Scalars['String']['input']>;
  weightingWindowDays?: InputMaybe<Scalars['Int']['input']>;
};

export type ReplacePowerBiInput = {
  customerId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};

export enum Role {
  Admin = 'ADMIN',
  None = 'NONE',
  Root = 'ROOT'
}

export type RunLog = {
  __typename?: 'RunLog';
  assumedCustomerGrowth?: Maybe<Scalars['Float']['output']>;
  auroraNextProductionRun?: Maybe<Scalars['String']['output']>;
  bindToForecastUpload?: Maybe<Scalars['Boolean']['output']>;
  bindToSKUOverrides?: Maybe<Scalars['Boolean']['output']>;
  cnpNextProductionRun?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  cutYieldLoss?: Maybe<Scalars['Float']['output']>;
  darkRoastRuntime?: Maybe<Scalars['Float']['output']>;
  decafChangeoverTime?: Maybe<Scalars['Float']['output']>;
  defaultChangeoverTime?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  desiredMinWeeksOnHand?: Maybe<Scalars['Int']['output']>;
  dyeYieldLoss?: Maybe<Scalars['Float']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  excludeForecast?: Maybe<Scalars['Boolean']['output']>;
  excludeYieldPlan?: Maybe<Scalars['Boolean']['output']>;
  firmWindowLookAhead?: Maybe<Scalars['Int']['output']>;
  historicalDatePatterns?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  leadTimeInWeeks?: Maybe<Scalars['Int']['output']>;
  lightRoastRuntime?: Maybe<Scalars['Float']['output']>;
  mediumRoastRuntime?: Maybe<Scalars['Float']['output']>;
  modifyExistingPos?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  onHoldToAvailableDays?: Maybe<Scalars['Int']['output']>;
  orderSimulationEndDate?: Maybe<Scalars['String']['output']>;
  orderToDeliveryDaysOffset?: Maybe<Scalars['Int']['output']>;
  organicMillingNextProductionRun?: Maybe<Scalars['String']['output']>;
  productionStartToEndDays?: Maybe<Scalars['Int']['output']>;
  runError?: Maybe<Scalars['String']['output']>;
  sewYieldLoss?: Maybe<Scalars['Float']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  taraNextProductionRun?: Maybe<Scalars['String']['output']>;
  trendLookbackWindow?: Maybe<Scalars['Int']['output']>;
  truckOrderToPackDays?: Maybe<Scalars['Int']['output']>;
  turnOnProductionBatching?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  useBufferForecast?: Maybe<Scalars['Boolean']['output']>;
  weeksOfSupply?: Maybe<Scalars['Int']['output']>;
  weightingMethod?: Maybe<Scalars['String']['output']>;
  weightingWindowDays?: Maybe<Scalars['Int']['output']>;
};

export type TransformedDataUrl = {
  __typename?: 'TransformedDataUrl';
  lastModified: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type UpdateMyRunInput = {
  description: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type User = {
  __typename?: 'User';
  customerId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type UserApproval = {
  __typename?: 'UserApproval';
  anchorRef: Scalars['String']['output'];
  approval?: Maybe<Approval>;
  date: Scalars['String']['output'];
  id: Scalars['String']['output'];
  message: Scalars['String']['output'];
  userComments?: Maybe<Array<UserComment>>;
  userId: Scalars['String']['output'];
};

export type UserComment = {
  __typename?: 'UserComment';
  anchorRef: Scalars['String']['output'];
  date: Scalars['String']['output'];
  id: Scalars['String']['output'];
  message: Scalars['String']['output'];
  userComments?: Maybe<Array<UserComment>>;
  userId: Scalars['String']['output'];
};

export type Vendor = {
  __typename?: 'Vendor';
  address?: Maybe<Scalars['String']['output']>;
  address_override?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

export type VendorInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  address_override?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

export type WorkflowTriggerEngineVariables = {
  assumedCustomerGrowth?: InputMaybe<Scalars['Float']['input']>;
  auroraNextProductionRun?: InputMaybe<Scalars['String']['input']>;
  bindToForecastUpload?: InputMaybe<Scalars['Boolean']['input']>;
  bindToSKUOverrides?: InputMaybe<Scalars['Boolean']['input']>;
  cnpNextProductionRun?: InputMaybe<Scalars['String']['input']>;
  cutYieldLoss?: InputMaybe<Scalars['Float']['input']>;
  darkRoastRuntime?: InputMaybe<Scalars['Float']['input']>;
  decafChangeoverTime?: InputMaybe<Scalars['Float']['input']>;
  defaultChangeoverTime?: InputMaybe<Scalars['Float']['input']>;
  desiredMinWeeksOnHand?: InputMaybe<Scalars['Int']['input']>;
  dyeYieldLoss?: InputMaybe<Scalars['Float']['input']>;
  excludeForecast?: InputMaybe<Scalars['Boolean']['input']>;
  excludeYieldPlan?: InputMaybe<Scalars['Boolean']['input']>;
  firmWindowLookAhead?: InputMaybe<Scalars['Int']['input']>;
  historicalDatePatterns?: InputMaybe<Scalars['Boolean']['input']>;
  leadTimeInWeeks?: InputMaybe<Scalars['Int']['input']>;
  lightRoastRuntime?: InputMaybe<Scalars['Float']['input']>;
  loadDemandOfRunId?: InputMaybe<Scalars['Int']['input']>;
  mediumRoastRuntime?: InputMaybe<Scalars['Float']['input']>;
  modifyExistingPos?: InputMaybe<Scalars['Boolean']['input']>;
  onHoldToAvailableDays?: InputMaybe<Scalars['Int']['input']>;
  orderSimulationEndDate?: InputMaybe<Scalars['String']['input']>;
  orderToDeliveryDaysOffset?: InputMaybe<Scalars['Int']['input']>;
  organicMillingNextProductionRun?: InputMaybe<Scalars['String']['input']>;
  productionStartToEndDays?: InputMaybe<Scalars['Int']['input']>;
  sewYieldLoss?: InputMaybe<Scalars['Float']['input']>;
  taraNextProductionRun?: InputMaybe<Scalars['String']['input']>;
  trendLookbackWindow?: InputMaybe<Scalars['Int']['input']>;
  truckOrderToPackDays?: InputMaybe<Scalars['Int']['input']>;
  turnOnProductionBatching?: InputMaybe<Scalars['Boolean']['input']>;
  useBufferForecast?: InputMaybe<Scalars['Boolean']['input']>;
  weeksOfSupply?: InputMaybe<Scalars['Int']['input']>;
  weightingMethod?: InputMaybe<Scalars['String']['input']>;
  weightingWindowDays?: InputMaybe<Scalars['Int']['input']>;
};

export type AddMyUserApprovalMutationVariables = Exact<{
  newApproval: AddUserApprovalInput;
}>;


export type AddMyUserApprovalMutation = { __typename?: 'Mutation', addMyUserApproval?: { __typename?: 'UserApproval', id: string, anchorRef: string, date: string, userId: string, message: string, approval?: Approval | null } | null };

export type AddMyUserCommentMutationVariables = Exact<{
  newComment: AddUserCommentInput;
}>;


export type AddMyUserCommentMutation = { __typename?: 'Mutation', addMyUserComment?: { __typename?: 'UserComment', id: string, anchorRef: string, date: string, userId: string, message: string } | null };

export type CancelMyOrchestratorRunMutationVariables = Exact<{
  runSettings: OrchestratorRunInput;
}>;


export type CancelMyOrchestratorRunMutation = { __typename?: 'Mutation', cancelMyOrchestratorRun?: string | null };

export type CreateCustomerMutationVariables = Exact<{
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  defaultRole: Scalars['String']['input'];
}>;


export type CreateCustomerMutation = { __typename?: 'Mutation', createCustomer?: { __typename?: 'Customer', name: string, id: string, defaultRole?: string | null } | null };

export type CreateCustomerEmailDomainMutationVariables = Exact<{
  customerId: Scalars['String']['input'];
  emailDomain: Scalars['String']['input'];
}>;


export type CreateCustomerEmailDomainMutation = { __typename?: 'Mutation', createCustomerEmailDomain?: { __typename?: 'Customer', id: string, emailDomains?: Array<string> | null } | null };

export type CreateMyEnginePresetMutationVariables = Exact<{
  enginePreset: CreateEnginePresetInput;
}>;


export type CreateMyEnginePresetMutation = { __typename?: 'Mutation', createMyEnginePreset?: { __typename?: 'EnginePreset', id: number, name: string, description: string, orderToDeliveryDaysOffset?: number | null, weightingMethod?: string | null, orderSimulationEndDate?: string | null, historicalDatePatterns?: boolean | null, weightingWindowDays?: number | null, bindToSKUOverrides?: boolean | null, bindToForecastUpload?: boolean | null, modifyExistingPos?: boolean | null, dyeYieldLoss?: number | null, sewYieldLoss?: number | null, cutYieldLoss?: number | null, weeksOfSupply?: number | null, useBufferForecast?: boolean | null, desiredMinWeeksOnHand?: number | null, leadTimeInWeeks?: number | null, assumedCustomerGrowth?: number | null, excludeForecast?: boolean | null, excludeYieldPlan?: boolean | null, truckOrderToPackDays?: number | null, onHoldToAvailableDays?: number | null, productionStartToEndDays?: number | null, darkRoastRuntime?: number | null, mediumRoastRuntime?: number | null, lightRoastRuntime?: number | null, defaultChangeoverTime?: number | null, decafChangeoverTime?: number | null, turnOnProductionBatching?: boolean | null, organicMillingNextProductionRun?: string | null, cnpNextProductionRun?: string | null, taraNextProductionRun?: string | null, auroraNextProductionRun?: string | null, firmWindowLookAhead?: number | null, trendLookbackWindow?: number | null, default: boolean } | null };

export type CreateMyGoodchopPresignUploadUrlMutationVariables = Exact<{
  fileName: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
}>;


export type CreateMyGoodchopPresignUploadUrlMutation = { __typename?: 'Mutation', createMyGoodchopPresignUploadUrl?: string | null };

export type CreateOrReplaceFeatureFlagsMutationVariables = Exact<{
  featureFlags: FeatureFlagsInput;
}>;


export type CreateOrReplaceFeatureFlagsMutation = { __typename?: 'Mutation', createOrReplaceFeatureFlags?: { __typename?: 'Features', EngineRuns: Role, EngineLegacyDatabase: Role, StepsUsedForEngineRuns: Role, StepsExperimentalEngineWorkflow: Role, StepsRunDetails: Role, StepsStepDetails: Role, StepsVariableSets: Role, EngineRunHistory: Role, EnginePresets: Role, EngineLoadLockedDemandForecast: Role, VarOrderToDeliveryDaysOffset: Role, VarWeightingMethod: Role, VarOrderSimulationEndDate: Role, VarHistoricalDatePatterns: Role, VarWeightingWindowDays: Role, VarBindToSKUOverrides: Role, VarBindToForecastUpload: Role, VarModifyExistingPos: Role, VarDyeYieldLoss: Role, VarSewYieldLoss: Role, VarCutYieldLoss: Role, VarWeeksOfSupply: Role, VarUseBufferForecast: Role, VarDesiredMinWeeksOnHand: Role, VarLeadTimeInWeeks: Role, VarAssumedCustomerGrowth: Role, VarExcludeForecast: Role, VarExcludeYieldPlan: Role, VarTruckOrderToPackDays: Role, VarOnHoldToAvailableDays: Role, VarProductionStartToEndDays: Role, VarDarkRoastRuntime: Role, VarMediumRoastRuntime: Role, VarLightRoastRuntime: Role, VarDefaultChangeoverTime: Role, VarDecafChangeoverTime: Role, VarTurnOnProductionBatching: Role, VarOrganicMillingNextProductionRun: Role, VarCnpNextProductionRun: Role, VarTaraNextProductionRun: Role, VarAauroraNextProductionRun: Role, VarFirmWindowLookAhead: Role, VarTrendLookbackWindow: Role, RunComparison: Role, ForecastAccuracy: Role, SkuHierarchyProductCategory: Role, SkuHierarchyProductType: Role, SkuHierarchyProductFamily: Role, SkuHierarchyProductTitle: Role, InventoryOnHand: Role, InventoryOnHandInStockTreshold: Role, InventoryOnHandForecast: Role, InventoryOnHandInStockRate: Role, ValidationDashboard: Role, DarkMode: Role } | null };

export type CreatePowerBiMutationVariables = Exact<{
  powerBi: CreatePowerBiInput;
}>;


export type CreatePowerBiMutation = { __typename?: 'Mutation', createPowerBi?: { __typename?: 'Customer', id: string, powerBi?: Array<{ __typename?: 'PowerBi', id: string, name: string, workspaceId: string, datasetId?: string | null }> | null } | null };

export type DeleteCustomerEmailDomainMutationVariables = Exact<{
  customerId: Scalars['String']['input'];
  emailDomain: Scalars['String']['input'];
}>;


export type DeleteCustomerEmailDomainMutation = { __typename?: 'Mutation', deleteCustomerEmailDomain?: { __typename?: 'Customer', id: string, emailDomains?: Array<string> | null } | null };

export type GenerateMyPoPdfWithDownloadUrlMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GenerateMyPoPdfWithDownloadUrlMutation = { __typename?: 'Mutation', generateMyPoPdfWithDownloadUrl?: string | null };

export type GetAllCustomersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCustomersQuery = { __typename?: 'Query', getAllCustomers: Array<{ __typename?: 'Customer', name: string, id: string }> };

export type GetCustomerQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
}>;


export type GetCustomerQuery = { __typename?: 'Query', getCustomer?: { __typename?: 'Customer', name: string, id: string, emailDomains?: Array<string> | null, defaultRole?: string | null, features?: { __typename?: 'Features', EngineRuns: Role, EngineLegacyDatabase: Role, StepsUsedForEngineRuns: Role, StepsExperimentalEngineWorkflow: Role, StepsRunDetails: Role, StepsStepDetails: Role, StepsVariableSets: Role, EngineRunHistory: Role, EnginePresets: Role, EngineLoadLockedDemandForecast: Role, VarOrderToDeliveryDaysOffset: Role, VarWeightingMethod: Role, VarOrderSimulationEndDate: Role, VarHistoricalDatePatterns: Role, VarWeightingWindowDays: Role, VarBindToSKUOverrides: Role, VarBindToForecastUpload: Role, VarModifyExistingPos: Role, VarDyeYieldLoss: Role, VarSewYieldLoss: Role, VarCutYieldLoss: Role, VarWeeksOfSupply: Role, VarUseBufferForecast: Role, VarDesiredMinWeeksOnHand: Role, VarLeadTimeInWeeks: Role, VarAssumedCustomerGrowth: Role, VarExcludeForecast: Role, VarExcludeYieldPlan: Role, VarTruckOrderToPackDays: Role, VarOnHoldToAvailableDays: Role, VarProductionStartToEndDays: Role, VarDarkRoastRuntime: Role, VarMediumRoastRuntime: Role, VarLightRoastRuntime: Role, VarDefaultChangeoverTime: Role, VarDecafChangeoverTime: Role, VarTurnOnProductionBatching: Role, VarOrganicMillingNextProductionRun: Role, VarCnpNextProductionRun: Role, VarTaraNextProductionRun: Role, VarAauroraNextProductionRun: Role, VarFirmWindowLookAhead: Role, VarTrendLookbackWindow: Role, RunComparison: Role, ForecastAccuracy: Role, SkuHierarchyProductCategory: Role, SkuHierarchyProductType: Role, SkuHierarchyProductFamily: Role, SkuHierarchyProductTitle: Role, InventoryOnHand: Role, InventoryOnHandInStockTreshold: Role, InventoryOnHandForecast: Role, InventoryOnHandInStockRate: Role, InventoryOnHandBeans: Role, ValidationDashboard: Role, DarkMode: Role, PoInbox: Role } | null, powerBi?: Array<{ __typename?: 'PowerBi', id: string, name: string, workspaceId: string, datasetId?: string | null, enabled?: boolean | null }> | null } | null };

export type GetLatestOrchestratorRunsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLatestOrchestratorRunsQuery = { __typename?: 'Query', getLatestOrchestratorRuns: Array<{ __typename?: 'OrchestratorRun', id: string, status: OrchestratorRunStatus, createdAt: string, updatedAt: string, initiatedBy?: string | null, name?: string | null, description?: string | null, locked?: boolean | null, usesLockedInputId?: string | null, usesLockedVariablesId?: string | null, oldLockedRunId?: string | null, runParamsJson?: string | null, oldRunId?: number | null, customerId?: string | null, runSettings: { __typename?: 'OrchestratorRunSettings', inputId: string, workflowId: string, variablesId: string, runAttemptId: number } }> };

export type GetMyCustomerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyCustomerQuery = { __typename?: 'Query', getMyCustomer?: { __typename?: 'MyCustomer', name: string, id: string, ej2License?: string | null, muiLicense?: string | null, powerBi?: Array<{ __typename?: 'PowerBi', id: string, name: string, workspaceId: string }> | null, features?: { __typename?: 'MyFeatures', EngineRuns?: boolean | null, EngineLegacyDatabase?: boolean | null, StepsUsedForEngineRuns?: boolean | null, StepsExperimentalEngineWorkflow?: boolean | null, StepsRunDetails?: boolean | null, StepsStepDetails?: boolean | null, StepsVariableSets?: boolean | null, EngineRunHistory?: boolean | null, EnginePresets?: boolean | null, EngineLoadLockedDemandForecast?: boolean | null, VarOrderToDeliveryDaysOffset?: boolean | null, VarWeightingMethod?: boolean | null, VarOrderSimulationEndDate?: boolean | null, VarHistoricalDatePatterns?: boolean | null, VarWeightingWindowDays?: boolean | null, VarBindToSKUOverrides?: boolean | null, VarBindToForecastUpload?: boolean | null, VarModifyExistingPos?: boolean | null, VarDyeYieldLoss?: boolean | null, VarSewYieldLoss?: boolean | null, VarCutYieldLoss?: boolean | null, VarWeeksOfSupply?: boolean | null, VarUseBufferForecast?: boolean | null, VarDesiredMinWeeksOnHand?: boolean | null, VarLeadTimeInWeeks?: boolean | null, VarAssumedCustomerGrowth?: boolean | null, VarExcludeForecast?: boolean | null, VarExcludeYieldPlan?: boolean | null, VarTruckOrderToPackDays?: boolean | null, VarOnHoldToAvailableDays?: boolean | null, VarProductionStartToEndDays?: boolean | null, VarDarkRoastRuntime?: boolean | null, VarMediumRoastRuntime?: boolean | null, VarLightRoastRuntime?: boolean | null, VarDefaultChangeoverTime?: boolean | null, VarDecafChangeoverTime?: boolean | null, VarTurnOnProductionBatching?: boolean | null, VarOrganicMillingNextProductionRun?: boolean | null, VarCnpNextProductionRun?: boolean | null, VarTaraNextProductionRun?: boolean | null, VarAauroraNextProductionRun?: boolean | null, VarFirmWindowLookAhead?: boolean | null, VarTrendLookbackWindow?: boolean | null, RunComparison?: boolean | null, ForecastAccuracy?: boolean | null, SkuHierarchyProductCategory?: boolean | null, SkuHierarchyProductType?: boolean | null, SkuHierarchyProductFamily?: boolean | null, SkuHierarchyProductTitle?: boolean | null, InventoryOnHand?: boolean | null, InventoryOnHandInStockTreshold?: boolean | null, InventoryOnHandForecast?: boolean | null, InventoryOnHandInStockRate?: boolean | null, InventoryOnHandBeans?: boolean | null, ValidationDashboard?: boolean | null, DarkMode?: boolean | null, PoInbox?: boolean | null } | null } | null };

export type GetMyDemandMonthlyDiffUrlQueryVariables = Exact<{
  engineRunId0: Scalars['Int']['input'];
  engineRunId1: Scalars['Int']['input'];
}>;


export type GetMyDemandMonthlyDiffUrlQuery = { __typename?: 'Query', getMyDemandMonthlyDiffUrl?: string | null };

export type GetMyDemandMonthlyUrlQueryVariables = Exact<{
  engineRunId: Scalars['Int']['input'];
}>;


export type GetMyDemandMonthlyUrlQuery = { __typename?: 'Query', getMyDemandMonthlyUrl?: string | null };

export type GetMyDemandWeeklyUrlQueryVariables = Exact<{
  engineRunId: Scalars['Int']['input'];
}>;


export type GetMyDemandWeeklyUrlQuery = { __typename?: 'Query', getMyDemandWeeklyUrl?: string | null };

export type GetMyEnginePresetsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyEnginePresetsQuery = { __typename?: 'Query', getMyEnginePresets: Array<{ __typename?: 'EnginePreset', id: number, name: string, description: string, orderToDeliveryDaysOffset?: number | null, weightingMethod?: string | null, orderSimulationEndDate?: string | null, historicalDatePatterns?: boolean | null, weightingWindowDays?: number | null, bindToSKUOverrides?: boolean | null, bindToForecastUpload?: boolean | null, modifyExistingPos?: boolean | null, dyeYieldLoss?: number | null, sewYieldLoss?: number | null, cutYieldLoss?: number | null, weeksOfSupply?: number | null, useBufferForecast?: boolean | null, desiredMinWeeksOnHand?: number | null, leadTimeInWeeks?: number | null, assumedCustomerGrowth?: number | null, excludeForecast?: boolean | null, excludeYieldPlan?: boolean | null, truckOrderToPackDays?: number | null, onHoldToAvailableDays?: number | null, productionStartToEndDays?: number | null, darkRoastRuntime?: number | null, mediumRoastRuntime?: number | null, lightRoastRuntime?: number | null, defaultChangeoverTime?: number | null, decafChangeoverTime?: number | null, turnOnProductionBatching?: boolean | null, organicMillingNextProductionRun?: string | null, cnpNextProductionRun?: string | null, taraNextProductionRun?: string | null, auroraNextProductionRun?: string | null, firmWindowLookAhead?: number | null, trendLookbackWindow?: number | null, default: boolean }> };

export type GetMyForecastAccuracyUrlQueryVariables = Exact<{
  actualsEngineRunId: Scalars['Int']['input'];
  forecastEngineRunId: Scalars['Int']['input'];
  minDate?: InputMaybe<Scalars['String']['input']>;
  maxDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMyForecastAccuracyUrlQuery = { __typename?: 'Query', getMyForecastAccuracyUrl?: string | null };

export type GetMyGoodchopOdlTaskQueryVariables = Exact<{
  taskId: Scalars['String']['input'];
}>;


export type GetMyGoodchopOdlTaskQuery = { __typename?: 'Query', getMyGoodchopOdlTask?: { __typename?: 'GoodchopOdlTask', updatedAt?: string | null, createdAt: string, status: string, error?: string | null, fileName: string, id: string } | null };

export type GetMyGoodchopTransformedDataUrlsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetMyGoodchopTransformedDataUrlsQuery = { __typename?: 'Query', getMyGoodchopOdlTransformedDataUrls?: { __typename?: 'GoodchopOdlTransformedDataUrls', page: number, totalPages: number, data: Array<{ __typename?: 'TransformedDataUrl', url: string, size: number, lastModified: string }> } | null };

export type GetMyInventoryOnHandBeansUrlsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyInventoryOnHandBeansUrlsQuery = { __typename?: 'Query', getMyInventoryOnHandBeansUrls: Array<{ __typename?: 'InventoryOnHandUrl', id: number, date: string, url: string }> };

export type GetMyInventoryOnHandForecastUrlsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyInventoryOnHandForecastUrlsQuery = { __typename?: 'Query', getMyInventoryOnHandForecastUrls: Array<{ __typename?: 'InventoryOnHandForecastUrl', id: number, url: string }> };

export type GetMyInventoryOnHandUrlsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyInventoryOnHandUrlsQuery = { __typename?: 'Query', getMyInventoryOnHandUrls: Array<{ __typename?: 'InventoryOnHandUrl', id: number, date: string, url: string }> };

export type GetMyLockedEngineRunIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyLockedEngineRunIdQuery = { __typename?: 'Query', getMyLockedEngineRunId?: number | null };

export type GetMyLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyLocationsQuery = { __typename?: 'Query', getMyLocations: Array<{ __typename?: 'Location', id: string, address?: string | null, address_override?: string | null, email?: string | null }> };

export type GetMyLockedDemandOutputRunIdsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyLockedDemandOutputRunIdsQuery = { __typename?: 'Query', getMyLockedDemandOutputRunIds: Array<number> };

export type GetMyLogoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyLogoQuery = { __typename?: 'Query', getMyLogo?: { __typename?: 'Logo', logo_name?: string | null, img_b64?: string | null } | null };

export type GetMyOrchestratorRunsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetMyOrchestratorRunsQuery = { __typename?: 'Query', getMyOrchestratorRuns: Array<{ __typename?: 'OrchestratorRun', id: string, status: OrchestratorRunStatus, createdAt: string, updatedAt: string, stepIds?: string | null, initiatedBy?: string | null, name?: string | null, description?: string | null, locked?: boolean | null, usesLockedInputId?: string | null, usesLockedVariablesId?: string | null, oldLockedRunId?: string | null, runParamsJson?: string | null, oldRunId?: number | null, runSettings: { __typename?: 'OrchestratorRunSettings', inputId: string, workflowId: string, variablesId: string, runAttemptId: number } }> };

export type GetMyOrchestratorStepsQueryVariables = Exact<{
  runSettings: OrchestratorRunSettingsInput;
}>;


export type GetMyOrchestratorStepsQuery = { __typename?: 'Query', getMyOrchestratorSteps?: Array<{ __typename?: 'OrchestratorStep', stepId: string, status: OrchestratorStepStatus, createdAt: string, runSettings: { __typename?: 'OrchestratorRunSettings', inputId: string, workflowId: string, variablesId: string, runAttemptId: number } }> | null };

export type GetMyPoEditsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetMyPoEditsQuery = { __typename?: 'Query', getMyPoEdits: Array<{ __typename?: 'PurchaseOrderEdit', id: string, po_id: string, location_address?: string | null, location_email?: string | null, vendor_address?: string | null, vendor_email?: string | null, need_by_date?: string | null, ship_by_date?: string | null, notes?: string | null, created_at?: string | null, created_by?: string | null }> };

export type GetMyPoSkuEditsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetMyPoSkuEditsQuery = { __typename?: 'Query', getMyPoSkuEdits: Array<{ __typename?: 'PurchaseOrderSku', id: string, po_id: string, sku: string, quantity?: string | null, unit: string, unit_cost?: string | null, created_at?: string | null, created_by?: string | null }> };

export type GetMyPoWithLatestEditAndSkusQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetMyPoWithLatestEditAndSkusQuery = { __typename?: 'Query', getMyPoWithLatestEditAndSkus?: { __typename?: 'PurchaseOrderWithEditAndSkus', id: string, po: { __typename?: 'PurchaseOrder', id: string, po_sim_id: string, location: string, vendor: string, snooze_start_date?: string | null, snooze_end_date?: string | null, status?: PurchaseOrderStatus | null, total_cogs?: number | null, created_at?: string | null, created_by?: string | null, updated_at?: string | null, updated_by?: string | null, run_settings?: { __typename?: 'OrchestratorRunSettings', inputId: string, variablesId: string, workflowId: string, runAttemptId: number } | null }, pe?: { __typename?: 'PurchaseOrderEdit', id: string, po_id: string, location_address?: string | null, location_email?: string | null, vendor_address?: string | null, vendor_email?: string | null, need_by_date?: string | null, ship_by_date?: string | null, notes?: string | null, created_at?: string | null, created_by?: string | null } | null, ps?: Array<{ __typename?: 'PurchaseOrderSku', id: string, po_id: string, sku: string, quantity?: string | null, unit: string, unit_cost?: string | null, created_at?: string | null, created_by?: string | null }> | null } | null };

export type GetMyPosWithLatestEditsQueryVariables = Exact<{
  include_status: Array<PurchaseOrderStatus> | PurchaseOrderStatus;
  runSettings?: InputMaybe<OrchestratorRunSettingsInput>;
  snoozed?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMyPosWithLatestEditsQuery = { __typename?: 'Query', getMyPosWithLatestEdits: Array<{ __typename?: 'PurchaseOrderWithEditAndSkus', id: string, po: { __typename?: 'PurchaseOrder', id: string, po_sim_id: string, location: string, vendor: string, snooze_start_date?: string | null, snooze_end_date?: string | null, status?: PurchaseOrderStatus | null, total_cogs?: number | null, created_at?: string | null, created_by?: string | null, updated_at?: string | null, updated_by?: string | null, run_settings?: { __typename?: 'OrchestratorRunSettings', inputId: string, variablesId: string, workflowId: string, runAttemptId: number } | null }, pe?: { __typename?: 'PurchaseOrderEdit', id: string, po_id: string, location_address?: string | null, location_email?: string | null, vendor_address?: string | null, vendor_email?: string | null, need_by_date?: string | null, ship_by_date?: string | null, notes?: string | null, created_at?: string | null, created_by?: string | null } | null }> };

export type GetMyPowerBiReportItemsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;


export type GetMyPowerBiReportItemsQuery = { __typename?: 'Query', getMyPowerBiReportItems?: { __typename?: 'PowerBiReportItems', embedToken: string, embedTokenId: string, embedTokenExpiration: string, reports: Array<{ __typename?: 'PowerBiReport', reportName: string, reportId: string, embedUrl: string, pages: Array<{ __typename?: 'PowerBiReportPages', pageId: string, pageName: string, order: number }> }> } | null };

export type GetMyPowerBisQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyPowerBisQuery = { __typename?: 'Query', getMyPowerBis: Array<{ __typename?: 'PowerBi', name: string, id: string, workspaceId: string }> };

export type GetMyRunComparisonRunIdsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyRunComparisonRunIdsQuery = { __typename?: 'Query', getMyRunComparisonRunIds: Array<number> };

export type GetMyRunLogsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyRunLogsQuery = { __typename?: 'Query', getMyRunLogs: Array<{ __typename?: 'RunLog', id?: number | null, email?: string | null, name?: string | null, description?: string | null, status?: string | null, createdAt?: string | null, updatedAt?: string | null, startedAt?: string | null, orderToDeliveryDaysOffset?: number | null, weightingMethod?: string | null, orderSimulationEndDate?: string | null, historicalDatePatterns?: boolean | null, weightingWindowDays?: number | null, bindToSKUOverrides?: boolean | null, bindToForecastUpload?: boolean | null, dyeYieldLoss?: number | null, sewYieldLoss?: number | null, cutYieldLoss?: number | null, weeksOfSupply?: number | null, useBufferForecast?: boolean | null, desiredMinWeeksOnHand?: number | null, leadTimeInWeeks?: number | null, assumedCustomerGrowth?: number | null, runError?: string | null, excludeYieldPlan?: boolean | null, excludeForecast?: boolean | null, truckOrderToPackDays?: number | null, onHoldToAvailableDays?: number | null, productionStartToEndDays?: number | null, darkRoastRuntime?: number | null, mediumRoastRuntime?: number | null, lightRoastRuntime?: number | null, defaultChangeoverTime?: number | null, decafChangeoverTime?: number | null, turnOnProductionBatching?: boolean | null, organicMillingNextProductionRun?: string | null, cnpNextProductionRun?: string | null, taraNextProductionRun?: string | null, auroraNextProductionRun?: string | null, firmWindowLookAhead?: number | null, trendLookbackWindow?: number | null }> };

export type GetMySkuHierarchyUrlQueryVariables = Exact<{
  engineRunId: Scalars['Int']['input'];
}>;


export type GetMySkuHierarchyUrlQuery = { __typename?: 'Query', getMySkuHierarchyUrl?: string | null };

export type GetMyUserApprovalsByAnchorQueryVariables = Exact<{
  anchorRefs: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetMyUserApprovalsByAnchorQuery = { __typename?: 'Query', getMyUserApprovalsByAnchor: Array<{ __typename?: 'UserApproval', id: string, anchorRef: string, date: string, userId: string, message: string, approval?: Approval | null }> };

export type GetMyUserCommentsByAnchorQueryVariables = Exact<{
  anchorRefs: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetMyUserCommentsByAnchorQuery = { __typename?: 'Query', getMyUserCommentsByAnchor: Array<{ __typename?: 'UserComment', id: string, anchorRef: string, date: string, userId: string, message: string }> };

export type GetMyVendorsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyVendorsQuery = { __typename?: 'Query', getMyVendors: Array<{ __typename?: 'Vendor', id: string, address?: string | null, address_override?: string | null, email?: string | null }> };

export type HelloWorldQueryVariables = Exact<{ [key: string]: never; }>;


export type HelloWorldQuery = { __typename?: 'Query', helloWorld?: string | null };

export type ImportMyPoMutationVariables = Exact<{
  id: Scalars['String']['input'];
  runSettings: OrchestratorRunInput;
}>;


export type ImportMyPoMutation = { __typename?: 'Mutation', importMyPo: { __typename?: 'PurchaseOrderWithEditAndSkus', id: string, po: { __typename?: 'PurchaseOrder', id: string, po_sim_id: string, location: string, vendor: string, snooze_start_date?: string | null, snooze_end_date?: string | null, status?: PurchaseOrderStatus | null, total_cogs?: number | null, created_at?: string | null, created_by?: string | null, updated_at?: string | null, updated_by?: string | null, run_settings?: { __typename?: 'OrchestratorRunSettings', inputId: string, variablesId: string, workflowId: string, runAttemptId: number } | null }, pe?: { __typename?: 'PurchaseOrderEdit', id: string, po_id: string, location_address?: string | null, location_email?: string | null, vendor_address?: string | null, vendor_email?: string | null, need_by_date?: string | null, ship_by_date?: string | null, notes?: string | null, created_at?: string | null, created_by?: string | null } | null, ps?: Array<{ __typename?: 'PurchaseOrderSku', id: string, po_id: string, sku: string, quantity?: string | null, unit: string, unit_cost?: string | null, created_at?: string | null, created_by?: string | null }> | null } };

export type MakeMyEnginePresetDefaultMutationVariables = Exact<{
  enginePresetId: Scalars['Int']['input'];
}>;


export type MakeMyEnginePresetDefaultMutation = { __typename?: 'Mutation', makeMyEnginePresetDefault?: string | null };

export type CreateMyGoodchopGrossOdlJobPlanMutationVariables = Exact<{
  jobPlanId: Scalars['String']['input'];
  jobPlan: Array<GoodChopGrossOdlJobPlanIntKeyValueInput> | GoodChopGrossOdlJobPlanIntKeyValueInput;
}>;


export type CreateMyGoodchopGrossOdlJobPlanMutation = { __typename?: 'Mutation', createMyGoodchopGrossOdlJobPlan?: { __typename?: 'GoodchopGrossOdlCreateJobPlanResponse', jobPlanId: string } | null };

export type CreateMyGoodchopGrossOdlJobMutationVariables = Exact<{
  jobPlanId: Scalars['String']['input'];
  job: Scalars['String']['input'];
  step: Scalars['String']['input'];
  runId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  jobName: Scalars['String']['input'];
}>;


export type CreateMyGoodchopGrossOdlJobMutation = { __typename?: 'Mutation', createMyGoodchopGrossOdlJob?: string | null };

export type CreateMyGoodchopGrossOdlPresignDownloadUrlMutationVariables = Exact<{
  filePath: Scalars['String']['input'];
}>;


export type CreateMyGoodchopGrossOdlPresignDownloadUrlMutation = { __typename?: 'Mutation', createMyGoodchopGrossOdlPresignDownloadUrl?: { __typename?: 'GoodchopGrossOdlPresignDownloadUrlResponse', presignUrl: string } | null };

export type CreateMyGoodchopGrossOdlPresignUploadUrlMutationVariables = Exact<{
  fileName: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  jobPlanId: Scalars['String']['input'];
  job: Scalars['String']['input'];
}>;


export type CreateMyGoodchopGrossOdlPresignUploadUrlMutation = { __typename?: 'Mutation', createMyGoodchopGrossOdlPresignUploadUrl?: { __typename?: 'GoodchopGrossOdlPresignUploadUrlResponse', presignUrl: string, runId: string } | null };

export type StartMyGoodchopGrossOdlJobMutationVariables = Exact<{
  jobPlanId: Scalars['String']['input'];
  job: Scalars['String']['input'];
  runId: Scalars['String']['input'];
}>;


export type StartMyGoodchopGrossOdlJobMutation = { __typename?: 'Mutation', startMyGoodchopGrossOdlJob?: { __typename?: 'GoodchopGrossOdlStartJobResponse', dagsterRunId: string } | null };

export type StartMyGoodchopGrossOdlUploadValidationMutationVariables = Exact<{
  runId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  jobPlanId: Scalars['String']['input'];
  job: Scalars['String']['input'];
}>;


export type StartMyGoodchopGrossOdlUploadValidationMutation = { __typename?: 'Mutation', startMyGoodchopGrossOdlUploadValidation?: { __typename?: 'GoodchopGrossOdlStartUploadValidationResponse', runId: string } | null };

export type UpdateMyGoodchopGrossOdlJobMutationVariables = Exact<{
  runId: Scalars['String']['input'];
  dagsterRunId: Scalars['String']['input'];
}>;


export type UpdateMyGoodchopGrossOdlJobMutation = { __typename?: 'Mutation', updateMyGoodchopGrossOdlJob?: string | null };

export type GetMyGoodchopGrossOdlJobsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyGoodchopGrossOdlJobsQuery = { __typename?: 'Query', getMyGoodchopGrossOdlJobs?: Array<{ __typename?: 'GoodchopGrossOdlJob', runId: string, job: string, jobPlanId: string, jobName: string, name: string, step: string, status: string, fileName: string, dagsterRunId?: string | null, dateCreated: string, dateUpdated: string, error?: string | null } | null> | null };

export type GetMyGoodchopGrossOdlJobPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyGoodchopGrossOdlJobPlansQuery = { __typename?: 'Query', getMyGoodchopGrossOdlJobPlans?: Array<{ __typename?: 'GoodchopGrossOdlJobPlan', jobPlanId: string, jobPlan: Array<{ __typename?: 'GoodChopGrossOdlJobPlanIntKeyValue', step: number, jobName: string, dagsterJobName: string }> }> | null };

export type GetMyGoodchopGrossOdlSingleJobQueryVariables = Exact<{
  runId: Scalars['String']['input'];
  dagsterRunId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMyGoodchopGrossOdlSingleJobQuery = { __typename?: 'Query', getMyGoodchopGrossOdlSingleJob?: { __typename?: 'GoodchopGrossOdlJob', runId: string, job: string, jobPlanId: string, jobName: string, step: string, status: string, fileName: string, dagsterRunId?: string | null, dateCreated: string, dateUpdated: string, error?: string | null } | null };

export type GetMyGoodchopGrossOdlSingleJobPlanQueryVariables = Exact<{
  jobPlanId: Scalars['String']['input'];
}>;


export type GetMyGoodchopGrossOdlSingleJobPlanQuery = { __typename?: 'Query', getMyGoodchopGrossOdlSingleJobPlan?: { __typename?: 'GoodchopGrossOdlJobPlan', jobPlanId: string, jobPlan: Array<{ __typename?: 'GoodChopGrossOdlJobPlanIntKeyValue', step: number, jobName: string }> } | null };

export type ReplaceMyEnginePresetMutationVariables = Exact<{
  enginePreset: ReplaceEnginePresetInput;
}>;


export type ReplaceMyEnginePresetMutation = { __typename?: 'Mutation', replaceMyEnginePreset?: { __typename?: 'EnginePreset', id: number, name: string, description: string, orderToDeliveryDaysOffset?: number | null, weightingMethod?: string | null, orderSimulationEndDate?: string | null, historicalDatePatterns?: boolean | null, weightingWindowDays?: number | null, bindToSKUOverrides?: boolean | null, bindToForecastUpload?: boolean | null, modifyExistingPos?: boolean | null, dyeYieldLoss?: number | null, sewYieldLoss?: number | null, cutYieldLoss?: number | null, weeksOfSupply?: number | null, useBufferForecast?: boolean | null, desiredMinWeeksOnHand?: number | null, leadTimeInWeeks?: number | null, assumedCustomerGrowth?: number | null, excludeForecast?: boolean | null, excludeYieldPlan?: boolean | null, truckOrderToPackDays?: number | null, onHoldToAvailableDays?: number | null, productionStartToEndDays?: number | null, darkRoastRuntime?: number | null, mediumRoastRuntime?: number | null, lightRoastRuntime?: number | null, defaultChangeoverTime?: number | null, decafChangeoverTime?: number | null, turnOnProductionBatching?: boolean | null, organicMillingNextProductionRun?: string | null, cnpNextProductionRun?: string | null, taraNextProductionRun?: string | null, auroraNextProductionRun?: string | null, firmWindowLookAhead?: number | null, trendLookbackWindow?: number | null, default: boolean } | null };

export type ReplacePowerBiMutationVariables = Exact<{
  powerBi: ReplacePowerBiInput;
}>;


export type ReplacePowerBiMutation = { __typename?: 'Mutation', replacePowerBi?: { __typename?: 'Customer', id: string, powerBi?: Array<{ __typename?: 'PowerBi', id: string, name: string, workspaceId: string, datasetId?: string | null }> | null } | null };

export type RerunMyOrchestratorStepMutationVariables = Exact<{
  runSettings: OrchestratorRunSettingsInput;
  stepId: Scalars['String']['input'];
}>;


export type RerunMyOrchestratorStepMutation = { __typename?: 'Mutation', rerunMyOrchestratorStep?: string | null };

export type RetryMyOrchestratorRunMutationVariables = Exact<{
  runSettings: OrchestratorRunInput;
}>;


export type RetryMyOrchestratorRunMutation = { __typename?: 'Mutation', retryMyOrchestratorRun?: string | null };

export type SetMyLocationMutationVariables = Exact<{
  location: LocationInput;
}>;


export type SetMyLocationMutation = { __typename?: 'Mutation', setMyLocation: { __typename?: 'Location', id: string, address?: string | null, address_override?: string | null, email?: string | null } };

export type SetMyLockedEngineRunIdMutationVariables = Exact<{
  engineRunId: Scalars['Int']['input'];
}>;


export type SetMyLockedEngineRunIdMutation = { __typename?: 'Mutation', setMyLockedEngineRunId?: string | null };

export type SetMyLogoMutationVariables = Exact<{
  logo: LogoInput;
}>;


export type SetMyLogoMutation = { __typename?: 'Mutation', setMyLogo: { __typename?: 'Logo', logo_name?: string | null, img_b64?: string | null } };

export type SetMyOrchestratorRunDescriptionMutationVariables = Exact<{
  runSettings: OrchestratorRunSettingsInput;
  description: Scalars['String']['input'];
}>;


export type SetMyOrchestratorRunDescriptionMutation = { __typename?: 'Mutation', setMyOrchestratorRunDescription?: string | null };

export type SetMyOrchestratorRunLockedMutationVariables = Exact<{
  runSettings: OrchestratorRunSettingsInput;
  locked: Scalars['Boolean']['input'];
}>;


export type SetMyOrchestratorRunLockedMutation = { __typename?: 'Mutation', setMyOrchestratorRunLocked?: string | null };

export type SetMyOrchestratorRunNameMutationVariables = Exact<{
  runSettings: OrchestratorRunSettingsInput;
  name: Scalars['String']['input'];
}>;


export type SetMyOrchestratorRunNameMutation = { __typename?: 'Mutation', setMyOrchestratorRunName?: string | null };

export type SetMyVendorMutationVariables = Exact<{
  vendor: VendorInput;
}>;


export type SetMyVendorMutation = { __typename?: 'Mutation', setMyVendor: { __typename?: 'Vendor', id: string, address?: string | null, address_override?: string | null, email?: string | null } };

export type StartMyGoodchopOdlTaskMutationVariables = Exact<{
  fileName: Scalars['String']['input'];
}>;


export type StartMyGoodchopOdlTaskMutation = { __typename?: 'Mutation', startMyGoodchopOdlTask?: { __typename?: 'GoodchopOdlTaskId', taskId?: string | null } | null };

export type StartMyOrchestratorRunMutationVariables = Exact<{
  runSettings: OrchestratorRunTriggerInput;
}>;


export type StartMyOrchestratorRunMutation = { __typename?: 'Mutation', startMyOrchestratorRun?: string | null };

export type StoreMyPurchaseOrderEditMutationVariables = Exact<{
  edit: PurchaseOrderEditInput;
}>;


export type StoreMyPurchaseOrderEditMutation = { __typename?: 'Mutation', storeMyPurchaseOrderEdit: string };

export type StoreMyPurchaseOrderEditWithSkusMutationVariables = Exact<{
  edit: PurchaseOrderEditSkusInput;
}>;


export type StoreMyPurchaseOrderEditWithSkusMutation = { __typename?: 'Mutation', storeMyPurchaseOrderEditWithSkus: string };

export type StoreMyPurchaseOrderSkuEditMutationVariables = Exact<{
  edit: PurchaseOrderSkuEditInput;
}>;


export type StoreMyPurchaseOrderSkuEditMutation = { __typename?: 'Mutation', storeMyPurchaseOrderSkuEdit: string };

export type StoreMyPurchaseOrderSnoozeAndStatusMutationVariables = Exact<{
  edit: PurchaseOrderSkuSnoozeAndStatus;
}>;


export type StoreMyPurchaseOrderSnoozeAndStatusMutation = { __typename?: 'Mutation', storeMyPurchaseOrderSnoozeAndStatus: string };

export type TriggerMyOrchestratorRunNextStepsMutationVariables = Exact<{
  runSettings: OrchestratorRunInput;
}>;


export type TriggerMyOrchestratorRunNextStepsMutation = { __typename?: 'Mutation', triggerMyOrchestratorRunNextSteps?: string | null };

export type TriggerMyorchestratorStartTheEngineScriptsMutationVariables = Exact<{
  loadDemandOfRunId?: InputMaybe<Scalars['String']['input']>;
  variablesId?: InputMaybe<Scalars['String']['input']>;
}>;


export type TriggerMyorchestratorStartTheEngineScriptsMutation = { __typename?: 'Mutation', triggerMyorchestratorStartTheEngineScripts?: string | null };

export type UpdateMyRunMutationVariables = Exact<{
  run: UpdateMyRunInput;
}>;


export type UpdateMyRunMutation = { __typename?: 'Mutation', updateMyRun?: { __typename?: 'RunLog', id?: number | null, email?: string | null, name?: string | null, description?: string | null, status?: string | null, createdAt?: string | null, updatedAt?: string | null } | null };

export type WhoAmIQueryVariables = Exact<{ [key: string]: never; }>;


export type WhoAmIQuery = { __typename?: 'Query', whoAmI?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, picture?: string | null, phoneNumber?: string | null, role?: string | null, customerId?: string | null } | null };

export type WorkflowTriggerMutationVariables = Exact<{
  engineVariables?: InputMaybe<WorkflowTriggerEngineVariables>;
}>;


export type WorkflowTriggerMutation = { __typename?: 'Mutation', workflowTrigger?: string | null };


export const AddMyUserApprovalDocument = gql`
    mutation AddMyUserApproval($newApproval: AddUserApprovalInput!) {
  addMyUserApproval(newApproval: $newApproval) {
    id
    anchorRef
    date
    userId
    message
    approval
  }
}
    `;
export type AddMyUserApprovalMutationFn = Apollo.MutationFunction<AddMyUserApprovalMutation, AddMyUserApprovalMutationVariables>;

/**
 * __useAddMyUserApprovalMutation__
 *
 * To run a mutation, you first call `useAddMyUserApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMyUserApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMyUserApprovalMutation, { data, loading, error }] = useAddMyUserApprovalMutation({
 *   variables: {
 *      newApproval: // value for 'newApproval'
 *   },
 * });
 */
export function useAddMyUserApprovalMutation(baseOptions?: Apollo.MutationHookOptions<AddMyUserApprovalMutation, AddMyUserApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMyUserApprovalMutation, AddMyUserApprovalMutationVariables>(AddMyUserApprovalDocument, options);
      }
export type AddMyUserApprovalMutationHookResult = ReturnType<typeof useAddMyUserApprovalMutation>;
export type AddMyUserApprovalMutationResult = Apollo.MutationResult<AddMyUserApprovalMutation>;
export type AddMyUserApprovalMutationOptions = Apollo.BaseMutationOptions<AddMyUserApprovalMutation, AddMyUserApprovalMutationVariables>;
export const AddMyUserCommentDocument = gql`
    mutation AddMyUserComment($newComment: AddUserCommentInput!) {
  addMyUserComment(newComment: $newComment) {
    id
    anchorRef
    date
    userId
    message
  }
}
    `;
export type AddMyUserCommentMutationFn = Apollo.MutationFunction<AddMyUserCommentMutation, AddMyUserCommentMutationVariables>;

/**
 * __useAddMyUserCommentMutation__
 *
 * To run a mutation, you first call `useAddMyUserCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMyUserCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMyUserCommentMutation, { data, loading, error }] = useAddMyUserCommentMutation({
 *   variables: {
 *      newComment: // value for 'newComment'
 *   },
 * });
 */
export function useAddMyUserCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddMyUserCommentMutation, AddMyUserCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMyUserCommentMutation, AddMyUserCommentMutationVariables>(AddMyUserCommentDocument, options);
      }
export type AddMyUserCommentMutationHookResult = ReturnType<typeof useAddMyUserCommentMutation>;
export type AddMyUserCommentMutationResult = Apollo.MutationResult<AddMyUserCommentMutation>;
export type AddMyUserCommentMutationOptions = Apollo.BaseMutationOptions<AddMyUserCommentMutation, AddMyUserCommentMutationVariables>;
export const CancelMyOrchestratorRunDocument = gql`
    mutation CancelMyOrchestratorRun($runSettings: OrchestratorRunInput!) {
  cancelMyOrchestratorRun(runSettings: $runSettings)
}
    `;
export type CancelMyOrchestratorRunMutationFn = Apollo.MutationFunction<CancelMyOrchestratorRunMutation, CancelMyOrchestratorRunMutationVariables>;

/**
 * __useCancelMyOrchestratorRunMutation__
 *
 * To run a mutation, you first call `useCancelMyOrchestratorRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelMyOrchestratorRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelMyOrchestratorRunMutation, { data, loading, error }] = useCancelMyOrchestratorRunMutation({
 *   variables: {
 *      runSettings: // value for 'runSettings'
 *   },
 * });
 */
export function useCancelMyOrchestratorRunMutation(baseOptions?: Apollo.MutationHookOptions<CancelMyOrchestratorRunMutation, CancelMyOrchestratorRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelMyOrchestratorRunMutation, CancelMyOrchestratorRunMutationVariables>(CancelMyOrchestratorRunDocument, options);
      }
export type CancelMyOrchestratorRunMutationHookResult = ReturnType<typeof useCancelMyOrchestratorRunMutation>;
export type CancelMyOrchestratorRunMutationResult = Apollo.MutationResult<CancelMyOrchestratorRunMutation>;
export type CancelMyOrchestratorRunMutationOptions = Apollo.BaseMutationOptions<CancelMyOrchestratorRunMutation, CancelMyOrchestratorRunMutationVariables>;
export const CreateCustomerDocument = gql`
    mutation CreateCustomer($id: String!, $name: String!, $defaultRole: String!) {
  createCustomer(id: $id, name: $name, defaultRole: $defaultRole) {
    name
    id
    defaultRole
  }
}
    `;
export type CreateCustomerMutationFn = Apollo.MutationFunction<CreateCustomerMutation, CreateCustomerMutationVariables>;

/**
 * __useCreateCustomerMutation__
 *
 * To run a mutation, you first call `useCreateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerMutation, { data, loading, error }] = useCreateCustomerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      defaultRole: // value for 'defaultRole'
 *   },
 * });
 */
export function useCreateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerMutation, CreateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerMutation, CreateCustomerMutationVariables>(CreateCustomerDocument, options);
      }
export type CreateCustomerMutationHookResult = ReturnType<typeof useCreateCustomerMutation>;
export type CreateCustomerMutationResult = Apollo.MutationResult<CreateCustomerMutation>;
export type CreateCustomerMutationOptions = Apollo.BaseMutationOptions<CreateCustomerMutation, CreateCustomerMutationVariables>;
export const CreateCustomerEmailDomainDocument = gql`
    mutation CreateCustomerEmailDomain($customerId: String!, $emailDomain: String!) {
  createCustomerEmailDomain(customerId: $customerId, emailDomain: $emailDomain) {
    id
    emailDomains
  }
}
    `;
export type CreateCustomerEmailDomainMutationFn = Apollo.MutationFunction<CreateCustomerEmailDomainMutation, CreateCustomerEmailDomainMutationVariables>;

/**
 * __useCreateCustomerEmailDomainMutation__
 *
 * To run a mutation, you first call `useCreateCustomerEmailDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerEmailDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerEmailDomainMutation, { data, loading, error }] = useCreateCustomerEmailDomainMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      emailDomain: // value for 'emailDomain'
 *   },
 * });
 */
export function useCreateCustomerEmailDomainMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerEmailDomainMutation, CreateCustomerEmailDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerEmailDomainMutation, CreateCustomerEmailDomainMutationVariables>(CreateCustomerEmailDomainDocument, options);
      }
export type CreateCustomerEmailDomainMutationHookResult = ReturnType<typeof useCreateCustomerEmailDomainMutation>;
export type CreateCustomerEmailDomainMutationResult = Apollo.MutationResult<CreateCustomerEmailDomainMutation>;
export type CreateCustomerEmailDomainMutationOptions = Apollo.BaseMutationOptions<CreateCustomerEmailDomainMutation, CreateCustomerEmailDomainMutationVariables>;
export const CreateMyEnginePresetDocument = gql`
    mutation CreateMyEnginePreset($enginePreset: CreateEnginePresetInput!) {
  createMyEnginePreset(enginePreset: $enginePreset) {
    id
    name
    description
    orderToDeliveryDaysOffset
    weightingMethod
    orderSimulationEndDate
    historicalDatePatterns
    weightingWindowDays
    bindToSKUOverrides
    bindToForecastUpload
    modifyExistingPos
    dyeYieldLoss
    sewYieldLoss
    cutYieldLoss
    weeksOfSupply
    useBufferForecast
    desiredMinWeeksOnHand
    leadTimeInWeeks
    assumedCustomerGrowth
    excludeForecast
    excludeYieldPlan
    truckOrderToPackDays
    onHoldToAvailableDays
    productionStartToEndDays
    darkRoastRuntime
    mediumRoastRuntime
    lightRoastRuntime
    defaultChangeoverTime
    decafChangeoverTime
    turnOnProductionBatching
    organicMillingNextProductionRun
    cnpNextProductionRun
    taraNextProductionRun
    auroraNextProductionRun
    firmWindowLookAhead
    trendLookbackWindow
    default
  }
}
    `;
export type CreateMyEnginePresetMutationFn = Apollo.MutationFunction<CreateMyEnginePresetMutation, CreateMyEnginePresetMutationVariables>;

/**
 * __useCreateMyEnginePresetMutation__
 *
 * To run a mutation, you first call `useCreateMyEnginePresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMyEnginePresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMyEnginePresetMutation, { data, loading, error }] = useCreateMyEnginePresetMutation({
 *   variables: {
 *      enginePreset: // value for 'enginePreset'
 *   },
 * });
 */
export function useCreateMyEnginePresetMutation(baseOptions?: Apollo.MutationHookOptions<CreateMyEnginePresetMutation, CreateMyEnginePresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMyEnginePresetMutation, CreateMyEnginePresetMutationVariables>(CreateMyEnginePresetDocument, options);
      }
export type CreateMyEnginePresetMutationHookResult = ReturnType<typeof useCreateMyEnginePresetMutation>;
export type CreateMyEnginePresetMutationResult = Apollo.MutationResult<CreateMyEnginePresetMutation>;
export type CreateMyEnginePresetMutationOptions = Apollo.BaseMutationOptions<CreateMyEnginePresetMutation, CreateMyEnginePresetMutationVariables>;
export const CreateMyGoodchopPresignUploadUrlDocument = gql`
    mutation CreateMyGoodchopPresignUploadUrl($fileName: String!, $contentType: String!) {
  createMyGoodchopPresignUploadUrl(fileName: $fileName, contentType: $contentType)
}
    `;
export type CreateMyGoodchopPresignUploadUrlMutationFn = Apollo.MutationFunction<CreateMyGoodchopPresignUploadUrlMutation, CreateMyGoodchopPresignUploadUrlMutationVariables>;

/**
 * __useCreateMyGoodchopPresignUploadUrlMutation__
 *
 * To run a mutation, you first call `useCreateMyGoodchopPresignUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMyGoodchopPresignUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMyGoodchopPresignUploadUrlMutation, { data, loading, error }] = useCreateMyGoodchopPresignUploadUrlMutation({
 *   variables: {
 *      fileName: // value for 'fileName'
 *      contentType: // value for 'contentType'
 *   },
 * });
 */
export function useCreateMyGoodchopPresignUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<CreateMyGoodchopPresignUploadUrlMutation, CreateMyGoodchopPresignUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMyGoodchopPresignUploadUrlMutation, CreateMyGoodchopPresignUploadUrlMutationVariables>(CreateMyGoodchopPresignUploadUrlDocument, options);
      }
export type CreateMyGoodchopPresignUploadUrlMutationHookResult = ReturnType<typeof useCreateMyGoodchopPresignUploadUrlMutation>;
export type CreateMyGoodchopPresignUploadUrlMutationResult = Apollo.MutationResult<CreateMyGoodchopPresignUploadUrlMutation>;
export type CreateMyGoodchopPresignUploadUrlMutationOptions = Apollo.BaseMutationOptions<CreateMyGoodchopPresignUploadUrlMutation, CreateMyGoodchopPresignUploadUrlMutationVariables>;
export const CreateOrReplaceFeatureFlagsDocument = gql`
    mutation createOrReplaceFeatureFlags($featureFlags: FeatureFlagsInput!) {
  createOrReplaceFeatureFlags(featureFlags: $featureFlags) {
    EngineRuns
    EngineLegacyDatabase
    StepsUsedForEngineRuns
    StepsExperimentalEngineWorkflow
    StepsRunDetails
    StepsStepDetails
    StepsVariableSets
    EngineRunHistory
    EnginePresets
    EngineLoadLockedDemandForecast
    VarOrderToDeliveryDaysOffset
    VarWeightingMethod
    VarOrderSimulationEndDate
    VarHistoricalDatePatterns
    VarWeightingWindowDays
    VarBindToSKUOverrides
    VarBindToForecastUpload
    VarModifyExistingPos
    VarDyeYieldLoss
    VarSewYieldLoss
    VarCutYieldLoss
    VarWeeksOfSupply
    VarUseBufferForecast
    VarDesiredMinWeeksOnHand
    VarLeadTimeInWeeks
    VarAssumedCustomerGrowth
    VarExcludeForecast
    VarExcludeYieldPlan
    VarTruckOrderToPackDays
    VarOnHoldToAvailableDays
    VarProductionStartToEndDays
    VarDarkRoastRuntime
    VarMediumRoastRuntime
    VarLightRoastRuntime
    VarDefaultChangeoverTime
    VarDecafChangeoverTime
    VarTurnOnProductionBatching
    VarOrganicMillingNextProductionRun
    VarCnpNextProductionRun
    VarTaraNextProductionRun
    VarAauroraNextProductionRun
    VarFirmWindowLookAhead
    VarTrendLookbackWindow
    RunComparison
    ForecastAccuracy
    SkuHierarchyProductCategory
    SkuHierarchyProductType
    SkuHierarchyProductFamily
    SkuHierarchyProductTitle
    InventoryOnHand
    InventoryOnHandInStockTreshold
    InventoryOnHandForecast
    InventoryOnHandInStockRate
    ValidationDashboard
    DarkMode
  }
}
    `;
export type CreateOrReplaceFeatureFlagsMutationFn = Apollo.MutationFunction<CreateOrReplaceFeatureFlagsMutation, CreateOrReplaceFeatureFlagsMutationVariables>;

/**
 * __useCreateOrReplaceFeatureFlagsMutation__
 *
 * To run a mutation, you first call `useCreateOrReplaceFeatureFlagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrReplaceFeatureFlagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrReplaceFeatureFlagsMutation, { data, loading, error }] = useCreateOrReplaceFeatureFlagsMutation({
 *   variables: {
 *      featureFlags: // value for 'featureFlags'
 *   },
 * });
 */
export function useCreateOrReplaceFeatureFlagsMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrReplaceFeatureFlagsMutation, CreateOrReplaceFeatureFlagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrReplaceFeatureFlagsMutation, CreateOrReplaceFeatureFlagsMutationVariables>(CreateOrReplaceFeatureFlagsDocument, options);
      }
export type CreateOrReplaceFeatureFlagsMutationHookResult = ReturnType<typeof useCreateOrReplaceFeatureFlagsMutation>;
export type CreateOrReplaceFeatureFlagsMutationResult = Apollo.MutationResult<CreateOrReplaceFeatureFlagsMutation>;
export type CreateOrReplaceFeatureFlagsMutationOptions = Apollo.BaseMutationOptions<CreateOrReplaceFeatureFlagsMutation, CreateOrReplaceFeatureFlagsMutationVariables>;
export const CreatePowerBiDocument = gql`
    mutation CreatePowerBi($powerBi: CreatePowerBiInput!) {
  createPowerBi(powerBi: $powerBi) {
    id
    powerBi {
      id
      name
      workspaceId
      datasetId
    }
  }
}
    `;
export type CreatePowerBiMutationFn = Apollo.MutationFunction<CreatePowerBiMutation, CreatePowerBiMutationVariables>;

/**
 * __useCreatePowerBiMutation__
 *
 * To run a mutation, you first call `useCreatePowerBiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePowerBiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPowerBiMutation, { data, loading, error }] = useCreatePowerBiMutation({
 *   variables: {
 *      powerBi: // value for 'powerBi'
 *   },
 * });
 */
export function useCreatePowerBiMutation(baseOptions?: Apollo.MutationHookOptions<CreatePowerBiMutation, CreatePowerBiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePowerBiMutation, CreatePowerBiMutationVariables>(CreatePowerBiDocument, options);
      }
export type CreatePowerBiMutationHookResult = ReturnType<typeof useCreatePowerBiMutation>;
export type CreatePowerBiMutationResult = Apollo.MutationResult<CreatePowerBiMutation>;
export type CreatePowerBiMutationOptions = Apollo.BaseMutationOptions<CreatePowerBiMutation, CreatePowerBiMutationVariables>;
export const DeleteCustomerEmailDomainDocument = gql`
    mutation DeleteCustomerEmailDomain($customerId: String!, $emailDomain: String!) {
  deleteCustomerEmailDomain(customerId: $customerId, emailDomain: $emailDomain) {
    id
    emailDomains
  }
}
    `;
export type DeleteCustomerEmailDomainMutationFn = Apollo.MutationFunction<DeleteCustomerEmailDomainMutation, DeleteCustomerEmailDomainMutationVariables>;

/**
 * __useDeleteCustomerEmailDomainMutation__
 *
 * To run a mutation, you first call `useDeleteCustomerEmailDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomerEmailDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomerEmailDomainMutation, { data, loading, error }] = useDeleteCustomerEmailDomainMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      emailDomain: // value for 'emailDomain'
 *   },
 * });
 */
export function useDeleteCustomerEmailDomainMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomerEmailDomainMutation, DeleteCustomerEmailDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomerEmailDomainMutation, DeleteCustomerEmailDomainMutationVariables>(DeleteCustomerEmailDomainDocument, options);
      }
export type DeleteCustomerEmailDomainMutationHookResult = ReturnType<typeof useDeleteCustomerEmailDomainMutation>;
export type DeleteCustomerEmailDomainMutationResult = Apollo.MutationResult<DeleteCustomerEmailDomainMutation>;
export type DeleteCustomerEmailDomainMutationOptions = Apollo.BaseMutationOptions<DeleteCustomerEmailDomainMutation, DeleteCustomerEmailDomainMutationVariables>;
export const GenerateMyPoPdfWithDownloadUrlDocument = gql`
    mutation GenerateMyPoPdfWithDownloadUrl($id: String!) {
  generateMyPoPdfWithDownloadUrl(id: $id)
}
    `;
export type GenerateMyPoPdfWithDownloadUrlMutationFn = Apollo.MutationFunction<GenerateMyPoPdfWithDownloadUrlMutation, GenerateMyPoPdfWithDownloadUrlMutationVariables>;

/**
 * __useGenerateMyPoPdfWithDownloadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateMyPoPdfWithDownloadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateMyPoPdfWithDownloadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateMyPoPdfWithDownloadUrlMutation, { data, loading, error }] = useGenerateMyPoPdfWithDownloadUrlMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGenerateMyPoPdfWithDownloadUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateMyPoPdfWithDownloadUrlMutation, GenerateMyPoPdfWithDownloadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateMyPoPdfWithDownloadUrlMutation, GenerateMyPoPdfWithDownloadUrlMutationVariables>(GenerateMyPoPdfWithDownloadUrlDocument, options);
      }
export type GenerateMyPoPdfWithDownloadUrlMutationHookResult = ReturnType<typeof useGenerateMyPoPdfWithDownloadUrlMutation>;
export type GenerateMyPoPdfWithDownloadUrlMutationResult = Apollo.MutationResult<GenerateMyPoPdfWithDownloadUrlMutation>;
export type GenerateMyPoPdfWithDownloadUrlMutationOptions = Apollo.BaseMutationOptions<GenerateMyPoPdfWithDownloadUrlMutation, GenerateMyPoPdfWithDownloadUrlMutationVariables>;
export const GetAllCustomersDocument = gql`
    query GetAllCustomers {
  getAllCustomers {
    name
    id
  }
}
    `;

/**
 * __useGetAllCustomersQuery__
 *
 * To run a query within a React component, call `useGetAllCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCustomersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllCustomersQuery(baseOptions?: Apollo.QueryHookOptions<GetAllCustomersQuery, GetAllCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCustomersQuery, GetAllCustomersQueryVariables>(GetAllCustomersDocument, options);
      }
export function useGetAllCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCustomersQuery, GetAllCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCustomersQuery, GetAllCustomersQueryVariables>(GetAllCustomersDocument, options);
        }
export function useGetAllCustomersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllCustomersQuery, GetAllCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllCustomersQuery, GetAllCustomersQueryVariables>(GetAllCustomersDocument, options);
        }
export type GetAllCustomersQueryHookResult = ReturnType<typeof useGetAllCustomersQuery>;
export type GetAllCustomersLazyQueryHookResult = ReturnType<typeof useGetAllCustomersLazyQuery>;
export type GetAllCustomersSuspenseQueryHookResult = ReturnType<typeof useGetAllCustomersSuspenseQuery>;
export type GetAllCustomersQueryResult = Apollo.QueryResult<GetAllCustomersQuery, GetAllCustomersQueryVariables>;
export const GetCustomerDocument = gql`
    query GetCustomer($customerId: String!) {
  getCustomer(customerId: $customerId) {
    name
    id
    features {
      EngineRuns
      EngineLegacyDatabase
      StepsUsedForEngineRuns
      StepsExperimentalEngineWorkflow
      StepsRunDetails
      StepsStepDetails
      StepsVariableSets
      EngineRunHistory
      EnginePresets
      EngineLoadLockedDemandForecast
      VarOrderToDeliveryDaysOffset
      VarWeightingMethod
      VarOrderSimulationEndDate
      VarHistoricalDatePatterns
      VarWeightingWindowDays
      VarBindToSKUOverrides
      VarBindToForecastUpload
      VarModifyExistingPos
      VarDyeYieldLoss
      VarSewYieldLoss
      VarCutYieldLoss
      VarWeeksOfSupply
      VarUseBufferForecast
      VarDesiredMinWeeksOnHand
      VarLeadTimeInWeeks
      VarAssumedCustomerGrowth
      VarExcludeForecast
      VarExcludeYieldPlan
      VarTruckOrderToPackDays
      VarOnHoldToAvailableDays
      VarProductionStartToEndDays
      VarDarkRoastRuntime
      VarMediumRoastRuntime
      VarLightRoastRuntime
      VarDefaultChangeoverTime
      VarDecafChangeoverTime
      VarTurnOnProductionBatching
      VarOrganicMillingNextProductionRun
      VarCnpNextProductionRun
      VarTaraNextProductionRun
      VarAauroraNextProductionRun
      VarFirmWindowLookAhead
      VarTrendLookbackWindow
      RunComparison
      ForecastAccuracy
      SkuHierarchyProductCategory
      SkuHierarchyProductType
      SkuHierarchyProductFamily
      SkuHierarchyProductTitle
      InventoryOnHand
      InventoryOnHandInStockTreshold
      InventoryOnHandForecast
      InventoryOnHandInStockRate
      InventoryOnHandBeans
      ValidationDashboard
      DarkMode
      PoInbox
    }
    emailDomains
    powerBi {
      id
      name
      workspaceId
      datasetId
      enabled
    }
    defaultRole
  }
}
    `;

/**
 * __useGetCustomerQuery__
 *
 * To run a query within a React component, call `useGetCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetCustomerQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
      }
export function useGetCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
        }
export function useGetCustomerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
        }
export type GetCustomerQueryHookResult = ReturnType<typeof useGetCustomerQuery>;
export type GetCustomerLazyQueryHookResult = ReturnType<typeof useGetCustomerLazyQuery>;
export type GetCustomerSuspenseQueryHookResult = ReturnType<typeof useGetCustomerSuspenseQuery>;
export type GetCustomerQueryResult = Apollo.QueryResult<GetCustomerQuery, GetCustomerQueryVariables>;
export const GetLatestOrchestratorRunsDocument = gql`
    query GetLatestOrchestratorRuns {
  getLatestOrchestratorRuns {
    id
    runSettings {
      inputId
      workflowId
      variablesId
      runAttemptId
    }
    status
    createdAt
    updatedAt
    initiatedBy
    name
    description
    locked
    usesLockedInputId
    usesLockedVariablesId
    oldLockedRunId
    runParamsJson
    oldRunId
    customerId
  }
}
    `;

/**
 * __useGetLatestOrchestratorRunsQuery__
 *
 * To run a query within a React component, call `useGetLatestOrchestratorRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestOrchestratorRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestOrchestratorRunsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLatestOrchestratorRunsQuery(baseOptions?: Apollo.QueryHookOptions<GetLatestOrchestratorRunsQuery, GetLatestOrchestratorRunsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestOrchestratorRunsQuery, GetLatestOrchestratorRunsQueryVariables>(GetLatestOrchestratorRunsDocument, options);
      }
export function useGetLatestOrchestratorRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestOrchestratorRunsQuery, GetLatestOrchestratorRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestOrchestratorRunsQuery, GetLatestOrchestratorRunsQueryVariables>(GetLatestOrchestratorRunsDocument, options);
        }
export function useGetLatestOrchestratorRunsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLatestOrchestratorRunsQuery, GetLatestOrchestratorRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLatestOrchestratorRunsQuery, GetLatestOrchestratorRunsQueryVariables>(GetLatestOrchestratorRunsDocument, options);
        }
export type GetLatestOrchestratorRunsQueryHookResult = ReturnType<typeof useGetLatestOrchestratorRunsQuery>;
export type GetLatestOrchestratorRunsLazyQueryHookResult = ReturnType<typeof useGetLatestOrchestratorRunsLazyQuery>;
export type GetLatestOrchestratorRunsSuspenseQueryHookResult = ReturnType<typeof useGetLatestOrchestratorRunsSuspenseQuery>;
export type GetLatestOrchestratorRunsQueryResult = Apollo.QueryResult<GetLatestOrchestratorRunsQuery, GetLatestOrchestratorRunsQueryVariables>;
export const GetMyCustomerDocument = gql`
    query GetMyCustomer {
  getMyCustomer {
    name
    id
    powerBi {
      id
      name
      workspaceId
    }
    features {
      EngineRuns
      EngineLegacyDatabase
      StepsUsedForEngineRuns
      StepsExperimentalEngineWorkflow
      StepsRunDetails
      StepsStepDetails
      StepsVariableSets
      EngineRunHistory
      EnginePresets
      EngineLoadLockedDemandForecast
      VarOrderToDeliveryDaysOffset
      VarWeightingMethod
      VarOrderSimulationEndDate
      VarHistoricalDatePatterns
      VarWeightingWindowDays
      VarBindToSKUOverrides
      VarBindToForecastUpload
      VarModifyExistingPos
      VarDyeYieldLoss
      VarSewYieldLoss
      VarCutYieldLoss
      VarWeeksOfSupply
      VarUseBufferForecast
      VarDesiredMinWeeksOnHand
      VarLeadTimeInWeeks
      VarAssumedCustomerGrowth
      VarExcludeForecast
      VarExcludeYieldPlan
      VarTruckOrderToPackDays
      VarOnHoldToAvailableDays
      VarProductionStartToEndDays
      VarDarkRoastRuntime
      VarMediumRoastRuntime
      VarLightRoastRuntime
      VarDefaultChangeoverTime
      VarDecafChangeoverTime
      VarTurnOnProductionBatching
      VarOrganicMillingNextProductionRun
      VarCnpNextProductionRun
      VarTaraNextProductionRun
      VarAauroraNextProductionRun
      VarFirmWindowLookAhead
      VarTrendLookbackWindow
      RunComparison
      ForecastAccuracy
      SkuHierarchyProductCategory
      SkuHierarchyProductType
      SkuHierarchyProductFamily
      SkuHierarchyProductTitle
      InventoryOnHand
      InventoryOnHandInStockTreshold
      InventoryOnHandForecast
      InventoryOnHandInStockRate
      InventoryOnHandBeans
      ValidationDashboard
      DarkMode
      PoInbox
    }
    ej2License
    muiLicense
  }
}
    `;

/**
 * __useGetMyCustomerQuery__
 *
 * To run a query within a React component, call `useGetMyCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyCustomerQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyCustomerQuery(baseOptions?: Apollo.QueryHookOptions<GetMyCustomerQuery, GetMyCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyCustomerQuery, GetMyCustomerQueryVariables>(GetMyCustomerDocument, options);
      }
export function useGetMyCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyCustomerQuery, GetMyCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyCustomerQuery, GetMyCustomerQueryVariables>(GetMyCustomerDocument, options);
        }
export function useGetMyCustomerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyCustomerQuery, GetMyCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyCustomerQuery, GetMyCustomerQueryVariables>(GetMyCustomerDocument, options);
        }
export type GetMyCustomerQueryHookResult = ReturnType<typeof useGetMyCustomerQuery>;
export type GetMyCustomerLazyQueryHookResult = ReturnType<typeof useGetMyCustomerLazyQuery>;
export type GetMyCustomerSuspenseQueryHookResult = ReturnType<typeof useGetMyCustomerSuspenseQuery>;
export type GetMyCustomerQueryResult = Apollo.QueryResult<GetMyCustomerQuery, GetMyCustomerQueryVariables>;
export const GetMyDemandMonthlyDiffUrlDocument = gql`
    query GetMyDemandMonthlyDiffUrl($engineRunId0: Int!, $engineRunId1: Int!) {
  getMyDemandMonthlyDiffUrl(
    engineRunId0: $engineRunId0
    engineRunId1: $engineRunId1
  )
}
    `;

/**
 * __useGetMyDemandMonthlyDiffUrlQuery__
 *
 * To run a query within a React component, call `useGetMyDemandMonthlyDiffUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyDemandMonthlyDiffUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyDemandMonthlyDiffUrlQuery({
 *   variables: {
 *      engineRunId0: // value for 'engineRunId0'
 *      engineRunId1: // value for 'engineRunId1'
 *   },
 * });
 */
export function useGetMyDemandMonthlyDiffUrlQuery(baseOptions: Apollo.QueryHookOptions<GetMyDemandMonthlyDiffUrlQuery, GetMyDemandMonthlyDiffUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyDemandMonthlyDiffUrlQuery, GetMyDemandMonthlyDiffUrlQueryVariables>(GetMyDemandMonthlyDiffUrlDocument, options);
      }
export function useGetMyDemandMonthlyDiffUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyDemandMonthlyDiffUrlQuery, GetMyDemandMonthlyDiffUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyDemandMonthlyDiffUrlQuery, GetMyDemandMonthlyDiffUrlQueryVariables>(GetMyDemandMonthlyDiffUrlDocument, options);
        }
export function useGetMyDemandMonthlyDiffUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyDemandMonthlyDiffUrlQuery, GetMyDemandMonthlyDiffUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyDemandMonthlyDiffUrlQuery, GetMyDemandMonthlyDiffUrlQueryVariables>(GetMyDemandMonthlyDiffUrlDocument, options);
        }
export type GetMyDemandMonthlyDiffUrlQueryHookResult = ReturnType<typeof useGetMyDemandMonthlyDiffUrlQuery>;
export type GetMyDemandMonthlyDiffUrlLazyQueryHookResult = ReturnType<typeof useGetMyDemandMonthlyDiffUrlLazyQuery>;
export type GetMyDemandMonthlyDiffUrlSuspenseQueryHookResult = ReturnType<typeof useGetMyDemandMonthlyDiffUrlSuspenseQuery>;
export type GetMyDemandMonthlyDiffUrlQueryResult = Apollo.QueryResult<GetMyDemandMonthlyDiffUrlQuery, GetMyDemandMonthlyDiffUrlQueryVariables>;
export const GetMyDemandMonthlyUrlDocument = gql`
    query GetMyDemandMonthlyUrl($engineRunId: Int!) {
  getMyDemandMonthlyUrl(engineRunId: $engineRunId)
}
    `;

/**
 * __useGetMyDemandMonthlyUrlQuery__
 *
 * To run a query within a React component, call `useGetMyDemandMonthlyUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyDemandMonthlyUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyDemandMonthlyUrlQuery({
 *   variables: {
 *      engineRunId: // value for 'engineRunId'
 *   },
 * });
 */
export function useGetMyDemandMonthlyUrlQuery(baseOptions: Apollo.QueryHookOptions<GetMyDemandMonthlyUrlQuery, GetMyDemandMonthlyUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyDemandMonthlyUrlQuery, GetMyDemandMonthlyUrlQueryVariables>(GetMyDemandMonthlyUrlDocument, options);
      }
export function useGetMyDemandMonthlyUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyDemandMonthlyUrlQuery, GetMyDemandMonthlyUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyDemandMonthlyUrlQuery, GetMyDemandMonthlyUrlQueryVariables>(GetMyDemandMonthlyUrlDocument, options);
        }
export function useGetMyDemandMonthlyUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyDemandMonthlyUrlQuery, GetMyDemandMonthlyUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyDemandMonthlyUrlQuery, GetMyDemandMonthlyUrlQueryVariables>(GetMyDemandMonthlyUrlDocument, options);
        }
export type GetMyDemandMonthlyUrlQueryHookResult = ReturnType<typeof useGetMyDemandMonthlyUrlQuery>;
export type GetMyDemandMonthlyUrlLazyQueryHookResult = ReturnType<typeof useGetMyDemandMonthlyUrlLazyQuery>;
export type GetMyDemandMonthlyUrlSuspenseQueryHookResult = ReturnType<typeof useGetMyDemandMonthlyUrlSuspenseQuery>;
export type GetMyDemandMonthlyUrlQueryResult = Apollo.QueryResult<GetMyDemandMonthlyUrlQuery, GetMyDemandMonthlyUrlQueryVariables>;
export const GetMyDemandWeeklyUrlDocument = gql`
    query GetMyDemandWeeklyUrl($engineRunId: Int!) {
  getMyDemandWeeklyUrl(engineRunId: $engineRunId)
}
    `;

/**
 * __useGetMyDemandWeeklyUrlQuery__
 *
 * To run a query within a React component, call `useGetMyDemandWeeklyUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyDemandWeeklyUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyDemandWeeklyUrlQuery({
 *   variables: {
 *      engineRunId: // value for 'engineRunId'
 *   },
 * });
 */
export function useGetMyDemandWeeklyUrlQuery(baseOptions: Apollo.QueryHookOptions<GetMyDemandWeeklyUrlQuery, GetMyDemandWeeklyUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyDemandWeeklyUrlQuery, GetMyDemandWeeklyUrlQueryVariables>(GetMyDemandWeeklyUrlDocument, options);
      }
export function useGetMyDemandWeeklyUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyDemandWeeklyUrlQuery, GetMyDemandWeeklyUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyDemandWeeklyUrlQuery, GetMyDemandWeeklyUrlQueryVariables>(GetMyDemandWeeklyUrlDocument, options);
        }
export function useGetMyDemandWeeklyUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyDemandWeeklyUrlQuery, GetMyDemandWeeklyUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyDemandWeeklyUrlQuery, GetMyDemandWeeklyUrlQueryVariables>(GetMyDemandWeeklyUrlDocument, options);
        }
export type GetMyDemandWeeklyUrlQueryHookResult = ReturnType<typeof useGetMyDemandWeeklyUrlQuery>;
export type GetMyDemandWeeklyUrlLazyQueryHookResult = ReturnType<typeof useGetMyDemandWeeklyUrlLazyQuery>;
export type GetMyDemandWeeklyUrlSuspenseQueryHookResult = ReturnType<typeof useGetMyDemandWeeklyUrlSuspenseQuery>;
export type GetMyDemandWeeklyUrlQueryResult = Apollo.QueryResult<GetMyDemandWeeklyUrlQuery, GetMyDemandWeeklyUrlQueryVariables>;
export const GetMyEnginePresetsDocument = gql`
    query GetMyEnginePresets {
  getMyEnginePresets {
    id
    name
    description
    orderToDeliveryDaysOffset
    weightingMethod
    orderSimulationEndDate
    historicalDatePatterns
    weightingWindowDays
    bindToSKUOverrides
    bindToForecastUpload
    modifyExistingPos
    dyeYieldLoss
    sewYieldLoss
    cutYieldLoss
    weeksOfSupply
    useBufferForecast
    desiredMinWeeksOnHand
    leadTimeInWeeks
    assumedCustomerGrowth
    excludeForecast
    excludeYieldPlan
    truckOrderToPackDays
    onHoldToAvailableDays
    productionStartToEndDays
    darkRoastRuntime
    mediumRoastRuntime
    lightRoastRuntime
    defaultChangeoverTime
    decafChangeoverTime
    turnOnProductionBatching
    organicMillingNextProductionRun
    cnpNextProductionRun
    taraNextProductionRun
    auroraNextProductionRun
    firmWindowLookAhead
    trendLookbackWindow
    default
  }
}
    `;

/**
 * __useGetMyEnginePresetsQuery__
 *
 * To run a query within a React component, call `useGetMyEnginePresetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyEnginePresetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyEnginePresetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyEnginePresetsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyEnginePresetsQuery, GetMyEnginePresetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyEnginePresetsQuery, GetMyEnginePresetsQueryVariables>(GetMyEnginePresetsDocument, options);
      }
export function useGetMyEnginePresetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyEnginePresetsQuery, GetMyEnginePresetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyEnginePresetsQuery, GetMyEnginePresetsQueryVariables>(GetMyEnginePresetsDocument, options);
        }
export function useGetMyEnginePresetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyEnginePresetsQuery, GetMyEnginePresetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyEnginePresetsQuery, GetMyEnginePresetsQueryVariables>(GetMyEnginePresetsDocument, options);
        }
export type GetMyEnginePresetsQueryHookResult = ReturnType<typeof useGetMyEnginePresetsQuery>;
export type GetMyEnginePresetsLazyQueryHookResult = ReturnType<typeof useGetMyEnginePresetsLazyQuery>;
export type GetMyEnginePresetsSuspenseQueryHookResult = ReturnType<typeof useGetMyEnginePresetsSuspenseQuery>;
export type GetMyEnginePresetsQueryResult = Apollo.QueryResult<GetMyEnginePresetsQuery, GetMyEnginePresetsQueryVariables>;
export const GetMyForecastAccuracyUrlDocument = gql`
    query GetMyForecastAccuracyUrl($actualsEngineRunId: Int!, $forecastEngineRunId: Int!, $minDate: String, $maxDate: String) {
  getMyForecastAccuracyUrl(
    actualsEngineRunId: $actualsEngineRunId
    forecastEngineRunId: $forecastEngineRunId
    minDate: $minDate
    maxDate: $maxDate
  )
}
    `;

/**
 * __useGetMyForecastAccuracyUrlQuery__
 *
 * To run a query within a React component, call `useGetMyForecastAccuracyUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyForecastAccuracyUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyForecastAccuracyUrlQuery({
 *   variables: {
 *      actualsEngineRunId: // value for 'actualsEngineRunId'
 *      forecastEngineRunId: // value for 'forecastEngineRunId'
 *      minDate: // value for 'minDate'
 *      maxDate: // value for 'maxDate'
 *   },
 * });
 */
export function useGetMyForecastAccuracyUrlQuery(baseOptions: Apollo.QueryHookOptions<GetMyForecastAccuracyUrlQuery, GetMyForecastAccuracyUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyForecastAccuracyUrlQuery, GetMyForecastAccuracyUrlQueryVariables>(GetMyForecastAccuracyUrlDocument, options);
      }
export function useGetMyForecastAccuracyUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyForecastAccuracyUrlQuery, GetMyForecastAccuracyUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyForecastAccuracyUrlQuery, GetMyForecastAccuracyUrlQueryVariables>(GetMyForecastAccuracyUrlDocument, options);
        }
export function useGetMyForecastAccuracyUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyForecastAccuracyUrlQuery, GetMyForecastAccuracyUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyForecastAccuracyUrlQuery, GetMyForecastAccuracyUrlQueryVariables>(GetMyForecastAccuracyUrlDocument, options);
        }
export type GetMyForecastAccuracyUrlQueryHookResult = ReturnType<typeof useGetMyForecastAccuracyUrlQuery>;
export type GetMyForecastAccuracyUrlLazyQueryHookResult = ReturnType<typeof useGetMyForecastAccuracyUrlLazyQuery>;
export type GetMyForecastAccuracyUrlSuspenseQueryHookResult = ReturnType<typeof useGetMyForecastAccuracyUrlSuspenseQuery>;
export type GetMyForecastAccuracyUrlQueryResult = Apollo.QueryResult<GetMyForecastAccuracyUrlQuery, GetMyForecastAccuracyUrlQueryVariables>;
export const GetMyGoodchopOdlTaskDocument = gql`
    query GetMyGoodchopOdlTask($taskId: String!) {
  getMyGoodchopOdlTask(taskId: $taskId) {
    updatedAt
    createdAt
    status
    error
    fileName
    id
  }
}
    `;

/**
 * __useGetMyGoodchopOdlTaskQuery__
 *
 * To run a query within a React component, call `useGetMyGoodchopOdlTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyGoodchopOdlTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyGoodchopOdlTaskQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetMyGoodchopOdlTaskQuery(baseOptions: Apollo.QueryHookOptions<GetMyGoodchopOdlTaskQuery, GetMyGoodchopOdlTaskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyGoodchopOdlTaskQuery, GetMyGoodchopOdlTaskQueryVariables>(GetMyGoodchopOdlTaskDocument, options);
      }
export function useGetMyGoodchopOdlTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyGoodchopOdlTaskQuery, GetMyGoodchopOdlTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyGoodchopOdlTaskQuery, GetMyGoodchopOdlTaskQueryVariables>(GetMyGoodchopOdlTaskDocument, options);
        }
export function useGetMyGoodchopOdlTaskSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyGoodchopOdlTaskQuery, GetMyGoodchopOdlTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyGoodchopOdlTaskQuery, GetMyGoodchopOdlTaskQueryVariables>(GetMyGoodchopOdlTaskDocument, options);
        }
export type GetMyGoodchopOdlTaskQueryHookResult = ReturnType<typeof useGetMyGoodchopOdlTaskQuery>;
export type GetMyGoodchopOdlTaskLazyQueryHookResult = ReturnType<typeof useGetMyGoodchopOdlTaskLazyQuery>;
export type GetMyGoodchopOdlTaskSuspenseQueryHookResult = ReturnType<typeof useGetMyGoodchopOdlTaskSuspenseQuery>;
export type GetMyGoodchopOdlTaskQueryResult = Apollo.QueryResult<GetMyGoodchopOdlTaskQuery, GetMyGoodchopOdlTaskQueryVariables>;
export const GetMyGoodchopTransformedDataUrlsDocument = gql`
    query GetMyGoodchopTransformedDataUrls($page: Int) {
  getMyGoodchopOdlTransformedDataUrls(page: $page) {
    data {
      url
      size
      lastModified
    }
    page
    totalPages
  }
}
    `;

/**
 * __useGetMyGoodchopTransformedDataUrlsQuery__
 *
 * To run a query within a React component, call `useGetMyGoodchopTransformedDataUrlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyGoodchopTransformedDataUrlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyGoodchopTransformedDataUrlsQuery({
 *   variables: {
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetMyGoodchopTransformedDataUrlsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyGoodchopTransformedDataUrlsQuery, GetMyGoodchopTransformedDataUrlsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyGoodchopTransformedDataUrlsQuery, GetMyGoodchopTransformedDataUrlsQueryVariables>(GetMyGoodchopTransformedDataUrlsDocument, options);
      }
export function useGetMyGoodchopTransformedDataUrlsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyGoodchopTransformedDataUrlsQuery, GetMyGoodchopTransformedDataUrlsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyGoodchopTransformedDataUrlsQuery, GetMyGoodchopTransformedDataUrlsQueryVariables>(GetMyGoodchopTransformedDataUrlsDocument, options);
        }
export function useGetMyGoodchopTransformedDataUrlsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyGoodchopTransformedDataUrlsQuery, GetMyGoodchopTransformedDataUrlsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyGoodchopTransformedDataUrlsQuery, GetMyGoodchopTransformedDataUrlsQueryVariables>(GetMyGoodchopTransformedDataUrlsDocument, options);
        }
export type GetMyGoodchopTransformedDataUrlsQueryHookResult = ReturnType<typeof useGetMyGoodchopTransformedDataUrlsQuery>;
export type GetMyGoodchopTransformedDataUrlsLazyQueryHookResult = ReturnType<typeof useGetMyGoodchopTransformedDataUrlsLazyQuery>;
export type GetMyGoodchopTransformedDataUrlsSuspenseQueryHookResult = ReturnType<typeof useGetMyGoodchopTransformedDataUrlsSuspenseQuery>;
export type GetMyGoodchopTransformedDataUrlsQueryResult = Apollo.QueryResult<GetMyGoodchopTransformedDataUrlsQuery, GetMyGoodchopTransformedDataUrlsQueryVariables>;
export const GetMyInventoryOnHandBeansUrlsDocument = gql`
    query GetMyInventoryOnHandBeansUrls {
  getMyInventoryOnHandBeansUrls {
    id
    date
    url
  }
}
    `;

/**
 * __useGetMyInventoryOnHandBeansUrlsQuery__
 *
 * To run a query within a React component, call `useGetMyInventoryOnHandBeansUrlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyInventoryOnHandBeansUrlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyInventoryOnHandBeansUrlsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyInventoryOnHandBeansUrlsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyInventoryOnHandBeansUrlsQuery, GetMyInventoryOnHandBeansUrlsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyInventoryOnHandBeansUrlsQuery, GetMyInventoryOnHandBeansUrlsQueryVariables>(GetMyInventoryOnHandBeansUrlsDocument, options);
      }
export function useGetMyInventoryOnHandBeansUrlsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyInventoryOnHandBeansUrlsQuery, GetMyInventoryOnHandBeansUrlsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyInventoryOnHandBeansUrlsQuery, GetMyInventoryOnHandBeansUrlsQueryVariables>(GetMyInventoryOnHandBeansUrlsDocument, options);
        }
export function useGetMyInventoryOnHandBeansUrlsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyInventoryOnHandBeansUrlsQuery, GetMyInventoryOnHandBeansUrlsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyInventoryOnHandBeansUrlsQuery, GetMyInventoryOnHandBeansUrlsQueryVariables>(GetMyInventoryOnHandBeansUrlsDocument, options);
        }
export type GetMyInventoryOnHandBeansUrlsQueryHookResult = ReturnType<typeof useGetMyInventoryOnHandBeansUrlsQuery>;
export type GetMyInventoryOnHandBeansUrlsLazyQueryHookResult = ReturnType<typeof useGetMyInventoryOnHandBeansUrlsLazyQuery>;
export type GetMyInventoryOnHandBeansUrlsSuspenseQueryHookResult = ReturnType<typeof useGetMyInventoryOnHandBeansUrlsSuspenseQuery>;
export type GetMyInventoryOnHandBeansUrlsQueryResult = Apollo.QueryResult<GetMyInventoryOnHandBeansUrlsQuery, GetMyInventoryOnHandBeansUrlsQueryVariables>;
export const GetMyInventoryOnHandForecastUrlsDocument = gql`
    query GetMyInventoryOnHandForecastUrls {
  getMyInventoryOnHandForecastUrls {
    id
    url
  }
}
    `;

/**
 * __useGetMyInventoryOnHandForecastUrlsQuery__
 *
 * To run a query within a React component, call `useGetMyInventoryOnHandForecastUrlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyInventoryOnHandForecastUrlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyInventoryOnHandForecastUrlsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyInventoryOnHandForecastUrlsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyInventoryOnHandForecastUrlsQuery, GetMyInventoryOnHandForecastUrlsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyInventoryOnHandForecastUrlsQuery, GetMyInventoryOnHandForecastUrlsQueryVariables>(GetMyInventoryOnHandForecastUrlsDocument, options);
      }
export function useGetMyInventoryOnHandForecastUrlsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyInventoryOnHandForecastUrlsQuery, GetMyInventoryOnHandForecastUrlsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyInventoryOnHandForecastUrlsQuery, GetMyInventoryOnHandForecastUrlsQueryVariables>(GetMyInventoryOnHandForecastUrlsDocument, options);
        }
export function useGetMyInventoryOnHandForecastUrlsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyInventoryOnHandForecastUrlsQuery, GetMyInventoryOnHandForecastUrlsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyInventoryOnHandForecastUrlsQuery, GetMyInventoryOnHandForecastUrlsQueryVariables>(GetMyInventoryOnHandForecastUrlsDocument, options);
        }
export type GetMyInventoryOnHandForecastUrlsQueryHookResult = ReturnType<typeof useGetMyInventoryOnHandForecastUrlsQuery>;
export type GetMyInventoryOnHandForecastUrlsLazyQueryHookResult = ReturnType<typeof useGetMyInventoryOnHandForecastUrlsLazyQuery>;
export type GetMyInventoryOnHandForecastUrlsSuspenseQueryHookResult = ReturnType<typeof useGetMyInventoryOnHandForecastUrlsSuspenseQuery>;
export type GetMyInventoryOnHandForecastUrlsQueryResult = Apollo.QueryResult<GetMyInventoryOnHandForecastUrlsQuery, GetMyInventoryOnHandForecastUrlsQueryVariables>;
export const GetMyInventoryOnHandUrlsDocument = gql`
    query GetMyInventoryOnHandUrls {
  getMyInventoryOnHandUrls {
    id
    date
    url
  }
}
    `;

/**
 * __useGetMyInventoryOnHandUrlsQuery__
 *
 * To run a query within a React component, call `useGetMyInventoryOnHandUrlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyInventoryOnHandUrlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyInventoryOnHandUrlsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyInventoryOnHandUrlsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyInventoryOnHandUrlsQuery, GetMyInventoryOnHandUrlsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyInventoryOnHandUrlsQuery, GetMyInventoryOnHandUrlsQueryVariables>(GetMyInventoryOnHandUrlsDocument, options);
      }
export function useGetMyInventoryOnHandUrlsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyInventoryOnHandUrlsQuery, GetMyInventoryOnHandUrlsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyInventoryOnHandUrlsQuery, GetMyInventoryOnHandUrlsQueryVariables>(GetMyInventoryOnHandUrlsDocument, options);
        }
export function useGetMyInventoryOnHandUrlsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyInventoryOnHandUrlsQuery, GetMyInventoryOnHandUrlsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyInventoryOnHandUrlsQuery, GetMyInventoryOnHandUrlsQueryVariables>(GetMyInventoryOnHandUrlsDocument, options);
        }
export type GetMyInventoryOnHandUrlsQueryHookResult = ReturnType<typeof useGetMyInventoryOnHandUrlsQuery>;
export type GetMyInventoryOnHandUrlsLazyQueryHookResult = ReturnType<typeof useGetMyInventoryOnHandUrlsLazyQuery>;
export type GetMyInventoryOnHandUrlsSuspenseQueryHookResult = ReturnType<typeof useGetMyInventoryOnHandUrlsSuspenseQuery>;
export type GetMyInventoryOnHandUrlsQueryResult = Apollo.QueryResult<GetMyInventoryOnHandUrlsQuery, GetMyInventoryOnHandUrlsQueryVariables>;
export const GetMyLockedEngineRunIdDocument = gql`
    query GetMyLockedEngineRunId {
  getMyLockedEngineRunId
}
    `;

/**
 * __useGetMyLockedEngineRunIdQuery__
 *
 * To run a query within a React component, call `useGetMyLockedEngineRunIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyLockedEngineRunIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyLockedEngineRunIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyLockedEngineRunIdQuery(baseOptions?: Apollo.QueryHookOptions<GetMyLockedEngineRunIdQuery, GetMyLockedEngineRunIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyLockedEngineRunIdQuery, GetMyLockedEngineRunIdQueryVariables>(GetMyLockedEngineRunIdDocument, options);
      }
export function useGetMyLockedEngineRunIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyLockedEngineRunIdQuery, GetMyLockedEngineRunIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyLockedEngineRunIdQuery, GetMyLockedEngineRunIdQueryVariables>(GetMyLockedEngineRunIdDocument, options);
        }
export function useGetMyLockedEngineRunIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyLockedEngineRunIdQuery, GetMyLockedEngineRunIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyLockedEngineRunIdQuery, GetMyLockedEngineRunIdQueryVariables>(GetMyLockedEngineRunIdDocument, options);
        }
export type GetMyLockedEngineRunIdQueryHookResult = ReturnType<typeof useGetMyLockedEngineRunIdQuery>;
export type GetMyLockedEngineRunIdLazyQueryHookResult = ReturnType<typeof useGetMyLockedEngineRunIdLazyQuery>;
export type GetMyLockedEngineRunIdSuspenseQueryHookResult = ReturnType<typeof useGetMyLockedEngineRunIdSuspenseQuery>;
export type GetMyLockedEngineRunIdQueryResult = Apollo.QueryResult<GetMyLockedEngineRunIdQuery, GetMyLockedEngineRunIdQueryVariables>;
export const GetMyLocationsDocument = gql`
    query GetMyLocations {
  getMyLocations {
    id
    address
    address_override
    email
  }
}
    `;

/**
 * __useGetMyLocationsQuery__
 *
 * To run a query within a React component, call `useGetMyLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyLocationsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyLocationsQuery, GetMyLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyLocationsQuery, GetMyLocationsQueryVariables>(GetMyLocationsDocument, options);
      }
export function useGetMyLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyLocationsQuery, GetMyLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyLocationsQuery, GetMyLocationsQueryVariables>(GetMyLocationsDocument, options);
        }
export function useGetMyLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyLocationsQuery, GetMyLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyLocationsQuery, GetMyLocationsQueryVariables>(GetMyLocationsDocument, options);
        }
export type GetMyLocationsQueryHookResult = ReturnType<typeof useGetMyLocationsQuery>;
export type GetMyLocationsLazyQueryHookResult = ReturnType<typeof useGetMyLocationsLazyQuery>;
export type GetMyLocationsSuspenseQueryHookResult = ReturnType<typeof useGetMyLocationsSuspenseQuery>;
export type GetMyLocationsQueryResult = Apollo.QueryResult<GetMyLocationsQuery, GetMyLocationsQueryVariables>;
export const GetMyLockedDemandOutputRunIdsDocument = gql`
    query GetMyLockedDemandOutputRunIds {
  getMyLockedDemandOutputRunIds
}
    `;

/**
 * __useGetMyLockedDemandOutputRunIdsQuery__
 *
 * To run a query within a React component, call `useGetMyLockedDemandOutputRunIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyLockedDemandOutputRunIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyLockedDemandOutputRunIdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyLockedDemandOutputRunIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyLockedDemandOutputRunIdsQuery, GetMyLockedDemandOutputRunIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyLockedDemandOutputRunIdsQuery, GetMyLockedDemandOutputRunIdsQueryVariables>(GetMyLockedDemandOutputRunIdsDocument, options);
      }
export function useGetMyLockedDemandOutputRunIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyLockedDemandOutputRunIdsQuery, GetMyLockedDemandOutputRunIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyLockedDemandOutputRunIdsQuery, GetMyLockedDemandOutputRunIdsQueryVariables>(GetMyLockedDemandOutputRunIdsDocument, options);
        }
export function useGetMyLockedDemandOutputRunIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyLockedDemandOutputRunIdsQuery, GetMyLockedDemandOutputRunIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyLockedDemandOutputRunIdsQuery, GetMyLockedDemandOutputRunIdsQueryVariables>(GetMyLockedDemandOutputRunIdsDocument, options);
        }
export type GetMyLockedDemandOutputRunIdsQueryHookResult = ReturnType<typeof useGetMyLockedDemandOutputRunIdsQuery>;
export type GetMyLockedDemandOutputRunIdsLazyQueryHookResult = ReturnType<typeof useGetMyLockedDemandOutputRunIdsLazyQuery>;
export type GetMyLockedDemandOutputRunIdsSuspenseQueryHookResult = ReturnType<typeof useGetMyLockedDemandOutputRunIdsSuspenseQuery>;
export type GetMyLockedDemandOutputRunIdsQueryResult = Apollo.QueryResult<GetMyLockedDemandOutputRunIdsQuery, GetMyLockedDemandOutputRunIdsQueryVariables>;
export const GetMyLogoDocument = gql`
    query GetMyLogo {
  getMyLogo {
    logo_name
    img_b64
  }
}
    `;

/**
 * __useGetMyLogoQuery__
 *
 * To run a query within a React component, call `useGetMyLogoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyLogoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyLogoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyLogoQuery(baseOptions?: Apollo.QueryHookOptions<GetMyLogoQuery, GetMyLogoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyLogoQuery, GetMyLogoQueryVariables>(GetMyLogoDocument, options);
      }
export function useGetMyLogoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyLogoQuery, GetMyLogoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyLogoQuery, GetMyLogoQueryVariables>(GetMyLogoDocument, options);
        }
export function useGetMyLogoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyLogoQuery, GetMyLogoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyLogoQuery, GetMyLogoQueryVariables>(GetMyLogoDocument, options);
        }
export type GetMyLogoQueryHookResult = ReturnType<typeof useGetMyLogoQuery>;
export type GetMyLogoLazyQueryHookResult = ReturnType<typeof useGetMyLogoLazyQuery>;
export type GetMyLogoSuspenseQueryHookResult = ReturnType<typeof useGetMyLogoSuspenseQuery>;
export type GetMyLogoQueryResult = Apollo.QueryResult<GetMyLogoQuery, GetMyLogoQueryVariables>;
export const GetMyOrchestratorRunsDocument = gql`
    query GetMyOrchestratorRuns($limit: Int, $offset: Int) {
  getMyOrchestratorRuns(limit: $limit, offset: $offset) {
    id
    runSettings {
      inputId
      workflowId
      variablesId
      runAttemptId
    }
    status
    createdAt
    updatedAt
    stepIds
    initiatedBy
    name
    description
    locked
    usesLockedInputId
    usesLockedVariablesId
    oldLockedRunId
    runParamsJson
    oldRunId
  }
}
    `;

/**
 * __useGetMyOrchestratorRunsQuery__
 *
 * To run a query within a React component, call `useGetMyOrchestratorRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyOrchestratorRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyOrchestratorRunsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetMyOrchestratorRunsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyOrchestratorRunsQuery, GetMyOrchestratorRunsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyOrchestratorRunsQuery, GetMyOrchestratorRunsQueryVariables>(GetMyOrchestratorRunsDocument, options);
      }
export function useGetMyOrchestratorRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyOrchestratorRunsQuery, GetMyOrchestratorRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyOrchestratorRunsQuery, GetMyOrchestratorRunsQueryVariables>(GetMyOrchestratorRunsDocument, options);
        }
export function useGetMyOrchestratorRunsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyOrchestratorRunsQuery, GetMyOrchestratorRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyOrchestratorRunsQuery, GetMyOrchestratorRunsQueryVariables>(GetMyOrchestratorRunsDocument, options);
        }
export type GetMyOrchestratorRunsQueryHookResult = ReturnType<typeof useGetMyOrchestratorRunsQuery>;
export type GetMyOrchestratorRunsLazyQueryHookResult = ReturnType<typeof useGetMyOrchestratorRunsLazyQuery>;
export type GetMyOrchestratorRunsSuspenseQueryHookResult = ReturnType<typeof useGetMyOrchestratorRunsSuspenseQuery>;
export type GetMyOrchestratorRunsQueryResult = Apollo.QueryResult<GetMyOrchestratorRunsQuery, GetMyOrchestratorRunsQueryVariables>;
export const GetMyOrchestratorStepsDocument = gql`
    query GetMyOrchestratorSteps($runSettings: OrchestratorRunSettingsInput!) {
  getMyOrchestratorSteps(runSettings: $runSettings) {
    runSettings {
      inputId
      workflowId
      variablesId
      runAttemptId
    }
    stepId
    status
    createdAt
  }
}
    `;

/**
 * __useGetMyOrchestratorStepsQuery__
 *
 * To run a query within a React component, call `useGetMyOrchestratorStepsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyOrchestratorStepsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyOrchestratorStepsQuery({
 *   variables: {
 *      runSettings: // value for 'runSettings'
 *   },
 * });
 */
export function useGetMyOrchestratorStepsQuery(baseOptions: Apollo.QueryHookOptions<GetMyOrchestratorStepsQuery, GetMyOrchestratorStepsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyOrchestratorStepsQuery, GetMyOrchestratorStepsQueryVariables>(GetMyOrchestratorStepsDocument, options);
      }
export function useGetMyOrchestratorStepsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyOrchestratorStepsQuery, GetMyOrchestratorStepsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyOrchestratorStepsQuery, GetMyOrchestratorStepsQueryVariables>(GetMyOrchestratorStepsDocument, options);
        }
export function useGetMyOrchestratorStepsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyOrchestratorStepsQuery, GetMyOrchestratorStepsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyOrchestratorStepsQuery, GetMyOrchestratorStepsQueryVariables>(GetMyOrchestratorStepsDocument, options);
        }
export type GetMyOrchestratorStepsQueryHookResult = ReturnType<typeof useGetMyOrchestratorStepsQuery>;
export type GetMyOrchestratorStepsLazyQueryHookResult = ReturnType<typeof useGetMyOrchestratorStepsLazyQuery>;
export type GetMyOrchestratorStepsSuspenseQueryHookResult = ReturnType<typeof useGetMyOrchestratorStepsSuspenseQuery>;
export type GetMyOrchestratorStepsQueryResult = Apollo.QueryResult<GetMyOrchestratorStepsQuery, GetMyOrchestratorStepsQueryVariables>;
export const GetMyPoEditsDocument = gql`
    query GetMyPoEdits($id: String!) {
  getMyPoEdits(id: $id) {
    id
    po_id
    location_address
    location_email
    vendor_address
    vendor_email
    need_by_date
    ship_by_date
    notes
    created_at
    created_by
  }
}
    `;

/**
 * __useGetMyPoEditsQuery__
 *
 * To run a query within a React component, call `useGetMyPoEditsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyPoEditsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyPoEditsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMyPoEditsQuery(baseOptions: Apollo.QueryHookOptions<GetMyPoEditsQuery, GetMyPoEditsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyPoEditsQuery, GetMyPoEditsQueryVariables>(GetMyPoEditsDocument, options);
      }
export function useGetMyPoEditsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyPoEditsQuery, GetMyPoEditsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyPoEditsQuery, GetMyPoEditsQueryVariables>(GetMyPoEditsDocument, options);
        }
export function useGetMyPoEditsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyPoEditsQuery, GetMyPoEditsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyPoEditsQuery, GetMyPoEditsQueryVariables>(GetMyPoEditsDocument, options);
        }
export type GetMyPoEditsQueryHookResult = ReturnType<typeof useGetMyPoEditsQuery>;
export type GetMyPoEditsLazyQueryHookResult = ReturnType<typeof useGetMyPoEditsLazyQuery>;
export type GetMyPoEditsSuspenseQueryHookResult = ReturnType<typeof useGetMyPoEditsSuspenseQuery>;
export type GetMyPoEditsQueryResult = Apollo.QueryResult<GetMyPoEditsQuery, GetMyPoEditsQueryVariables>;
export const GetMyPoSkuEditsDocument = gql`
    query GetMyPoSkuEdits($id: String!) {
  getMyPoSkuEdits(id: $id) {
    id
    po_id
    sku
    quantity
    unit
    unit_cost
    created_at
    created_by
  }
}
    `;

/**
 * __useGetMyPoSkuEditsQuery__
 *
 * To run a query within a React component, call `useGetMyPoSkuEditsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyPoSkuEditsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyPoSkuEditsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMyPoSkuEditsQuery(baseOptions: Apollo.QueryHookOptions<GetMyPoSkuEditsQuery, GetMyPoSkuEditsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyPoSkuEditsQuery, GetMyPoSkuEditsQueryVariables>(GetMyPoSkuEditsDocument, options);
      }
export function useGetMyPoSkuEditsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyPoSkuEditsQuery, GetMyPoSkuEditsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyPoSkuEditsQuery, GetMyPoSkuEditsQueryVariables>(GetMyPoSkuEditsDocument, options);
        }
export function useGetMyPoSkuEditsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyPoSkuEditsQuery, GetMyPoSkuEditsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyPoSkuEditsQuery, GetMyPoSkuEditsQueryVariables>(GetMyPoSkuEditsDocument, options);
        }
export type GetMyPoSkuEditsQueryHookResult = ReturnType<typeof useGetMyPoSkuEditsQuery>;
export type GetMyPoSkuEditsLazyQueryHookResult = ReturnType<typeof useGetMyPoSkuEditsLazyQuery>;
export type GetMyPoSkuEditsSuspenseQueryHookResult = ReturnType<typeof useGetMyPoSkuEditsSuspenseQuery>;
export type GetMyPoSkuEditsQueryResult = Apollo.QueryResult<GetMyPoSkuEditsQuery, GetMyPoSkuEditsQueryVariables>;
export const GetMyPoWithLatestEditAndSkusDocument = gql`
    query GetMyPoWithLatestEditAndSkus($id: String!) {
  getMyPoWithLatestEditAndSkus(id: $id) {
    id
    po {
      id
      run_settings {
        inputId
        variablesId
        workflowId
        runAttemptId
      }
      po_sim_id
      location
      vendor
      snooze_start_date
      snooze_end_date
      status
      total_cogs
      created_at
      created_by
      updated_at
      updated_by
    }
    pe {
      id
      po_id
      location_address
      location_email
      vendor_address
      vendor_email
      need_by_date
      ship_by_date
      notes
      created_at
      created_by
    }
    ps {
      id
      po_id
      sku
      quantity
      unit
      unit_cost
      created_at
      created_by
    }
  }
}
    `;

/**
 * __useGetMyPoWithLatestEditAndSkusQuery__
 *
 * To run a query within a React component, call `useGetMyPoWithLatestEditAndSkusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyPoWithLatestEditAndSkusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyPoWithLatestEditAndSkusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMyPoWithLatestEditAndSkusQuery(baseOptions: Apollo.QueryHookOptions<GetMyPoWithLatestEditAndSkusQuery, GetMyPoWithLatestEditAndSkusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyPoWithLatestEditAndSkusQuery, GetMyPoWithLatestEditAndSkusQueryVariables>(GetMyPoWithLatestEditAndSkusDocument, options);
      }
export function useGetMyPoWithLatestEditAndSkusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyPoWithLatestEditAndSkusQuery, GetMyPoWithLatestEditAndSkusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyPoWithLatestEditAndSkusQuery, GetMyPoWithLatestEditAndSkusQueryVariables>(GetMyPoWithLatestEditAndSkusDocument, options);
        }
export function useGetMyPoWithLatestEditAndSkusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyPoWithLatestEditAndSkusQuery, GetMyPoWithLatestEditAndSkusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyPoWithLatestEditAndSkusQuery, GetMyPoWithLatestEditAndSkusQueryVariables>(GetMyPoWithLatestEditAndSkusDocument, options);
        }
export type GetMyPoWithLatestEditAndSkusQueryHookResult = ReturnType<typeof useGetMyPoWithLatestEditAndSkusQuery>;
export type GetMyPoWithLatestEditAndSkusLazyQueryHookResult = ReturnType<typeof useGetMyPoWithLatestEditAndSkusLazyQuery>;
export type GetMyPoWithLatestEditAndSkusSuspenseQueryHookResult = ReturnType<typeof useGetMyPoWithLatestEditAndSkusSuspenseQuery>;
export type GetMyPoWithLatestEditAndSkusQueryResult = Apollo.QueryResult<GetMyPoWithLatestEditAndSkusQuery, GetMyPoWithLatestEditAndSkusQueryVariables>;
export const GetMyPosWithLatestEditsDocument = gql`
    query GetMyPosWithLatestEdits($include_status: [PurchaseOrderStatus!]!, $runSettings: OrchestratorRunSettingsInput, $snoozed: Boolean) {
  getMyPosWithLatestEdits(
    include_status: $include_status
    runSettings: $runSettings
    snoozed: $snoozed
  ) {
    id
    po {
      id
      run_settings {
        inputId
        variablesId
        workflowId
        runAttemptId
      }
      po_sim_id
      location
      vendor
      snooze_start_date
      snooze_end_date
      status
      total_cogs
      created_at
      created_by
      updated_at
      updated_by
    }
    pe {
      id
      po_id
      location_address
      location_email
      vendor_address
      vendor_email
      need_by_date
      ship_by_date
      notes
      created_at
      created_by
    }
  }
}
    `;

/**
 * __useGetMyPosWithLatestEditsQuery__
 *
 * To run a query within a React component, call `useGetMyPosWithLatestEditsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyPosWithLatestEditsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyPosWithLatestEditsQuery({
 *   variables: {
 *      include_status: // value for 'include_status'
 *      runSettings: // value for 'runSettings'
 *      snoozed: // value for 'snoozed'
 *   },
 * });
 */
export function useGetMyPosWithLatestEditsQuery(baseOptions: Apollo.QueryHookOptions<GetMyPosWithLatestEditsQuery, GetMyPosWithLatestEditsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyPosWithLatestEditsQuery, GetMyPosWithLatestEditsQueryVariables>(GetMyPosWithLatestEditsDocument, options);
      }
export function useGetMyPosWithLatestEditsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyPosWithLatestEditsQuery, GetMyPosWithLatestEditsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyPosWithLatestEditsQuery, GetMyPosWithLatestEditsQueryVariables>(GetMyPosWithLatestEditsDocument, options);
        }
export function useGetMyPosWithLatestEditsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyPosWithLatestEditsQuery, GetMyPosWithLatestEditsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyPosWithLatestEditsQuery, GetMyPosWithLatestEditsQueryVariables>(GetMyPosWithLatestEditsDocument, options);
        }
export type GetMyPosWithLatestEditsQueryHookResult = ReturnType<typeof useGetMyPosWithLatestEditsQuery>;
export type GetMyPosWithLatestEditsLazyQueryHookResult = ReturnType<typeof useGetMyPosWithLatestEditsLazyQuery>;
export type GetMyPosWithLatestEditsSuspenseQueryHookResult = ReturnType<typeof useGetMyPosWithLatestEditsSuspenseQuery>;
export type GetMyPosWithLatestEditsQueryResult = Apollo.QueryResult<GetMyPosWithLatestEditsQuery, GetMyPosWithLatestEditsQueryVariables>;
export const GetMyPowerBiReportItemsDocument = gql`
    query GetMyPowerBiReportItems($workspaceId: String!) {
  getMyPowerBiReportItems(workspaceId: $workspaceId) {
    embedToken
    embedTokenId
    embedTokenExpiration
    reports {
      reportName
      reportId
      embedUrl
      pages {
        pageId
        pageName
        order
      }
    }
  }
}
    `;

/**
 * __useGetMyPowerBiReportItemsQuery__
 *
 * To run a query within a React component, call `useGetMyPowerBiReportItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyPowerBiReportItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyPowerBiReportItemsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetMyPowerBiReportItemsQuery(baseOptions: Apollo.QueryHookOptions<GetMyPowerBiReportItemsQuery, GetMyPowerBiReportItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyPowerBiReportItemsQuery, GetMyPowerBiReportItemsQueryVariables>(GetMyPowerBiReportItemsDocument, options);
      }
export function useGetMyPowerBiReportItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyPowerBiReportItemsQuery, GetMyPowerBiReportItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyPowerBiReportItemsQuery, GetMyPowerBiReportItemsQueryVariables>(GetMyPowerBiReportItemsDocument, options);
        }
export function useGetMyPowerBiReportItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyPowerBiReportItemsQuery, GetMyPowerBiReportItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyPowerBiReportItemsQuery, GetMyPowerBiReportItemsQueryVariables>(GetMyPowerBiReportItemsDocument, options);
        }
export type GetMyPowerBiReportItemsQueryHookResult = ReturnType<typeof useGetMyPowerBiReportItemsQuery>;
export type GetMyPowerBiReportItemsLazyQueryHookResult = ReturnType<typeof useGetMyPowerBiReportItemsLazyQuery>;
export type GetMyPowerBiReportItemsSuspenseQueryHookResult = ReturnType<typeof useGetMyPowerBiReportItemsSuspenseQuery>;
export type GetMyPowerBiReportItemsQueryResult = Apollo.QueryResult<GetMyPowerBiReportItemsQuery, GetMyPowerBiReportItemsQueryVariables>;
export const GetMyPowerBisDocument = gql`
    query GetMyPowerBis {
  getMyPowerBis {
    name
    id
    workspaceId
  }
}
    `;

/**
 * __useGetMyPowerBisQuery__
 *
 * To run a query within a React component, call `useGetMyPowerBisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyPowerBisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyPowerBisQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyPowerBisQuery(baseOptions?: Apollo.QueryHookOptions<GetMyPowerBisQuery, GetMyPowerBisQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyPowerBisQuery, GetMyPowerBisQueryVariables>(GetMyPowerBisDocument, options);
      }
export function useGetMyPowerBisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyPowerBisQuery, GetMyPowerBisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyPowerBisQuery, GetMyPowerBisQueryVariables>(GetMyPowerBisDocument, options);
        }
export function useGetMyPowerBisSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyPowerBisQuery, GetMyPowerBisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyPowerBisQuery, GetMyPowerBisQueryVariables>(GetMyPowerBisDocument, options);
        }
export type GetMyPowerBisQueryHookResult = ReturnType<typeof useGetMyPowerBisQuery>;
export type GetMyPowerBisLazyQueryHookResult = ReturnType<typeof useGetMyPowerBisLazyQuery>;
export type GetMyPowerBisSuspenseQueryHookResult = ReturnType<typeof useGetMyPowerBisSuspenseQuery>;
export type GetMyPowerBisQueryResult = Apollo.QueryResult<GetMyPowerBisQuery, GetMyPowerBisQueryVariables>;
export const GetMyRunComparisonRunIdsDocument = gql`
    query GetMyRunComparisonRunIds {
  getMyRunComparisonRunIds
}
    `;

/**
 * __useGetMyRunComparisonRunIdsQuery__
 *
 * To run a query within a React component, call `useGetMyRunComparisonRunIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyRunComparisonRunIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyRunComparisonRunIdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyRunComparisonRunIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyRunComparisonRunIdsQuery, GetMyRunComparisonRunIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyRunComparisonRunIdsQuery, GetMyRunComparisonRunIdsQueryVariables>(GetMyRunComparisonRunIdsDocument, options);
      }
export function useGetMyRunComparisonRunIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyRunComparisonRunIdsQuery, GetMyRunComparisonRunIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyRunComparisonRunIdsQuery, GetMyRunComparisonRunIdsQueryVariables>(GetMyRunComparisonRunIdsDocument, options);
        }
export function useGetMyRunComparisonRunIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyRunComparisonRunIdsQuery, GetMyRunComparisonRunIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyRunComparisonRunIdsQuery, GetMyRunComparisonRunIdsQueryVariables>(GetMyRunComparisonRunIdsDocument, options);
        }
export type GetMyRunComparisonRunIdsQueryHookResult = ReturnType<typeof useGetMyRunComparisonRunIdsQuery>;
export type GetMyRunComparisonRunIdsLazyQueryHookResult = ReturnType<typeof useGetMyRunComparisonRunIdsLazyQuery>;
export type GetMyRunComparisonRunIdsSuspenseQueryHookResult = ReturnType<typeof useGetMyRunComparisonRunIdsSuspenseQuery>;
export type GetMyRunComparisonRunIdsQueryResult = Apollo.QueryResult<GetMyRunComparisonRunIdsQuery, GetMyRunComparisonRunIdsQueryVariables>;
export const GetMyRunLogsDocument = gql`
    query GetMyRunLogs {
  getMyRunLogs {
    id
    email
    name
    description
    status
    createdAt
    updatedAt
    startedAt
    orderToDeliveryDaysOffset
    weightingMethod
    orderSimulationEndDate
    historicalDatePatterns
    weightingWindowDays
    bindToSKUOverrides
    bindToForecastUpload
    dyeYieldLoss
    sewYieldLoss
    cutYieldLoss
    weeksOfSupply
    useBufferForecast
    desiredMinWeeksOnHand
    leadTimeInWeeks
    assumedCustomerGrowth
    runError
    excludeYieldPlan
    excludeForecast
    truckOrderToPackDays
    onHoldToAvailableDays
    productionStartToEndDays
    darkRoastRuntime
    mediumRoastRuntime
    lightRoastRuntime
    defaultChangeoverTime
    decafChangeoverTime
    turnOnProductionBatching
    organicMillingNextProductionRun
    cnpNextProductionRun
    taraNextProductionRun
    auroraNextProductionRun
    firmWindowLookAhead
    trendLookbackWindow
  }
}
    `;

/**
 * __useGetMyRunLogsQuery__
 *
 * To run a query within a React component, call `useGetMyRunLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyRunLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyRunLogsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyRunLogsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyRunLogsQuery, GetMyRunLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyRunLogsQuery, GetMyRunLogsQueryVariables>(GetMyRunLogsDocument, options);
      }
export function useGetMyRunLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyRunLogsQuery, GetMyRunLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyRunLogsQuery, GetMyRunLogsQueryVariables>(GetMyRunLogsDocument, options);
        }
export function useGetMyRunLogsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyRunLogsQuery, GetMyRunLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyRunLogsQuery, GetMyRunLogsQueryVariables>(GetMyRunLogsDocument, options);
        }
export type GetMyRunLogsQueryHookResult = ReturnType<typeof useGetMyRunLogsQuery>;
export type GetMyRunLogsLazyQueryHookResult = ReturnType<typeof useGetMyRunLogsLazyQuery>;
export type GetMyRunLogsSuspenseQueryHookResult = ReturnType<typeof useGetMyRunLogsSuspenseQuery>;
export type GetMyRunLogsQueryResult = Apollo.QueryResult<GetMyRunLogsQuery, GetMyRunLogsQueryVariables>;
export const GetMySkuHierarchyUrlDocument = gql`
    query GetMySkuHierarchyUrl($engineRunId: Int!) {
  getMySkuHierarchyUrl(engineRunId: $engineRunId)
}
    `;

/**
 * __useGetMySkuHierarchyUrlQuery__
 *
 * To run a query within a React component, call `useGetMySkuHierarchyUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMySkuHierarchyUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMySkuHierarchyUrlQuery({
 *   variables: {
 *      engineRunId: // value for 'engineRunId'
 *   },
 * });
 */
export function useGetMySkuHierarchyUrlQuery(baseOptions: Apollo.QueryHookOptions<GetMySkuHierarchyUrlQuery, GetMySkuHierarchyUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMySkuHierarchyUrlQuery, GetMySkuHierarchyUrlQueryVariables>(GetMySkuHierarchyUrlDocument, options);
      }
export function useGetMySkuHierarchyUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMySkuHierarchyUrlQuery, GetMySkuHierarchyUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMySkuHierarchyUrlQuery, GetMySkuHierarchyUrlQueryVariables>(GetMySkuHierarchyUrlDocument, options);
        }
export function useGetMySkuHierarchyUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMySkuHierarchyUrlQuery, GetMySkuHierarchyUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMySkuHierarchyUrlQuery, GetMySkuHierarchyUrlQueryVariables>(GetMySkuHierarchyUrlDocument, options);
        }
export type GetMySkuHierarchyUrlQueryHookResult = ReturnType<typeof useGetMySkuHierarchyUrlQuery>;
export type GetMySkuHierarchyUrlLazyQueryHookResult = ReturnType<typeof useGetMySkuHierarchyUrlLazyQuery>;
export type GetMySkuHierarchyUrlSuspenseQueryHookResult = ReturnType<typeof useGetMySkuHierarchyUrlSuspenseQuery>;
export type GetMySkuHierarchyUrlQueryResult = Apollo.QueryResult<GetMySkuHierarchyUrlQuery, GetMySkuHierarchyUrlQueryVariables>;
export const GetMyUserApprovalsByAnchorDocument = gql`
    query GetMyUserApprovalsByAnchor($anchorRefs: [String!]!) {
  getMyUserApprovalsByAnchor(anchorRefs: $anchorRefs) {
    id
    anchorRef
    date
    userId
    message
    approval
  }
}
    `;

/**
 * __useGetMyUserApprovalsByAnchorQuery__
 *
 * To run a query within a React component, call `useGetMyUserApprovalsByAnchorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyUserApprovalsByAnchorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyUserApprovalsByAnchorQuery({
 *   variables: {
 *      anchorRefs: // value for 'anchorRefs'
 *   },
 * });
 */
export function useGetMyUserApprovalsByAnchorQuery(baseOptions: Apollo.QueryHookOptions<GetMyUserApprovalsByAnchorQuery, GetMyUserApprovalsByAnchorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyUserApprovalsByAnchorQuery, GetMyUserApprovalsByAnchorQueryVariables>(GetMyUserApprovalsByAnchorDocument, options);
      }
export function useGetMyUserApprovalsByAnchorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyUserApprovalsByAnchorQuery, GetMyUserApprovalsByAnchorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyUserApprovalsByAnchorQuery, GetMyUserApprovalsByAnchorQueryVariables>(GetMyUserApprovalsByAnchorDocument, options);
        }
export function useGetMyUserApprovalsByAnchorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyUserApprovalsByAnchorQuery, GetMyUserApprovalsByAnchorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyUserApprovalsByAnchorQuery, GetMyUserApprovalsByAnchorQueryVariables>(GetMyUserApprovalsByAnchorDocument, options);
        }
export type GetMyUserApprovalsByAnchorQueryHookResult = ReturnType<typeof useGetMyUserApprovalsByAnchorQuery>;
export type GetMyUserApprovalsByAnchorLazyQueryHookResult = ReturnType<typeof useGetMyUserApprovalsByAnchorLazyQuery>;
export type GetMyUserApprovalsByAnchorSuspenseQueryHookResult = ReturnType<typeof useGetMyUserApprovalsByAnchorSuspenseQuery>;
export type GetMyUserApprovalsByAnchorQueryResult = Apollo.QueryResult<GetMyUserApprovalsByAnchorQuery, GetMyUserApprovalsByAnchorQueryVariables>;
export const GetMyUserCommentsByAnchorDocument = gql`
    query GetMyUserCommentsByAnchor($anchorRefs: [String!]!) {
  getMyUserCommentsByAnchor(anchorRefs: $anchorRefs) {
    id
    anchorRef
    date
    userId
    message
  }
}
    `;

/**
 * __useGetMyUserCommentsByAnchorQuery__
 *
 * To run a query within a React component, call `useGetMyUserCommentsByAnchorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyUserCommentsByAnchorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyUserCommentsByAnchorQuery({
 *   variables: {
 *      anchorRefs: // value for 'anchorRefs'
 *   },
 * });
 */
export function useGetMyUserCommentsByAnchorQuery(baseOptions: Apollo.QueryHookOptions<GetMyUserCommentsByAnchorQuery, GetMyUserCommentsByAnchorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyUserCommentsByAnchorQuery, GetMyUserCommentsByAnchorQueryVariables>(GetMyUserCommentsByAnchorDocument, options);
      }
export function useGetMyUserCommentsByAnchorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyUserCommentsByAnchorQuery, GetMyUserCommentsByAnchorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyUserCommentsByAnchorQuery, GetMyUserCommentsByAnchorQueryVariables>(GetMyUserCommentsByAnchorDocument, options);
        }
export function useGetMyUserCommentsByAnchorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyUserCommentsByAnchorQuery, GetMyUserCommentsByAnchorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyUserCommentsByAnchorQuery, GetMyUserCommentsByAnchorQueryVariables>(GetMyUserCommentsByAnchorDocument, options);
        }
export type GetMyUserCommentsByAnchorQueryHookResult = ReturnType<typeof useGetMyUserCommentsByAnchorQuery>;
export type GetMyUserCommentsByAnchorLazyQueryHookResult = ReturnType<typeof useGetMyUserCommentsByAnchorLazyQuery>;
export type GetMyUserCommentsByAnchorSuspenseQueryHookResult = ReturnType<typeof useGetMyUserCommentsByAnchorSuspenseQuery>;
export type GetMyUserCommentsByAnchorQueryResult = Apollo.QueryResult<GetMyUserCommentsByAnchorQuery, GetMyUserCommentsByAnchorQueryVariables>;
export const GetMyVendorsDocument = gql`
    query GetMyVendors {
  getMyVendors {
    id
    address
    address_override
    email
  }
}
    `;

/**
 * __useGetMyVendorsQuery__
 *
 * To run a query within a React component, call `useGetMyVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyVendorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyVendorsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyVendorsQuery, GetMyVendorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyVendorsQuery, GetMyVendorsQueryVariables>(GetMyVendorsDocument, options);
      }
export function useGetMyVendorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyVendorsQuery, GetMyVendorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyVendorsQuery, GetMyVendorsQueryVariables>(GetMyVendorsDocument, options);
        }
export function useGetMyVendorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyVendorsQuery, GetMyVendorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyVendorsQuery, GetMyVendorsQueryVariables>(GetMyVendorsDocument, options);
        }
export type GetMyVendorsQueryHookResult = ReturnType<typeof useGetMyVendorsQuery>;
export type GetMyVendorsLazyQueryHookResult = ReturnType<typeof useGetMyVendorsLazyQuery>;
export type GetMyVendorsSuspenseQueryHookResult = ReturnType<typeof useGetMyVendorsSuspenseQuery>;
export type GetMyVendorsQueryResult = Apollo.QueryResult<GetMyVendorsQuery, GetMyVendorsQueryVariables>;
export const HelloWorldDocument = gql`
    query HelloWorld {
  helloWorld
}
    `;

/**
 * __useHelloWorldQuery__
 *
 * To run a query within a React component, call `useHelloWorldQuery` and pass it any options that fit your needs.
 * When your component renders, `useHelloWorldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHelloWorldQuery({
 *   variables: {
 *   },
 * });
 */
export function useHelloWorldQuery(baseOptions?: Apollo.QueryHookOptions<HelloWorldQuery, HelloWorldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HelloWorldQuery, HelloWorldQueryVariables>(HelloWorldDocument, options);
      }
export function useHelloWorldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HelloWorldQuery, HelloWorldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HelloWorldQuery, HelloWorldQueryVariables>(HelloWorldDocument, options);
        }
export function useHelloWorldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HelloWorldQuery, HelloWorldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HelloWorldQuery, HelloWorldQueryVariables>(HelloWorldDocument, options);
        }
export type HelloWorldQueryHookResult = ReturnType<typeof useHelloWorldQuery>;
export type HelloWorldLazyQueryHookResult = ReturnType<typeof useHelloWorldLazyQuery>;
export type HelloWorldSuspenseQueryHookResult = ReturnType<typeof useHelloWorldSuspenseQuery>;
export type HelloWorldQueryResult = Apollo.QueryResult<HelloWorldQuery, HelloWorldQueryVariables>;
export const ImportMyPoDocument = gql`
    mutation ImportMyPo($id: String!, $runSettings: OrchestratorRunInput!) {
  importMyPo(id: $id, runSettings: $runSettings) {
    id
    po {
      id
      run_settings {
        inputId
        variablesId
        workflowId
        runAttemptId
      }
      po_sim_id
      location
      vendor
      snooze_start_date
      snooze_end_date
      status
      total_cogs
      created_at
      created_by
      updated_at
      updated_by
    }
    pe {
      id
      po_id
      location_address
      location_email
      vendor_address
      vendor_email
      need_by_date
      ship_by_date
      notes
      created_at
      created_by
    }
    ps {
      id
      po_id
      sku
      quantity
      unit
      unit_cost
      created_at
      created_by
    }
  }
}
    `;
export type ImportMyPoMutationFn = Apollo.MutationFunction<ImportMyPoMutation, ImportMyPoMutationVariables>;

/**
 * __useImportMyPoMutation__
 *
 * To run a mutation, you first call `useImportMyPoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportMyPoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importMyPoMutation, { data, loading, error }] = useImportMyPoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      runSettings: // value for 'runSettings'
 *   },
 * });
 */
export function useImportMyPoMutation(baseOptions?: Apollo.MutationHookOptions<ImportMyPoMutation, ImportMyPoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportMyPoMutation, ImportMyPoMutationVariables>(ImportMyPoDocument, options);
      }
export type ImportMyPoMutationHookResult = ReturnType<typeof useImportMyPoMutation>;
export type ImportMyPoMutationResult = Apollo.MutationResult<ImportMyPoMutation>;
export type ImportMyPoMutationOptions = Apollo.BaseMutationOptions<ImportMyPoMutation, ImportMyPoMutationVariables>;
export const MakeMyEnginePresetDefaultDocument = gql`
    mutation MakeMyEnginePresetDefault($enginePresetId: Int!) {
  makeMyEnginePresetDefault(enginePresetId: $enginePresetId)
}
    `;
export type MakeMyEnginePresetDefaultMutationFn = Apollo.MutationFunction<MakeMyEnginePresetDefaultMutation, MakeMyEnginePresetDefaultMutationVariables>;

/**
 * __useMakeMyEnginePresetDefaultMutation__
 *
 * To run a mutation, you first call `useMakeMyEnginePresetDefaultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeMyEnginePresetDefaultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeMyEnginePresetDefaultMutation, { data, loading, error }] = useMakeMyEnginePresetDefaultMutation({
 *   variables: {
 *      enginePresetId: // value for 'enginePresetId'
 *   },
 * });
 */
export function useMakeMyEnginePresetDefaultMutation(baseOptions?: Apollo.MutationHookOptions<MakeMyEnginePresetDefaultMutation, MakeMyEnginePresetDefaultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MakeMyEnginePresetDefaultMutation, MakeMyEnginePresetDefaultMutationVariables>(MakeMyEnginePresetDefaultDocument, options);
      }
export type MakeMyEnginePresetDefaultMutationHookResult = ReturnType<typeof useMakeMyEnginePresetDefaultMutation>;
export type MakeMyEnginePresetDefaultMutationResult = Apollo.MutationResult<MakeMyEnginePresetDefaultMutation>;
export type MakeMyEnginePresetDefaultMutationOptions = Apollo.BaseMutationOptions<MakeMyEnginePresetDefaultMutation, MakeMyEnginePresetDefaultMutationVariables>;
export const CreateMyGoodchopGrossOdlJobPlanDocument = gql`
    mutation CreateMyGoodchopGrossOdlJobPlan($jobPlanId: String!, $jobPlan: [GoodChopGrossOdlJobPlanIntKeyValueInput!]!) {
  createMyGoodchopGrossOdlJobPlan(jobPlanId: $jobPlanId, jobPlan: $jobPlan) {
    jobPlanId
  }
}
    `;
export type CreateMyGoodchopGrossOdlJobPlanMutationFn = Apollo.MutationFunction<CreateMyGoodchopGrossOdlJobPlanMutation, CreateMyGoodchopGrossOdlJobPlanMutationVariables>;

/**
 * __useCreateMyGoodchopGrossOdlJobPlanMutation__
 *
 * To run a mutation, you first call `useCreateMyGoodchopGrossOdlJobPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMyGoodchopGrossOdlJobPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMyGoodchopGrossOdlJobPlanMutation, { data, loading, error }] = useCreateMyGoodchopGrossOdlJobPlanMutation({
 *   variables: {
 *      jobPlanId: // value for 'jobPlanId'
 *      jobPlan: // value for 'jobPlan'
 *   },
 * });
 */
export function useCreateMyGoodchopGrossOdlJobPlanMutation(baseOptions?: Apollo.MutationHookOptions<CreateMyGoodchopGrossOdlJobPlanMutation, CreateMyGoodchopGrossOdlJobPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMyGoodchopGrossOdlJobPlanMutation, CreateMyGoodchopGrossOdlJobPlanMutationVariables>(CreateMyGoodchopGrossOdlJobPlanDocument, options);
      }
export type CreateMyGoodchopGrossOdlJobPlanMutationHookResult = ReturnType<typeof useCreateMyGoodchopGrossOdlJobPlanMutation>;
export type CreateMyGoodchopGrossOdlJobPlanMutationResult = Apollo.MutationResult<CreateMyGoodchopGrossOdlJobPlanMutation>;
export type CreateMyGoodchopGrossOdlJobPlanMutationOptions = Apollo.BaseMutationOptions<CreateMyGoodchopGrossOdlJobPlanMutation, CreateMyGoodchopGrossOdlJobPlanMutationVariables>;
export const CreateMyGoodchopGrossOdlJobDocument = gql`
    mutation CreateMyGoodchopGrossOdlJob($jobPlanId: String!, $job: String!, $step: String!, $runId: String!, $fileName: String!, $name: String!, $jobName: String!) {
  createMyGoodchopGrossOdlJob(
    jobPlanId: $jobPlanId
    job: $job
    step: $step
    runId: $runId
    fileName: $fileName
    name: $name
    jobName: $jobName
  )
}
    `;
export type CreateMyGoodchopGrossOdlJobMutationFn = Apollo.MutationFunction<CreateMyGoodchopGrossOdlJobMutation, CreateMyGoodchopGrossOdlJobMutationVariables>;

/**
 * __useCreateMyGoodchopGrossOdlJobMutation__
 *
 * To run a mutation, you first call `useCreateMyGoodchopGrossOdlJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMyGoodchopGrossOdlJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMyGoodchopGrossOdlJobMutation, { data, loading, error }] = useCreateMyGoodchopGrossOdlJobMutation({
 *   variables: {
 *      jobPlanId: // value for 'jobPlanId'
 *      job: // value for 'job'
 *      step: // value for 'step'
 *      runId: // value for 'runId'
 *      fileName: // value for 'fileName'
 *      name: // value for 'name'
 *      jobName: // value for 'jobName'
 *   },
 * });
 */
export function useCreateMyGoodchopGrossOdlJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateMyGoodchopGrossOdlJobMutation, CreateMyGoodchopGrossOdlJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMyGoodchopGrossOdlJobMutation, CreateMyGoodchopGrossOdlJobMutationVariables>(CreateMyGoodchopGrossOdlJobDocument, options);
      }
export type CreateMyGoodchopGrossOdlJobMutationHookResult = ReturnType<typeof useCreateMyGoodchopGrossOdlJobMutation>;
export type CreateMyGoodchopGrossOdlJobMutationResult = Apollo.MutationResult<CreateMyGoodchopGrossOdlJobMutation>;
export type CreateMyGoodchopGrossOdlJobMutationOptions = Apollo.BaseMutationOptions<CreateMyGoodchopGrossOdlJobMutation, CreateMyGoodchopGrossOdlJobMutationVariables>;
export const CreateMyGoodchopGrossOdlPresignDownloadUrlDocument = gql`
    mutation CreateMyGoodchopGrossOdlPresignDownloadUrl($filePath: String!) {
  createMyGoodchopGrossOdlPresignDownloadUrl(filePath: $filePath) {
    presignUrl
  }
}
    `;
export type CreateMyGoodchopGrossOdlPresignDownloadUrlMutationFn = Apollo.MutationFunction<CreateMyGoodchopGrossOdlPresignDownloadUrlMutation, CreateMyGoodchopGrossOdlPresignDownloadUrlMutationVariables>;

/**
 * __useCreateMyGoodchopGrossOdlPresignDownloadUrlMutation__
 *
 * To run a mutation, you first call `useCreateMyGoodchopGrossOdlPresignDownloadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMyGoodchopGrossOdlPresignDownloadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMyGoodchopGrossOdlPresignDownloadUrlMutation, { data, loading, error }] = useCreateMyGoodchopGrossOdlPresignDownloadUrlMutation({
 *   variables: {
 *      filePath: // value for 'filePath'
 *   },
 * });
 */
export function useCreateMyGoodchopGrossOdlPresignDownloadUrlMutation(baseOptions?: Apollo.MutationHookOptions<CreateMyGoodchopGrossOdlPresignDownloadUrlMutation, CreateMyGoodchopGrossOdlPresignDownloadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMyGoodchopGrossOdlPresignDownloadUrlMutation, CreateMyGoodchopGrossOdlPresignDownloadUrlMutationVariables>(CreateMyGoodchopGrossOdlPresignDownloadUrlDocument, options);
      }
export type CreateMyGoodchopGrossOdlPresignDownloadUrlMutationHookResult = ReturnType<typeof useCreateMyGoodchopGrossOdlPresignDownloadUrlMutation>;
export type CreateMyGoodchopGrossOdlPresignDownloadUrlMutationResult = Apollo.MutationResult<CreateMyGoodchopGrossOdlPresignDownloadUrlMutation>;
export type CreateMyGoodchopGrossOdlPresignDownloadUrlMutationOptions = Apollo.BaseMutationOptions<CreateMyGoodchopGrossOdlPresignDownloadUrlMutation, CreateMyGoodchopGrossOdlPresignDownloadUrlMutationVariables>;
export const CreateMyGoodchopGrossOdlPresignUploadUrlDocument = gql`
    mutation CreateMyGoodchopGrossOdlPresignUploadUrl($fileName: String!, $contentType: String!, $jobPlanId: String!, $job: String!) {
  createMyGoodchopGrossOdlPresignUploadUrl(
    fileName: $fileName
    contentType: $contentType
    jobPlanId: $jobPlanId
    job: $job
  ) {
    presignUrl
    runId
  }
}
    `;
export type CreateMyGoodchopGrossOdlPresignUploadUrlMutationFn = Apollo.MutationFunction<CreateMyGoodchopGrossOdlPresignUploadUrlMutation, CreateMyGoodchopGrossOdlPresignUploadUrlMutationVariables>;

/**
 * __useCreateMyGoodchopGrossOdlPresignUploadUrlMutation__
 *
 * To run a mutation, you first call `useCreateMyGoodchopGrossOdlPresignUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMyGoodchopGrossOdlPresignUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMyGoodchopGrossOdlPresignUploadUrlMutation, { data, loading, error }] = useCreateMyGoodchopGrossOdlPresignUploadUrlMutation({
 *   variables: {
 *      fileName: // value for 'fileName'
 *      contentType: // value for 'contentType'
 *      jobPlanId: // value for 'jobPlanId'
 *      job: // value for 'job'
 *   },
 * });
 */
export function useCreateMyGoodchopGrossOdlPresignUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<CreateMyGoodchopGrossOdlPresignUploadUrlMutation, CreateMyGoodchopGrossOdlPresignUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMyGoodchopGrossOdlPresignUploadUrlMutation, CreateMyGoodchopGrossOdlPresignUploadUrlMutationVariables>(CreateMyGoodchopGrossOdlPresignUploadUrlDocument, options);
      }
export type CreateMyGoodchopGrossOdlPresignUploadUrlMutationHookResult = ReturnType<typeof useCreateMyGoodchopGrossOdlPresignUploadUrlMutation>;
export type CreateMyGoodchopGrossOdlPresignUploadUrlMutationResult = Apollo.MutationResult<CreateMyGoodchopGrossOdlPresignUploadUrlMutation>;
export type CreateMyGoodchopGrossOdlPresignUploadUrlMutationOptions = Apollo.BaseMutationOptions<CreateMyGoodchopGrossOdlPresignUploadUrlMutation, CreateMyGoodchopGrossOdlPresignUploadUrlMutationVariables>;
export const StartMyGoodchopGrossOdlJobDocument = gql`
    mutation StartMyGoodchopGrossOdlJob($jobPlanId: String!, $job: String!, $runId: String!) {
  startMyGoodchopGrossOdlJob(jobPlanId: $jobPlanId, job: $job, runId: $runId) {
    dagsterRunId
  }
}
    `;
export type StartMyGoodchopGrossOdlJobMutationFn = Apollo.MutationFunction<StartMyGoodchopGrossOdlJobMutation, StartMyGoodchopGrossOdlJobMutationVariables>;

/**
 * __useStartMyGoodchopGrossOdlJobMutation__
 *
 * To run a mutation, you first call `useStartMyGoodchopGrossOdlJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartMyGoodchopGrossOdlJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startMyGoodchopGrossOdlJobMutation, { data, loading, error }] = useStartMyGoodchopGrossOdlJobMutation({
 *   variables: {
 *      jobPlanId: // value for 'jobPlanId'
 *      job: // value for 'job'
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useStartMyGoodchopGrossOdlJobMutation(baseOptions?: Apollo.MutationHookOptions<StartMyGoodchopGrossOdlJobMutation, StartMyGoodchopGrossOdlJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartMyGoodchopGrossOdlJobMutation, StartMyGoodchopGrossOdlJobMutationVariables>(StartMyGoodchopGrossOdlJobDocument, options);
      }
export type StartMyGoodchopGrossOdlJobMutationHookResult = ReturnType<typeof useStartMyGoodchopGrossOdlJobMutation>;
export type StartMyGoodchopGrossOdlJobMutationResult = Apollo.MutationResult<StartMyGoodchopGrossOdlJobMutation>;
export type StartMyGoodchopGrossOdlJobMutationOptions = Apollo.BaseMutationOptions<StartMyGoodchopGrossOdlJobMutation, StartMyGoodchopGrossOdlJobMutationVariables>;
export const StartMyGoodchopGrossOdlUploadValidationDocument = gql`
    mutation StartMyGoodchopGrossOdlUploadValidation($runId: String!, $fileName: String!, $jobPlanId: String!, $job: String!) {
  startMyGoodchopGrossOdlUploadValidation(
    runId: $runId
    fileName: $fileName
    jobPlanId: $jobPlanId
    job: $job
  ) {
    runId
  }
}
    `;
export type StartMyGoodchopGrossOdlUploadValidationMutationFn = Apollo.MutationFunction<StartMyGoodchopGrossOdlUploadValidationMutation, StartMyGoodchopGrossOdlUploadValidationMutationVariables>;

/**
 * __useStartMyGoodchopGrossOdlUploadValidationMutation__
 *
 * To run a mutation, you first call `useStartMyGoodchopGrossOdlUploadValidationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartMyGoodchopGrossOdlUploadValidationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startMyGoodchopGrossOdlUploadValidationMutation, { data, loading, error }] = useStartMyGoodchopGrossOdlUploadValidationMutation({
 *   variables: {
 *      runId: // value for 'runId'
 *      fileName: // value for 'fileName'
 *      jobPlanId: // value for 'jobPlanId'
 *      job: // value for 'job'
 *   },
 * });
 */
export function useStartMyGoodchopGrossOdlUploadValidationMutation(baseOptions?: Apollo.MutationHookOptions<StartMyGoodchopGrossOdlUploadValidationMutation, StartMyGoodchopGrossOdlUploadValidationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartMyGoodchopGrossOdlUploadValidationMutation, StartMyGoodchopGrossOdlUploadValidationMutationVariables>(StartMyGoodchopGrossOdlUploadValidationDocument, options);
      }
export type StartMyGoodchopGrossOdlUploadValidationMutationHookResult = ReturnType<typeof useStartMyGoodchopGrossOdlUploadValidationMutation>;
export type StartMyGoodchopGrossOdlUploadValidationMutationResult = Apollo.MutationResult<StartMyGoodchopGrossOdlUploadValidationMutation>;
export type StartMyGoodchopGrossOdlUploadValidationMutationOptions = Apollo.BaseMutationOptions<StartMyGoodchopGrossOdlUploadValidationMutation, StartMyGoodchopGrossOdlUploadValidationMutationVariables>;
export const UpdateMyGoodchopGrossOdlJobDocument = gql`
    mutation UpdateMyGoodchopGrossOdlJob($runId: String!, $dagsterRunId: String!) {
  updateMyGoodchopGrossOdlJob(runId: $runId, dagsterRunId: $dagsterRunId)
}
    `;
export type UpdateMyGoodchopGrossOdlJobMutationFn = Apollo.MutationFunction<UpdateMyGoodchopGrossOdlJobMutation, UpdateMyGoodchopGrossOdlJobMutationVariables>;

/**
 * __useUpdateMyGoodchopGrossOdlJobMutation__
 *
 * To run a mutation, you first call `useUpdateMyGoodchopGrossOdlJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyGoodchopGrossOdlJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyGoodchopGrossOdlJobMutation, { data, loading, error }] = useUpdateMyGoodchopGrossOdlJobMutation({
 *   variables: {
 *      runId: // value for 'runId'
 *      dagsterRunId: // value for 'dagsterRunId'
 *   },
 * });
 */
export function useUpdateMyGoodchopGrossOdlJobMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMyGoodchopGrossOdlJobMutation, UpdateMyGoodchopGrossOdlJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMyGoodchopGrossOdlJobMutation, UpdateMyGoodchopGrossOdlJobMutationVariables>(UpdateMyGoodchopGrossOdlJobDocument, options);
      }
export type UpdateMyGoodchopGrossOdlJobMutationHookResult = ReturnType<typeof useUpdateMyGoodchopGrossOdlJobMutation>;
export type UpdateMyGoodchopGrossOdlJobMutationResult = Apollo.MutationResult<UpdateMyGoodchopGrossOdlJobMutation>;
export type UpdateMyGoodchopGrossOdlJobMutationOptions = Apollo.BaseMutationOptions<UpdateMyGoodchopGrossOdlJobMutation, UpdateMyGoodchopGrossOdlJobMutationVariables>;
export const GetMyGoodchopGrossOdlJobsDocument = gql`
    query GetMyGoodchopGrossOdlJobs {
  getMyGoodchopGrossOdlJobs {
    runId
    job
    jobPlanId
    jobName
    name
    step
    status
    fileName
    name
    dagsterRunId
    dateCreated
    dateUpdated
    error
  }
}
    `;

/**
 * __useGetMyGoodchopGrossOdlJobsQuery__
 *
 * To run a query within a React component, call `useGetMyGoodchopGrossOdlJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyGoodchopGrossOdlJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyGoodchopGrossOdlJobsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyGoodchopGrossOdlJobsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyGoodchopGrossOdlJobsQuery, GetMyGoodchopGrossOdlJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyGoodchopGrossOdlJobsQuery, GetMyGoodchopGrossOdlJobsQueryVariables>(GetMyGoodchopGrossOdlJobsDocument, options);
      }
export function useGetMyGoodchopGrossOdlJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyGoodchopGrossOdlJobsQuery, GetMyGoodchopGrossOdlJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyGoodchopGrossOdlJobsQuery, GetMyGoodchopGrossOdlJobsQueryVariables>(GetMyGoodchopGrossOdlJobsDocument, options);
        }
export function useGetMyGoodchopGrossOdlJobsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyGoodchopGrossOdlJobsQuery, GetMyGoodchopGrossOdlJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyGoodchopGrossOdlJobsQuery, GetMyGoodchopGrossOdlJobsQueryVariables>(GetMyGoodchopGrossOdlJobsDocument, options);
        }
export type GetMyGoodchopGrossOdlJobsQueryHookResult = ReturnType<typeof useGetMyGoodchopGrossOdlJobsQuery>;
export type GetMyGoodchopGrossOdlJobsLazyQueryHookResult = ReturnType<typeof useGetMyGoodchopGrossOdlJobsLazyQuery>;
export type GetMyGoodchopGrossOdlJobsSuspenseQueryHookResult = ReturnType<typeof useGetMyGoodchopGrossOdlJobsSuspenseQuery>;
export type GetMyGoodchopGrossOdlJobsQueryResult = Apollo.QueryResult<GetMyGoodchopGrossOdlJobsQuery, GetMyGoodchopGrossOdlJobsQueryVariables>;
export const GetMyGoodchopGrossOdlJobPlansDocument = gql`
    query GetMyGoodchopGrossOdlJobPlans {
  getMyGoodchopGrossOdlJobPlans {
    jobPlanId
    jobPlan {
      step
      jobName
      dagsterJobName
    }
  }
}
    `;

/**
 * __useGetMyGoodchopGrossOdlJobPlansQuery__
 *
 * To run a query within a React component, call `useGetMyGoodchopGrossOdlJobPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyGoodchopGrossOdlJobPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyGoodchopGrossOdlJobPlansQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyGoodchopGrossOdlJobPlansQuery(baseOptions?: Apollo.QueryHookOptions<GetMyGoodchopGrossOdlJobPlansQuery, GetMyGoodchopGrossOdlJobPlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyGoodchopGrossOdlJobPlansQuery, GetMyGoodchopGrossOdlJobPlansQueryVariables>(GetMyGoodchopGrossOdlJobPlansDocument, options);
      }
export function useGetMyGoodchopGrossOdlJobPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyGoodchopGrossOdlJobPlansQuery, GetMyGoodchopGrossOdlJobPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyGoodchopGrossOdlJobPlansQuery, GetMyGoodchopGrossOdlJobPlansQueryVariables>(GetMyGoodchopGrossOdlJobPlansDocument, options);
        }
export function useGetMyGoodchopGrossOdlJobPlansSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyGoodchopGrossOdlJobPlansQuery, GetMyGoodchopGrossOdlJobPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyGoodchopGrossOdlJobPlansQuery, GetMyGoodchopGrossOdlJobPlansQueryVariables>(GetMyGoodchopGrossOdlJobPlansDocument, options);
        }
export type GetMyGoodchopGrossOdlJobPlansQueryHookResult = ReturnType<typeof useGetMyGoodchopGrossOdlJobPlansQuery>;
export type GetMyGoodchopGrossOdlJobPlansLazyQueryHookResult = ReturnType<typeof useGetMyGoodchopGrossOdlJobPlansLazyQuery>;
export type GetMyGoodchopGrossOdlJobPlansSuspenseQueryHookResult = ReturnType<typeof useGetMyGoodchopGrossOdlJobPlansSuspenseQuery>;
export type GetMyGoodchopGrossOdlJobPlansQueryResult = Apollo.QueryResult<GetMyGoodchopGrossOdlJobPlansQuery, GetMyGoodchopGrossOdlJobPlansQueryVariables>;
export const GetMyGoodchopGrossOdlSingleJobDocument = gql`
    query GetMyGoodchopGrossOdlSingleJob($runId: String!, $dagsterRunId: String) {
  getMyGoodchopGrossOdlSingleJob(runId: $runId, dagsterRunId: $dagsterRunId) {
    runId
    job
    jobPlanId
    jobName
    step
    status
    fileName
    dagsterRunId
    dateCreated
    dateUpdated
    error
  }
}
    `;

/**
 * __useGetMyGoodchopGrossOdlSingleJobQuery__
 *
 * To run a query within a React component, call `useGetMyGoodchopGrossOdlSingleJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyGoodchopGrossOdlSingleJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyGoodchopGrossOdlSingleJobQuery({
 *   variables: {
 *      runId: // value for 'runId'
 *      dagsterRunId: // value for 'dagsterRunId'
 *   },
 * });
 */
export function useGetMyGoodchopGrossOdlSingleJobQuery(baseOptions: Apollo.QueryHookOptions<GetMyGoodchopGrossOdlSingleJobQuery, GetMyGoodchopGrossOdlSingleJobQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyGoodchopGrossOdlSingleJobQuery, GetMyGoodchopGrossOdlSingleJobQueryVariables>(GetMyGoodchopGrossOdlSingleJobDocument, options);
      }
export function useGetMyGoodchopGrossOdlSingleJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyGoodchopGrossOdlSingleJobQuery, GetMyGoodchopGrossOdlSingleJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyGoodchopGrossOdlSingleJobQuery, GetMyGoodchopGrossOdlSingleJobQueryVariables>(GetMyGoodchopGrossOdlSingleJobDocument, options);
        }
export function useGetMyGoodchopGrossOdlSingleJobSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyGoodchopGrossOdlSingleJobQuery, GetMyGoodchopGrossOdlSingleJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyGoodchopGrossOdlSingleJobQuery, GetMyGoodchopGrossOdlSingleJobQueryVariables>(GetMyGoodchopGrossOdlSingleJobDocument, options);
        }
export type GetMyGoodchopGrossOdlSingleJobQueryHookResult = ReturnType<typeof useGetMyGoodchopGrossOdlSingleJobQuery>;
export type GetMyGoodchopGrossOdlSingleJobLazyQueryHookResult = ReturnType<typeof useGetMyGoodchopGrossOdlSingleJobLazyQuery>;
export type GetMyGoodchopGrossOdlSingleJobSuspenseQueryHookResult = ReturnType<typeof useGetMyGoodchopGrossOdlSingleJobSuspenseQuery>;
export type GetMyGoodchopGrossOdlSingleJobQueryResult = Apollo.QueryResult<GetMyGoodchopGrossOdlSingleJobQuery, GetMyGoodchopGrossOdlSingleJobQueryVariables>;
export const GetMyGoodchopGrossOdlSingleJobPlanDocument = gql`
    query GetMyGoodchopGrossOdlSingleJobPlan($jobPlanId: String!) {
  getMyGoodchopGrossOdlSingleJobPlan(jobPlanId: $jobPlanId) {
    jobPlanId
    jobPlan {
      step
      jobName
    }
  }
}
    `;

/**
 * __useGetMyGoodchopGrossOdlSingleJobPlanQuery__
 *
 * To run a query within a React component, call `useGetMyGoodchopGrossOdlSingleJobPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyGoodchopGrossOdlSingleJobPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyGoodchopGrossOdlSingleJobPlanQuery({
 *   variables: {
 *      jobPlanId: // value for 'jobPlanId'
 *   },
 * });
 */
export function useGetMyGoodchopGrossOdlSingleJobPlanQuery(baseOptions: Apollo.QueryHookOptions<GetMyGoodchopGrossOdlSingleJobPlanQuery, GetMyGoodchopGrossOdlSingleJobPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyGoodchopGrossOdlSingleJobPlanQuery, GetMyGoodchopGrossOdlSingleJobPlanQueryVariables>(GetMyGoodchopGrossOdlSingleJobPlanDocument, options);
      }
export function useGetMyGoodchopGrossOdlSingleJobPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyGoodchopGrossOdlSingleJobPlanQuery, GetMyGoodchopGrossOdlSingleJobPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyGoodchopGrossOdlSingleJobPlanQuery, GetMyGoodchopGrossOdlSingleJobPlanQueryVariables>(GetMyGoodchopGrossOdlSingleJobPlanDocument, options);
        }
export function useGetMyGoodchopGrossOdlSingleJobPlanSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyGoodchopGrossOdlSingleJobPlanQuery, GetMyGoodchopGrossOdlSingleJobPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyGoodchopGrossOdlSingleJobPlanQuery, GetMyGoodchopGrossOdlSingleJobPlanQueryVariables>(GetMyGoodchopGrossOdlSingleJobPlanDocument, options);
        }
export type GetMyGoodchopGrossOdlSingleJobPlanQueryHookResult = ReturnType<typeof useGetMyGoodchopGrossOdlSingleJobPlanQuery>;
export type GetMyGoodchopGrossOdlSingleJobPlanLazyQueryHookResult = ReturnType<typeof useGetMyGoodchopGrossOdlSingleJobPlanLazyQuery>;
export type GetMyGoodchopGrossOdlSingleJobPlanSuspenseQueryHookResult = ReturnType<typeof useGetMyGoodchopGrossOdlSingleJobPlanSuspenseQuery>;
export type GetMyGoodchopGrossOdlSingleJobPlanQueryResult = Apollo.QueryResult<GetMyGoodchopGrossOdlSingleJobPlanQuery, GetMyGoodchopGrossOdlSingleJobPlanQueryVariables>;
export const ReplaceMyEnginePresetDocument = gql`
    mutation ReplaceMyEnginePreset($enginePreset: ReplaceEnginePresetInput!) {
  replaceMyEnginePreset(enginePreset: $enginePreset) {
    id
    name
    description
    orderToDeliveryDaysOffset
    weightingMethod
    orderSimulationEndDate
    historicalDatePatterns
    weightingWindowDays
    bindToSKUOverrides
    bindToForecastUpload
    modifyExistingPos
    dyeYieldLoss
    sewYieldLoss
    cutYieldLoss
    weeksOfSupply
    useBufferForecast
    desiredMinWeeksOnHand
    leadTimeInWeeks
    assumedCustomerGrowth
    excludeForecast
    excludeYieldPlan
    truckOrderToPackDays
    onHoldToAvailableDays
    productionStartToEndDays
    darkRoastRuntime
    mediumRoastRuntime
    lightRoastRuntime
    defaultChangeoverTime
    decafChangeoverTime
    turnOnProductionBatching
    organicMillingNextProductionRun
    cnpNextProductionRun
    taraNextProductionRun
    auroraNextProductionRun
    firmWindowLookAhead
    trendLookbackWindow
    default
  }
}
    `;
export type ReplaceMyEnginePresetMutationFn = Apollo.MutationFunction<ReplaceMyEnginePresetMutation, ReplaceMyEnginePresetMutationVariables>;

/**
 * __useReplaceMyEnginePresetMutation__
 *
 * To run a mutation, you first call `useReplaceMyEnginePresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceMyEnginePresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceMyEnginePresetMutation, { data, loading, error }] = useReplaceMyEnginePresetMutation({
 *   variables: {
 *      enginePreset: // value for 'enginePreset'
 *   },
 * });
 */
export function useReplaceMyEnginePresetMutation(baseOptions?: Apollo.MutationHookOptions<ReplaceMyEnginePresetMutation, ReplaceMyEnginePresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplaceMyEnginePresetMutation, ReplaceMyEnginePresetMutationVariables>(ReplaceMyEnginePresetDocument, options);
      }
export type ReplaceMyEnginePresetMutationHookResult = ReturnType<typeof useReplaceMyEnginePresetMutation>;
export type ReplaceMyEnginePresetMutationResult = Apollo.MutationResult<ReplaceMyEnginePresetMutation>;
export type ReplaceMyEnginePresetMutationOptions = Apollo.BaseMutationOptions<ReplaceMyEnginePresetMutation, ReplaceMyEnginePresetMutationVariables>;
export const ReplacePowerBiDocument = gql`
    mutation ReplacePowerBi($powerBi: ReplacePowerBiInput!) {
  replacePowerBi(powerBi: $powerBi) {
    id
    powerBi {
      id
      name
      workspaceId
      datasetId
    }
  }
}
    `;
export type ReplacePowerBiMutationFn = Apollo.MutationFunction<ReplacePowerBiMutation, ReplacePowerBiMutationVariables>;

/**
 * __useReplacePowerBiMutation__
 *
 * To run a mutation, you first call `useReplacePowerBiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplacePowerBiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replacePowerBiMutation, { data, loading, error }] = useReplacePowerBiMutation({
 *   variables: {
 *      powerBi: // value for 'powerBi'
 *   },
 * });
 */
export function useReplacePowerBiMutation(baseOptions?: Apollo.MutationHookOptions<ReplacePowerBiMutation, ReplacePowerBiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplacePowerBiMutation, ReplacePowerBiMutationVariables>(ReplacePowerBiDocument, options);
      }
export type ReplacePowerBiMutationHookResult = ReturnType<typeof useReplacePowerBiMutation>;
export type ReplacePowerBiMutationResult = Apollo.MutationResult<ReplacePowerBiMutation>;
export type ReplacePowerBiMutationOptions = Apollo.BaseMutationOptions<ReplacePowerBiMutation, ReplacePowerBiMutationVariables>;
export const RerunMyOrchestratorStepDocument = gql`
    mutation RerunMyOrchestratorStep($runSettings: OrchestratorRunSettingsInput!, $stepId: String!) {
  rerunMyOrchestratorStep(runSettings: $runSettings, stepId: $stepId)
}
    `;
export type RerunMyOrchestratorStepMutationFn = Apollo.MutationFunction<RerunMyOrchestratorStepMutation, RerunMyOrchestratorStepMutationVariables>;

/**
 * __useRerunMyOrchestratorStepMutation__
 *
 * To run a mutation, you first call `useRerunMyOrchestratorStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRerunMyOrchestratorStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rerunMyOrchestratorStepMutation, { data, loading, error }] = useRerunMyOrchestratorStepMutation({
 *   variables: {
 *      runSettings: // value for 'runSettings'
 *      stepId: // value for 'stepId'
 *   },
 * });
 */
export function useRerunMyOrchestratorStepMutation(baseOptions?: Apollo.MutationHookOptions<RerunMyOrchestratorStepMutation, RerunMyOrchestratorStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RerunMyOrchestratorStepMutation, RerunMyOrchestratorStepMutationVariables>(RerunMyOrchestratorStepDocument, options);
      }
export type RerunMyOrchestratorStepMutationHookResult = ReturnType<typeof useRerunMyOrchestratorStepMutation>;
export type RerunMyOrchestratorStepMutationResult = Apollo.MutationResult<RerunMyOrchestratorStepMutation>;
export type RerunMyOrchestratorStepMutationOptions = Apollo.BaseMutationOptions<RerunMyOrchestratorStepMutation, RerunMyOrchestratorStepMutationVariables>;
export const RetryMyOrchestratorRunDocument = gql`
    mutation RetryMyOrchestratorRun($runSettings: OrchestratorRunInput!) {
  retryMyOrchestratorRun(runSettings: $runSettings)
}
    `;
export type RetryMyOrchestratorRunMutationFn = Apollo.MutationFunction<RetryMyOrchestratorRunMutation, RetryMyOrchestratorRunMutationVariables>;

/**
 * __useRetryMyOrchestratorRunMutation__
 *
 * To run a mutation, you first call `useRetryMyOrchestratorRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryMyOrchestratorRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryMyOrchestratorRunMutation, { data, loading, error }] = useRetryMyOrchestratorRunMutation({
 *   variables: {
 *      runSettings: // value for 'runSettings'
 *   },
 * });
 */
export function useRetryMyOrchestratorRunMutation(baseOptions?: Apollo.MutationHookOptions<RetryMyOrchestratorRunMutation, RetryMyOrchestratorRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryMyOrchestratorRunMutation, RetryMyOrchestratorRunMutationVariables>(RetryMyOrchestratorRunDocument, options);
      }
export type RetryMyOrchestratorRunMutationHookResult = ReturnType<typeof useRetryMyOrchestratorRunMutation>;
export type RetryMyOrchestratorRunMutationResult = Apollo.MutationResult<RetryMyOrchestratorRunMutation>;
export type RetryMyOrchestratorRunMutationOptions = Apollo.BaseMutationOptions<RetryMyOrchestratorRunMutation, RetryMyOrchestratorRunMutationVariables>;
export const SetMyLocationDocument = gql`
    mutation SetMyLocation($location: LocationInput!) {
  setMyLocation(location: $location) {
    id
    address
    address_override
    email
  }
}
    `;
export type SetMyLocationMutationFn = Apollo.MutationFunction<SetMyLocationMutation, SetMyLocationMutationVariables>;

/**
 * __useSetMyLocationMutation__
 *
 * To run a mutation, you first call `useSetMyLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMyLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMyLocationMutation, { data, loading, error }] = useSetMyLocationMutation({
 *   variables: {
 *      location: // value for 'location'
 *   },
 * });
 */
export function useSetMyLocationMutation(baseOptions?: Apollo.MutationHookOptions<SetMyLocationMutation, SetMyLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMyLocationMutation, SetMyLocationMutationVariables>(SetMyLocationDocument, options);
      }
export type SetMyLocationMutationHookResult = ReturnType<typeof useSetMyLocationMutation>;
export type SetMyLocationMutationResult = Apollo.MutationResult<SetMyLocationMutation>;
export type SetMyLocationMutationOptions = Apollo.BaseMutationOptions<SetMyLocationMutation, SetMyLocationMutationVariables>;
export const SetMyLockedEngineRunIdDocument = gql`
    mutation SetMyLockedEngineRunId($engineRunId: Int!) {
  setMyLockedEngineRunId(engineRunId: $engineRunId)
}
    `;
export type SetMyLockedEngineRunIdMutationFn = Apollo.MutationFunction<SetMyLockedEngineRunIdMutation, SetMyLockedEngineRunIdMutationVariables>;

/**
 * __useSetMyLockedEngineRunIdMutation__
 *
 * To run a mutation, you first call `useSetMyLockedEngineRunIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMyLockedEngineRunIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMyLockedEngineRunIdMutation, { data, loading, error }] = useSetMyLockedEngineRunIdMutation({
 *   variables: {
 *      engineRunId: // value for 'engineRunId'
 *   },
 * });
 */
export function useSetMyLockedEngineRunIdMutation(baseOptions?: Apollo.MutationHookOptions<SetMyLockedEngineRunIdMutation, SetMyLockedEngineRunIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMyLockedEngineRunIdMutation, SetMyLockedEngineRunIdMutationVariables>(SetMyLockedEngineRunIdDocument, options);
      }
export type SetMyLockedEngineRunIdMutationHookResult = ReturnType<typeof useSetMyLockedEngineRunIdMutation>;
export type SetMyLockedEngineRunIdMutationResult = Apollo.MutationResult<SetMyLockedEngineRunIdMutation>;
export type SetMyLockedEngineRunIdMutationOptions = Apollo.BaseMutationOptions<SetMyLockedEngineRunIdMutation, SetMyLockedEngineRunIdMutationVariables>;
export const SetMyLogoDocument = gql`
    mutation SetMyLogo($logo: LogoInput!) {
  setMyLogo(logo: $logo) {
    logo_name
    img_b64
  }
}
    `;
export type SetMyLogoMutationFn = Apollo.MutationFunction<SetMyLogoMutation, SetMyLogoMutationVariables>;

/**
 * __useSetMyLogoMutation__
 *
 * To run a mutation, you first call `useSetMyLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMyLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMyLogoMutation, { data, loading, error }] = useSetMyLogoMutation({
 *   variables: {
 *      logo: // value for 'logo'
 *   },
 * });
 */
export function useSetMyLogoMutation(baseOptions?: Apollo.MutationHookOptions<SetMyLogoMutation, SetMyLogoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMyLogoMutation, SetMyLogoMutationVariables>(SetMyLogoDocument, options);
      }
export type SetMyLogoMutationHookResult = ReturnType<typeof useSetMyLogoMutation>;
export type SetMyLogoMutationResult = Apollo.MutationResult<SetMyLogoMutation>;
export type SetMyLogoMutationOptions = Apollo.BaseMutationOptions<SetMyLogoMutation, SetMyLogoMutationVariables>;
export const SetMyOrchestratorRunDescriptionDocument = gql`
    mutation SetMyOrchestratorRunDescription($runSettings: OrchestratorRunSettingsInput!, $description: String!) {
  setMyOrchestratorRunDescription(
    runSettings: $runSettings
    description: $description
  )
}
    `;
export type SetMyOrchestratorRunDescriptionMutationFn = Apollo.MutationFunction<SetMyOrchestratorRunDescriptionMutation, SetMyOrchestratorRunDescriptionMutationVariables>;

/**
 * __useSetMyOrchestratorRunDescriptionMutation__
 *
 * To run a mutation, you first call `useSetMyOrchestratorRunDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMyOrchestratorRunDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMyOrchestratorRunDescriptionMutation, { data, loading, error }] = useSetMyOrchestratorRunDescriptionMutation({
 *   variables: {
 *      runSettings: // value for 'runSettings'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useSetMyOrchestratorRunDescriptionMutation(baseOptions?: Apollo.MutationHookOptions<SetMyOrchestratorRunDescriptionMutation, SetMyOrchestratorRunDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMyOrchestratorRunDescriptionMutation, SetMyOrchestratorRunDescriptionMutationVariables>(SetMyOrchestratorRunDescriptionDocument, options);
      }
export type SetMyOrchestratorRunDescriptionMutationHookResult = ReturnType<typeof useSetMyOrchestratorRunDescriptionMutation>;
export type SetMyOrchestratorRunDescriptionMutationResult = Apollo.MutationResult<SetMyOrchestratorRunDescriptionMutation>;
export type SetMyOrchestratorRunDescriptionMutationOptions = Apollo.BaseMutationOptions<SetMyOrchestratorRunDescriptionMutation, SetMyOrchestratorRunDescriptionMutationVariables>;
export const SetMyOrchestratorRunLockedDocument = gql`
    mutation SetMyOrchestratorRunLocked($runSettings: OrchestratorRunSettingsInput!, $locked: Boolean!) {
  setMyOrchestratorRunLocked(runSettings: $runSettings, locked: $locked)
}
    `;
export type SetMyOrchestratorRunLockedMutationFn = Apollo.MutationFunction<SetMyOrchestratorRunLockedMutation, SetMyOrchestratorRunLockedMutationVariables>;

/**
 * __useSetMyOrchestratorRunLockedMutation__
 *
 * To run a mutation, you first call `useSetMyOrchestratorRunLockedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMyOrchestratorRunLockedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMyOrchestratorRunLockedMutation, { data, loading, error }] = useSetMyOrchestratorRunLockedMutation({
 *   variables: {
 *      runSettings: // value for 'runSettings'
 *      locked: // value for 'locked'
 *   },
 * });
 */
export function useSetMyOrchestratorRunLockedMutation(baseOptions?: Apollo.MutationHookOptions<SetMyOrchestratorRunLockedMutation, SetMyOrchestratorRunLockedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMyOrchestratorRunLockedMutation, SetMyOrchestratorRunLockedMutationVariables>(SetMyOrchestratorRunLockedDocument, options);
      }
export type SetMyOrchestratorRunLockedMutationHookResult = ReturnType<typeof useSetMyOrchestratorRunLockedMutation>;
export type SetMyOrchestratorRunLockedMutationResult = Apollo.MutationResult<SetMyOrchestratorRunLockedMutation>;
export type SetMyOrchestratorRunLockedMutationOptions = Apollo.BaseMutationOptions<SetMyOrchestratorRunLockedMutation, SetMyOrchestratorRunLockedMutationVariables>;
export const SetMyOrchestratorRunNameDocument = gql`
    mutation SetMyOrchestratorRunName($runSettings: OrchestratorRunSettingsInput!, $name: String!) {
  setMyOrchestratorRunName(runSettings: $runSettings, name: $name)
}
    `;
export type SetMyOrchestratorRunNameMutationFn = Apollo.MutationFunction<SetMyOrchestratorRunNameMutation, SetMyOrchestratorRunNameMutationVariables>;

/**
 * __useSetMyOrchestratorRunNameMutation__
 *
 * To run a mutation, you first call `useSetMyOrchestratorRunNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMyOrchestratorRunNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMyOrchestratorRunNameMutation, { data, loading, error }] = useSetMyOrchestratorRunNameMutation({
 *   variables: {
 *      runSettings: // value for 'runSettings'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useSetMyOrchestratorRunNameMutation(baseOptions?: Apollo.MutationHookOptions<SetMyOrchestratorRunNameMutation, SetMyOrchestratorRunNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMyOrchestratorRunNameMutation, SetMyOrchestratorRunNameMutationVariables>(SetMyOrchestratorRunNameDocument, options);
      }
export type SetMyOrchestratorRunNameMutationHookResult = ReturnType<typeof useSetMyOrchestratorRunNameMutation>;
export type SetMyOrchestratorRunNameMutationResult = Apollo.MutationResult<SetMyOrchestratorRunNameMutation>;
export type SetMyOrchestratorRunNameMutationOptions = Apollo.BaseMutationOptions<SetMyOrchestratorRunNameMutation, SetMyOrchestratorRunNameMutationVariables>;
export const SetMyVendorDocument = gql`
    mutation SetMyVendor($vendor: VendorInput!) {
  setMyVendor(vendor: $vendor) {
    id
    address
    address_override
    email
  }
}
    `;
export type SetMyVendorMutationFn = Apollo.MutationFunction<SetMyVendorMutation, SetMyVendorMutationVariables>;

/**
 * __useSetMyVendorMutation__
 *
 * To run a mutation, you first call `useSetMyVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMyVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMyVendorMutation, { data, loading, error }] = useSetMyVendorMutation({
 *   variables: {
 *      vendor: // value for 'vendor'
 *   },
 * });
 */
export function useSetMyVendorMutation(baseOptions?: Apollo.MutationHookOptions<SetMyVendorMutation, SetMyVendorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMyVendorMutation, SetMyVendorMutationVariables>(SetMyVendorDocument, options);
      }
export type SetMyVendorMutationHookResult = ReturnType<typeof useSetMyVendorMutation>;
export type SetMyVendorMutationResult = Apollo.MutationResult<SetMyVendorMutation>;
export type SetMyVendorMutationOptions = Apollo.BaseMutationOptions<SetMyVendorMutation, SetMyVendorMutationVariables>;
export const StartMyGoodchopOdlTaskDocument = gql`
    mutation StartMyGoodchopOdlTask($fileName: String!) {
  startMyGoodchopOdlTask(fileName: $fileName) {
    taskId
  }
}
    `;
export type StartMyGoodchopOdlTaskMutationFn = Apollo.MutationFunction<StartMyGoodchopOdlTaskMutation, StartMyGoodchopOdlTaskMutationVariables>;

/**
 * __useStartMyGoodchopOdlTaskMutation__
 *
 * To run a mutation, you first call `useStartMyGoodchopOdlTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartMyGoodchopOdlTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startMyGoodchopOdlTaskMutation, { data, loading, error }] = useStartMyGoodchopOdlTaskMutation({
 *   variables: {
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useStartMyGoodchopOdlTaskMutation(baseOptions?: Apollo.MutationHookOptions<StartMyGoodchopOdlTaskMutation, StartMyGoodchopOdlTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartMyGoodchopOdlTaskMutation, StartMyGoodchopOdlTaskMutationVariables>(StartMyGoodchopOdlTaskDocument, options);
      }
export type StartMyGoodchopOdlTaskMutationHookResult = ReturnType<typeof useStartMyGoodchopOdlTaskMutation>;
export type StartMyGoodchopOdlTaskMutationResult = Apollo.MutationResult<StartMyGoodchopOdlTaskMutation>;
export type StartMyGoodchopOdlTaskMutationOptions = Apollo.BaseMutationOptions<StartMyGoodchopOdlTaskMutation, StartMyGoodchopOdlTaskMutationVariables>;
export const StartMyOrchestratorRunDocument = gql`
    mutation StartMyOrchestratorRun($runSettings: OrchestratorRunTriggerInput!) {
  startMyOrchestratorRun(runSettings: $runSettings)
}
    `;
export type StartMyOrchestratorRunMutationFn = Apollo.MutationFunction<StartMyOrchestratorRunMutation, StartMyOrchestratorRunMutationVariables>;

/**
 * __useStartMyOrchestratorRunMutation__
 *
 * To run a mutation, you first call `useStartMyOrchestratorRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartMyOrchestratorRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startMyOrchestratorRunMutation, { data, loading, error }] = useStartMyOrchestratorRunMutation({
 *   variables: {
 *      runSettings: // value for 'runSettings'
 *   },
 * });
 */
export function useStartMyOrchestratorRunMutation(baseOptions?: Apollo.MutationHookOptions<StartMyOrchestratorRunMutation, StartMyOrchestratorRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartMyOrchestratorRunMutation, StartMyOrchestratorRunMutationVariables>(StartMyOrchestratorRunDocument, options);
      }
export type StartMyOrchestratorRunMutationHookResult = ReturnType<typeof useStartMyOrchestratorRunMutation>;
export type StartMyOrchestratorRunMutationResult = Apollo.MutationResult<StartMyOrchestratorRunMutation>;
export type StartMyOrchestratorRunMutationOptions = Apollo.BaseMutationOptions<StartMyOrchestratorRunMutation, StartMyOrchestratorRunMutationVariables>;
export const StoreMyPurchaseOrderEditDocument = gql`
    mutation StoreMyPurchaseOrderEdit($edit: PurchaseOrderEditInput!) {
  storeMyPurchaseOrderEdit(edit: $edit)
}
    `;
export type StoreMyPurchaseOrderEditMutationFn = Apollo.MutationFunction<StoreMyPurchaseOrderEditMutation, StoreMyPurchaseOrderEditMutationVariables>;

/**
 * __useStoreMyPurchaseOrderEditMutation__
 *
 * To run a mutation, you first call `useStoreMyPurchaseOrderEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreMyPurchaseOrderEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeMyPurchaseOrderEditMutation, { data, loading, error }] = useStoreMyPurchaseOrderEditMutation({
 *   variables: {
 *      edit: // value for 'edit'
 *   },
 * });
 */
export function useStoreMyPurchaseOrderEditMutation(baseOptions?: Apollo.MutationHookOptions<StoreMyPurchaseOrderEditMutation, StoreMyPurchaseOrderEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StoreMyPurchaseOrderEditMutation, StoreMyPurchaseOrderEditMutationVariables>(StoreMyPurchaseOrderEditDocument, options);
      }
export type StoreMyPurchaseOrderEditMutationHookResult = ReturnType<typeof useStoreMyPurchaseOrderEditMutation>;
export type StoreMyPurchaseOrderEditMutationResult = Apollo.MutationResult<StoreMyPurchaseOrderEditMutation>;
export type StoreMyPurchaseOrderEditMutationOptions = Apollo.BaseMutationOptions<StoreMyPurchaseOrderEditMutation, StoreMyPurchaseOrderEditMutationVariables>;
export const StoreMyPurchaseOrderEditWithSkusDocument = gql`
    mutation StoreMyPurchaseOrderEditWithSkus($edit: PurchaseOrderEditSkusInput!) {
  storeMyPurchaseOrderEditWithSkus(edit: $edit)
}
    `;
export type StoreMyPurchaseOrderEditWithSkusMutationFn = Apollo.MutationFunction<StoreMyPurchaseOrderEditWithSkusMutation, StoreMyPurchaseOrderEditWithSkusMutationVariables>;

/**
 * __useStoreMyPurchaseOrderEditWithSkusMutation__
 *
 * To run a mutation, you first call `useStoreMyPurchaseOrderEditWithSkusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreMyPurchaseOrderEditWithSkusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeMyPurchaseOrderEditWithSkusMutation, { data, loading, error }] = useStoreMyPurchaseOrderEditWithSkusMutation({
 *   variables: {
 *      edit: // value for 'edit'
 *   },
 * });
 */
export function useStoreMyPurchaseOrderEditWithSkusMutation(baseOptions?: Apollo.MutationHookOptions<StoreMyPurchaseOrderEditWithSkusMutation, StoreMyPurchaseOrderEditWithSkusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StoreMyPurchaseOrderEditWithSkusMutation, StoreMyPurchaseOrderEditWithSkusMutationVariables>(StoreMyPurchaseOrderEditWithSkusDocument, options);
      }
export type StoreMyPurchaseOrderEditWithSkusMutationHookResult = ReturnType<typeof useStoreMyPurchaseOrderEditWithSkusMutation>;
export type StoreMyPurchaseOrderEditWithSkusMutationResult = Apollo.MutationResult<StoreMyPurchaseOrderEditWithSkusMutation>;
export type StoreMyPurchaseOrderEditWithSkusMutationOptions = Apollo.BaseMutationOptions<StoreMyPurchaseOrderEditWithSkusMutation, StoreMyPurchaseOrderEditWithSkusMutationVariables>;
export const StoreMyPurchaseOrderSkuEditDocument = gql`
    mutation StoreMyPurchaseOrderSkuEdit($edit: PurchaseOrderSkuEditInput!) {
  storeMyPurchaseOrderSkuEdit(edit: $edit)
}
    `;
export type StoreMyPurchaseOrderSkuEditMutationFn = Apollo.MutationFunction<StoreMyPurchaseOrderSkuEditMutation, StoreMyPurchaseOrderSkuEditMutationVariables>;

/**
 * __useStoreMyPurchaseOrderSkuEditMutation__
 *
 * To run a mutation, you first call `useStoreMyPurchaseOrderSkuEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreMyPurchaseOrderSkuEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeMyPurchaseOrderSkuEditMutation, { data, loading, error }] = useStoreMyPurchaseOrderSkuEditMutation({
 *   variables: {
 *      edit: // value for 'edit'
 *   },
 * });
 */
export function useStoreMyPurchaseOrderSkuEditMutation(baseOptions?: Apollo.MutationHookOptions<StoreMyPurchaseOrderSkuEditMutation, StoreMyPurchaseOrderSkuEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StoreMyPurchaseOrderSkuEditMutation, StoreMyPurchaseOrderSkuEditMutationVariables>(StoreMyPurchaseOrderSkuEditDocument, options);
      }
export type StoreMyPurchaseOrderSkuEditMutationHookResult = ReturnType<typeof useStoreMyPurchaseOrderSkuEditMutation>;
export type StoreMyPurchaseOrderSkuEditMutationResult = Apollo.MutationResult<StoreMyPurchaseOrderSkuEditMutation>;
export type StoreMyPurchaseOrderSkuEditMutationOptions = Apollo.BaseMutationOptions<StoreMyPurchaseOrderSkuEditMutation, StoreMyPurchaseOrderSkuEditMutationVariables>;
export const StoreMyPurchaseOrderSnoozeAndStatusDocument = gql`
    mutation StoreMyPurchaseOrderSnoozeAndStatus($edit: PurchaseOrderSkuSnoozeAndStatus!) {
  storeMyPurchaseOrderSnoozeAndStatus(edit: $edit)
}
    `;
export type StoreMyPurchaseOrderSnoozeAndStatusMutationFn = Apollo.MutationFunction<StoreMyPurchaseOrderSnoozeAndStatusMutation, StoreMyPurchaseOrderSnoozeAndStatusMutationVariables>;

/**
 * __useStoreMyPurchaseOrderSnoozeAndStatusMutation__
 *
 * To run a mutation, you first call `useStoreMyPurchaseOrderSnoozeAndStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreMyPurchaseOrderSnoozeAndStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeMyPurchaseOrderSnoozeAndStatusMutation, { data, loading, error }] = useStoreMyPurchaseOrderSnoozeAndStatusMutation({
 *   variables: {
 *      edit: // value for 'edit'
 *   },
 * });
 */
export function useStoreMyPurchaseOrderSnoozeAndStatusMutation(baseOptions?: Apollo.MutationHookOptions<StoreMyPurchaseOrderSnoozeAndStatusMutation, StoreMyPurchaseOrderSnoozeAndStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StoreMyPurchaseOrderSnoozeAndStatusMutation, StoreMyPurchaseOrderSnoozeAndStatusMutationVariables>(StoreMyPurchaseOrderSnoozeAndStatusDocument, options);
      }
export type StoreMyPurchaseOrderSnoozeAndStatusMutationHookResult = ReturnType<typeof useStoreMyPurchaseOrderSnoozeAndStatusMutation>;
export type StoreMyPurchaseOrderSnoozeAndStatusMutationResult = Apollo.MutationResult<StoreMyPurchaseOrderSnoozeAndStatusMutation>;
export type StoreMyPurchaseOrderSnoozeAndStatusMutationOptions = Apollo.BaseMutationOptions<StoreMyPurchaseOrderSnoozeAndStatusMutation, StoreMyPurchaseOrderSnoozeAndStatusMutationVariables>;
export const TriggerMyOrchestratorRunNextStepsDocument = gql`
    mutation TriggerMyOrchestratorRunNextSteps($runSettings: OrchestratorRunInput!) {
  triggerMyOrchestratorRunNextSteps(runSettings: $runSettings)
}
    `;
export type TriggerMyOrchestratorRunNextStepsMutationFn = Apollo.MutationFunction<TriggerMyOrchestratorRunNextStepsMutation, TriggerMyOrchestratorRunNextStepsMutationVariables>;

/**
 * __useTriggerMyOrchestratorRunNextStepsMutation__
 *
 * To run a mutation, you first call `useTriggerMyOrchestratorRunNextStepsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerMyOrchestratorRunNextStepsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerMyOrchestratorRunNextStepsMutation, { data, loading, error }] = useTriggerMyOrchestratorRunNextStepsMutation({
 *   variables: {
 *      runSettings: // value for 'runSettings'
 *   },
 * });
 */
export function useTriggerMyOrchestratorRunNextStepsMutation(baseOptions?: Apollo.MutationHookOptions<TriggerMyOrchestratorRunNextStepsMutation, TriggerMyOrchestratorRunNextStepsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerMyOrchestratorRunNextStepsMutation, TriggerMyOrchestratorRunNextStepsMutationVariables>(TriggerMyOrchestratorRunNextStepsDocument, options);
      }
export type TriggerMyOrchestratorRunNextStepsMutationHookResult = ReturnType<typeof useTriggerMyOrchestratorRunNextStepsMutation>;
export type TriggerMyOrchestratorRunNextStepsMutationResult = Apollo.MutationResult<TriggerMyOrchestratorRunNextStepsMutation>;
export type TriggerMyOrchestratorRunNextStepsMutationOptions = Apollo.BaseMutationOptions<TriggerMyOrchestratorRunNextStepsMutation, TriggerMyOrchestratorRunNextStepsMutationVariables>;
export const TriggerMyorchestratorStartTheEngineScriptsDocument = gql`
    mutation TriggerMyorchestratorStartTheEngineScripts($loadDemandOfRunId: String, $variablesId: String) {
  triggerMyorchestratorStartTheEngineScripts(
    loadDemandOfRunId: $loadDemandOfRunId
    variablesId: $variablesId
  )
}
    `;
export type TriggerMyorchestratorStartTheEngineScriptsMutationFn = Apollo.MutationFunction<TriggerMyorchestratorStartTheEngineScriptsMutation, TriggerMyorchestratorStartTheEngineScriptsMutationVariables>;

/**
 * __useTriggerMyorchestratorStartTheEngineScriptsMutation__
 *
 * To run a mutation, you first call `useTriggerMyorchestratorStartTheEngineScriptsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerMyorchestratorStartTheEngineScriptsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerMyorchestratorStartTheEngineScriptsMutation, { data, loading, error }] = useTriggerMyorchestratorStartTheEngineScriptsMutation({
 *   variables: {
 *      loadDemandOfRunId: // value for 'loadDemandOfRunId'
 *      variablesId: // value for 'variablesId'
 *   },
 * });
 */
export function useTriggerMyorchestratorStartTheEngineScriptsMutation(baseOptions?: Apollo.MutationHookOptions<TriggerMyorchestratorStartTheEngineScriptsMutation, TriggerMyorchestratorStartTheEngineScriptsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerMyorchestratorStartTheEngineScriptsMutation, TriggerMyorchestratorStartTheEngineScriptsMutationVariables>(TriggerMyorchestratorStartTheEngineScriptsDocument, options);
      }
export type TriggerMyorchestratorStartTheEngineScriptsMutationHookResult = ReturnType<typeof useTriggerMyorchestratorStartTheEngineScriptsMutation>;
export type TriggerMyorchestratorStartTheEngineScriptsMutationResult = Apollo.MutationResult<TriggerMyorchestratorStartTheEngineScriptsMutation>;
export type TriggerMyorchestratorStartTheEngineScriptsMutationOptions = Apollo.BaseMutationOptions<TriggerMyorchestratorStartTheEngineScriptsMutation, TriggerMyorchestratorStartTheEngineScriptsMutationVariables>;
export const UpdateMyRunDocument = gql`
    mutation UpdateMyRun($run: UpdateMyRunInput!) {
  updateMyRun(run: $run) {
    id
    email
    name
    description
    status
    createdAt
    updatedAt
  }
}
    `;
export type UpdateMyRunMutationFn = Apollo.MutationFunction<UpdateMyRunMutation, UpdateMyRunMutationVariables>;

/**
 * __useUpdateMyRunMutation__
 *
 * To run a mutation, you first call `useUpdateMyRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyRunMutation, { data, loading, error }] = useUpdateMyRunMutation({
 *   variables: {
 *      run: // value for 'run'
 *   },
 * });
 */
export function useUpdateMyRunMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMyRunMutation, UpdateMyRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMyRunMutation, UpdateMyRunMutationVariables>(UpdateMyRunDocument, options);
      }
export type UpdateMyRunMutationHookResult = ReturnType<typeof useUpdateMyRunMutation>;
export type UpdateMyRunMutationResult = Apollo.MutationResult<UpdateMyRunMutation>;
export type UpdateMyRunMutationOptions = Apollo.BaseMutationOptions<UpdateMyRunMutation, UpdateMyRunMutationVariables>;
export const WhoAmIDocument = gql`
    query WhoAmI {
  whoAmI {
    id
    name
    email
    picture
    phoneNumber
    role
    customerId
  }
}
    `;

/**
 * __useWhoAmIQuery__
 *
 * To run a query within a React component, call `useWhoAmIQuery` and pass it any options that fit your needs.
 * When your component renders, `useWhoAmIQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWhoAmIQuery({
 *   variables: {
 *   },
 * });
 */
export function useWhoAmIQuery(baseOptions?: Apollo.QueryHookOptions<WhoAmIQuery, WhoAmIQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WhoAmIQuery, WhoAmIQueryVariables>(WhoAmIDocument, options);
      }
export function useWhoAmILazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WhoAmIQuery, WhoAmIQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WhoAmIQuery, WhoAmIQueryVariables>(WhoAmIDocument, options);
        }
export function useWhoAmISuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WhoAmIQuery, WhoAmIQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WhoAmIQuery, WhoAmIQueryVariables>(WhoAmIDocument, options);
        }
export type WhoAmIQueryHookResult = ReturnType<typeof useWhoAmIQuery>;
export type WhoAmILazyQueryHookResult = ReturnType<typeof useWhoAmILazyQuery>;
export type WhoAmISuspenseQueryHookResult = ReturnType<typeof useWhoAmISuspenseQuery>;
export type WhoAmIQueryResult = Apollo.QueryResult<WhoAmIQuery, WhoAmIQueryVariables>;
export const WorkflowTriggerDocument = gql`
    mutation WorkflowTrigger($engineVariables: WorkflowTriggerEngineVariables) {
  workflowTrigger(engineVariables: $engineVariables)
}
    `;
export type WorkflowTriggerMutationFn = Apollo.MutationFunction<WorkflowTriggerMutation, WorkflowTriggerMutationVariables>;

/**
 * __useWorkflowTriggerMutation__
 *
 * To run a mutation, you first call `useWorkflowTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWorkflowTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [workflowTriggerMutation, { data, loading, error }] = useWorkflowTriggerMutation({
 *   variables: {
 *      engineVariables: // value for 'engineVariables'
 *   },
 * });
 */
export function useWorkflowTriggerMutation(baseOptions?: Apollo.MutationHookOptions<WorkflowTriggerMutation, WorkflowTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WorkflowTriggerMutation, WorkflowTriggerMutationVariables>(WorkflowTriggerDocument, options);
      }
export type WorkflowTriggerMutationHookResult = ReturnType<typeof useWorkflowTriggerMutation>;
export type WorkflowTriggerMutationResult = Apollo.MutationResult<WorkflowTriggerMutation>;
export type WorkflowTriggerMutationOptions = Apollo.BaseMutationOptions<WorkflowTriggerMutation, WorkflowTriggerMutationVariables>;
export const namedOperations = {
  Query: {
    GetAllCustomers: 'GetAllCustomers',
    GetCustomer: 'GetCustomer',
    GetLatestOrchestratorRuns: 'GetLatestOrchestratorRuns',
    GetMyCustomer: 'GetMyCustomer',
    GetMyDemandMonthlyDiffUrl: 'GetMyDemandMonthlyDiffUrl',
    GetMyDemandMonthlyUrl: 'GetMyDemandMonthlyUrl',
    GetMyDemandWeeklyUrl: 'GetMyDemandWeeklyUrl',
    GetMyEnginePresets: 'GetMyEnginePresets',
    GetMyForecastAccuracyUrl: 'GetMyForecastAccuracyUrl',
    GetMyGoodchopOdlTask: 'GetMyGoodchopOdlTask',
    GetMyGoodchopTransformedDataUrls: 'GetMyGoodchopTransformedDataUrls',
    GetMyInventoryOnHandBeansUrls: 'GetMyInventoryOnHandBeansUrls',
    GetMyInventoryOnHandForecastUrls: 'GetMyInventoryOnHandForecastUrls',
    GetMyInventoryOnHandUrls: 'GetMyInventoryOnHandUrls',
    GetMyLockedEngineRunId: 'GetMyLockedEngineRunId',
    GetMyLocations: 'GetMyLocations',
    GetMyLockedDemandOutputRunIds: 'GetMyLockedDemandOutputRunIds',
    GetMyLogo: 'GetMyLogo',
    GetMyOrchestratorRuns: 'GetMyOrchestratorRuns',
    GetMyOrchestratorSteps: 'GetMyOrchestratorSteps',
    GetMyPoEdits: 'GetMyPoEdits',
    GetMyPoSkuEdits: 'GetMyPoSkuEdits',
    GetMyPoWithLatestEditAndSkus: 'GetMyPoWithLatestEditAndSkus',
    GetMyPosWithLatestEdits: 'GetMyPosWithLatestEdits',
    GetMyPowerBiReportItems: 'GetMyPowerBiReportItems',
    GetMyPowerBis: 'GetMyPowerBis',
    GetMyRunComparisonRunIds: 'GetMyRunComparisonRunIds',
    GetMyRunLogs: 'GetMyRunLogs',
    GetMySkuHierarchyUrl: 'GetMySkuHierarchyUrl',
    GetMyUserApprovalsByAnchor: 'GetMyUserApprovalsByAnchor',
    GetMyUserCommentsByAnchor: 'GetMyUserCommentsByAnchor',
    GetMyVendors: 'GetMyVendors',
    HelloWorld: 'HelloWorld',
    GetMyGoodchopGrossOdlJobs: 'GetMyGoodchopGrossOdlJobs',
    GetMyGoodchopGrossOdlJobPlans: 'GetMyGoodchopGrossOdlJobPlans',
    GetMyGoodchopGrossOdlSingleJob: 'GetMyGoodchopGrossOdlSingleJob',
    GetMyGoodchopGrossOdlSingleJobPlan: 'GetMyGoodchopGrossOdlSingleJobPlan',
    WhoAmI: 'WhoAmI'
  },
  Mutation: {
    AddMyUserApproval: 'AddMyUserApproval',
    AddMyUserComment: 'AddMyUserComment',
    CancelMyOrchestratorRun: 'CancelMyOrchestratorRun',
    CreateCustomer: 'CreateCustomer',
    CreateCustomerEmailDomain: 'CreateCustomerEmailDomain',
    CreateMyEnginePreset: 'CreateMyEnginePreset',
    CreateMyGoodchopPresignUploadUrl: 'CreateMyGoodchopPresignUploadUrl',
    createOrReplaceFeatureFlags: 'createOrReplaceFeatureFlags',
    CreatePowerBi: 'CreatePowerBi',
    DeleteCustomerEmailDomain: 'DeleteCustomerEmailDomain',
    GenerateMyPoPdfWithDownloadUrl: 'GenerateMyPoPdfWithDownloadUrl',
    ImportMyPo: 'ImportMyPo',
    MakeMyEnginePresetDefault: 'MakeMyEnginePresetDefault',
    CreateMyGoodchopGrossOdlJobPlan: 'CreateMyGoodchopGrossOdlJobPlan',
    CreateMyGoodchopGrossOdlJob: 'CreateMyGoodchopGrossOdlJob',
    CreateMyGoodchopGrossOdlPresignDownloadUrl: 'CreateMyGoodchopGrossOdlPresignDownloadUrl',
    CreateMyGoodchopGrossOdlPresignUploadUrl: 'CreateMyGoodchopGrossOdlPresignUploadUrl',
    StartMyGoodchopGrossOdlJob: 'StartMyGoodchopGrossOdlJob',
    StartMyGoodchopGrossOdlUploadValidation: 'StartMyGoodchopGrossOdlUploadValidation',
    UpdateMyGoodchopGrossOdlJob: 'UpdateMyGoodchopGrossOdlJob',
    ReplaceMyEnginePreset: 'ReplaceMyEnginePreset',
    ReplacePowerBi: 'ReplacePowerBi',
    RerunMyOrchestratorStep: 'RerunMyOrchestratorStep',
    RetryMyOrchestratorRun: 'RetryMyOrchestratorRun',
    SetMyLocation: 'SetMyLocation',
    SetMyLockedEngineRunId: 'SetMyLockedEngineRunId',
    SetMyLogo: 'SetMyLogo',
    SetMyOrchestratorRunDescription: 'SetMyOrchestratorRunDescription',
    SetMyOrchestratorRunLocked: 'SetMyOrchestratorRunLocked',
    SetMyOrchestratorRunName: 'SetMyOrchestratorRunName',
    SetMyVendor: 'SetMyVendor',
    StartMyGoodchopOdlTask: 'StartMyGoodchopOdlTask',
    StartMyOrchestratorRun: 'StartMyOrchestratorRun',
    StoreMyPurchaseOrderEdit: 'StoreMyPurchaseOrderEdit',
    StoreMyPurchaseOrderEditWithSkus: 'StoreMyPurchaseOrderEditWithSkus',
    StoreMyPurchaseOrderSkuEdit: 'StoreMyPurchaseOrderSkuEdit',
    StoreMyPurchaseOrderSnoozeAndStatus: 'StoreMyPurchaseOrderSnoozeAndStatus',
    TriggerMyOrchestratorRunNextSteps: 'TriggerMyOrchestratorRunNextSteps',
    TriggerMyorchestratorStartTheEngineScripts: 'TriggerMyorchestratorStartTheEngineScripts',
    UpdateMyRun: 'UpdateMyRun',
    WorkflowTrigger: 'WorkflowTrigger'
  }
}